interface StringsType {
    [key: string]: {[key: string]: string}
}

export const Strings: StringsType = {
    tm: {
        app: "Lezzet'Sebeti",
        appStore: "Lezzet'Store",
        appGo: "Lezzet'Go",

        appUpdateVersionTitle: "Programma üpjünçiligi!",
        appUpdateVersionDescription: "Bu programma üpjünçiligi täzelendi, haýyş, iň soňky wersiýa täzeläň!",

        loading: 'ÝÜKLENÝÄR',
        loadMore: 'Has köp ýükle',
        pageNotFound: 'Ýaňlyş: 404 - sahypa tapylmady',
        unknownScreen: 'Näbelli sahypa',
        install: "Lezzet'Sebeti programmasyny gurnamak",

        logo: 'Logo',
        logos: 'Logotipler',

        start: 'Başlatmak',
        startIn: 'Şu ýerden başlat',

        sessions: 'Birikdirilen enjamlar',

        pages: 'Sahypalar',
        viewPages: 'Görkeziljek Sahypalar',
        otherPages: 'Başga Sahypalar',

        shoppingCenters: 'Söwda Nokatlary',
        shoppingCenter: 'Söwda Nokady',

        homePage: 'Baş Sahypa',
        home: 'Baş sahypa',

        adminPanelPage: 'Dolandyryjy-panel Sahypa',
        adminPanel: 'Dolandyryjy-panel',
        panelPage: 'Panel Sahypa',
        panel: 'Panel',

        createRankAbonimentPage: 'Dereje Abunasyny döretmek Sahypa',
        setRankAbonimentPage: 'Dereje Abunasy Sazlamalary Sahypa',
        createRankAboniment: 'Dereje Abunasyny döretmek',
        newRankAboniment: 'Täze Dereje Abunasy',
        rankAbonimentPage: 'Dereje Abunasy Sahypa',
        rankAboniment: 'Dereje Abunasy',
        rankAbonimentStoresPage: 'Dereje Abunasy Dükanlar Sahypa',
        rankAbonimentStores: 'Dereje Abunasy Dükanlar',
        rankAbonimentTitle: 'Iýdikje gazan',
        rankAbonimentTableTitle: 'Iýdikje gazan derejesi',
        
        promotions: 'Aksiýalar',
        promotionAboniment: 'Aksiýa 1+1',

        subscribesStores: 'Abuna ýazylan Dükanlar',

        adminsPage: 'Dolandyryjylar Sahypa',
        createAdminPage: 'Dolandyryjy döretmek Sahypa',
        setAdminPage: 'Dolandyryjy Sazlamalary Sahypa',
        createAdmin: 'Dolandyryjy döretmek',
        setAdmin: 'Dolandyryjy Sazlamalary',
        newAdmin: 'Täze Dolandyryjy',
        admins: 'Dolandyryjylar',
        adminPage: 'Dolandyryjy Sahypa',
        admin: 'Dolandyryjy',
        
        lDeliverysPage: 'Eltip bermek Hyzmaty Sahypa',
        createLDeliveryPage: 'Eltip bermek Hyzmatyny döretmek Sahypa',
        setLDeliveryPage: 'Eltip bermek Hyzmatynyň Sazlamalary Sahypa',
        setLDelivery: 'Eltip bermek Hyzmatynyň Sazlamalary',
        createLDelivery: 'Eltip bermek Hyzmatyny döretmek',
        newLDelivery: 'Täze Eltip bermek Hyzmaty',
        lDeliverys: 'Eltip bermek Hyzmatlary',
        lDeliveryPage: 'Eltip bermek Hyzmaty Sahypa',
        lDelivery: 'Eltip bermek Hyzmaty',
        
        couriersPage: 'Eltip berijiler Sahypa',
        createCourierPage: 'Eltip beriji döretmek Sahypa',
        setCourierPage: 'Eltip berijiniň Sazlamalary Sahypa',
        setCourier: 'Eltip berijiniň Sazlamalary',
        createCourier: 'Eltip beriji döretmek',
        newCourier: 'Täze Eltip beriji',
        couriers: 'Eltip berijiler',
        courierPage: 'Eltip beriji Sahypa',
        courier: 'Eltip beriji',
        courierCartsPage: 'Eltip berijiniň Sargytlary Sahypa',
        courierNotificationsPage: 'Eltip berijiniň Habarlary Sahypa',

        cartPage: 'Sebet Sahypa',
        shopsPage: 'Sargytlar Sahypa',
        shopPage: 'Sargyt Sahypa',
        shop: 'Sargyt',
        setShopPage: 'Sargydyň Sazlamalary Sahypa',
        setShop: 'Sargydyň Sazlamalary',
        storeShops: 'Sargytlar',
        storeNewShops: 'Häzirki Sargytlar',
        courierShops: 'Sargytlar',
        courierNewShops: 'Häzirki Sargytlar',
        profileShops: 'Sargytlar',
        profileNewShops: 'Garaşylýan Sargytlar',
        historyShops: 'Sargytlar taryhy',
        cart: 'Sebet',
        confirmCart: 'Sargydy tassyklamak',
        newCarts: 'Täze Sargytlar',
        confirmedCarts: 'Tassyklanan Sargytlar',
        sentedCarts: 'Ugradylan Sargytlar',
        deliveredCarts: 'Eltip berilen Sargytlar',
        receivedCarts: 'Gowşurylan Sargytlar',
        rejectedCarts: 'Red edilen Sargytlar',

        profilesPage: 'Ulanyjylar Sahypa',
        profiles: 'Ulanyjylar',
        profilePage: 'Ulanyjy Sahypa',
        setProfilePage: 'Ulanyjynyň Sazlamalary Sahypa',
        setProfile: 'Ulanyjynyň Sazlamalary',
        profileDataPage: 'Ulanyjy Maglumatlary Sahypa',
        profileData: 'Ulanyjy Maglumatlary',
        profileDataTrash: 'Ulanyjy Maglumatlaryny Öçürmek',
        profileTrash: 'Ulanyjyny Öçürmek',
        profile: 'Profil',
        profileSet: 'Profili düzetmek',
        profileCartsPage: 'Ulanyjy Sargytlary Sahypa',
        profileNotificationsPage: 'Ulanyjy Habarlary Sahypa',

        addressesPage: 'Salgylar Sahypa',
        addAddressPage: 'Salgy goşmak Sahypa',

        myFavoriteStoresPage: 'Halan Dükanlarym Sahypa',
        myFavoriteProductsPage: 'Halan Harytlarym Sahypa',
        myRatedStoresPage: 'Baha beren Dükanlarym Sahypa',
        recomendedStoresPage: 'Maslahat berilýän Dükanlar Sahypa',

        profileCurrentRatesPage: 'Meniň Bahalarym Sahypa',
        profileCurrentRates: 'Meniň Bahalarym',
        profilePendingRatesPage: 'Garaşylýan Bahalar Sahypa',
        profilePendingRates: 'Garaşylýan Bahalar',

        currentRatesPage: 'Bahalar Sahypa',
        currentRates: 'Bahalar',
        pendingRatesPage: 'Garaşylýan Bahalar Sahypa',
        pendingRates: 'Garaşylýan Bahalar',

        settingsPage: 'Sazlamalar Sahypa',
        settings: 'Sazlamalar',

        discountStoresPage: 'Arzanladyş Dükanlar Sahypa',
        promotionStoresPage: 'Aksiýaly Dükanlar Sahypa',
        lezzetDeliveryStoresPage: "Lezzet'Sebeti tarapyndan Eltip bermek Dükanlar Sahypa",
        rankStoresPage: 'Iýdikje gazan derejeli Dükanlar Sahypa',

        storesPage: 'Dükanlar Sahypa',
        createStorePage: 'Dükan açmak Sahypa',
        setStorePage: 'Dükanyň Sazlamalary Sahypa',
        setStore: 'Dükanyň Sazlamalary',
        createStore: 'Dükan açmak',
        newStore: 'Täze Dükan',
        stores: 'Dükanlar',
        storePage: 'Dükan Sahypa',
        store: 'Dükan',
        storeBannersPage: 'Dükanyň Bannerlary Sahypa',
        storeCreateBannerPage: 'Banner goşmak Sahypa',
        storeProductsPage: 'Dükanyň Harytlary Sahypa',
        storeCreateProductPage: 'Haryt goşmak Sahypa',
        storeCartsPage: 'Dükanyň Sargytlary Sahypa',
        storeNotificationsPage: 'Dükanyň Habarlary Sahypa',
        
        productsPage: 'Harytlar Sahypa',
        addProduct: 'Haryt goşmak',
        addProducts: 'Harytlary goşmak',
        newProduct: 'Täze Haryt',
        newProducts: 'Täze Harytlar',
        products: 'Harytlar',
        productPage: 'Haryt Sahypa',
        setProductPage: 'Harydyň Sazlamalary Sahypa',
        setProduct: 'Harydyň Sazlamalary',
        product: 'Haryt',
        
        bannersPage: 'Bannerlar Sahypa',
        setBannerPage: 'Banner Sazlamalary Sahypa',
        setBanner: 'Banner Sazlamalary',
        addBanner: 'Banner goşmak',
        newBanner: 'Täze Banner',
        banners: 'Bannerlar',
        bannerPage: 'Banner Sahypa',
        banner: 'Banner',

        advertisingsPage: 'Mahabatlar Sahypa',
        addAdvertising: 'Mahabat goşmak',
        newAdvertising: 'Täze Mahabat',
        advertisings: 'Mahabatlar',
        advertisingPage: 'Mahabat Sahypa',
        advertising: 'Mahabat',

        notificationsPage: 'Habarlar Sahypa',
        setNotificationPage: 'Habar Sazlamalary Sahypa',
        addNotification: 'Habar goşmak',
        newNotification: 'Täze Habar',
        notifications: 'Habarlar',
        notificationPage: 'Habar Sahypa',
        notification: 'Habar',
        
        reviews: 'Synlar',

        authorization: 'Ulgama girmek',
        signup: 'Ulgam açmak',
        agree: 'Men ulanyş şertlerini we gizlinlik syýasatyny kabul edýärin',
        
        help: 'Kömek',
        termsOfUse: 'Ulanyş şertleri',
        privacyPolicy: 'Gizlinlik syýasaty',
        aboutUs: 'Biz barada',
        
        informations: 'Bölümler we maglumatlar',
        contacts: 'Kontaktlar',
        
        welcomeBack: 'Salam, Hoş Gördük',
        entrancePage: 'Giriş Sahypa',
        entrance: 'Giriş',
        allTheBest: 'Hoş, Sag Boluň',
        exitPage: 'Çykyş Sahypa',
        exit: 'Çykyş',
        exitIn: 'Çykmak',
        verifyPage: 'Tassyklamak Sahypa',
        resetPage: 'Dikeltmek Sahypa',
        next: 'Dowam et',

        lang: 'Dil',
        changeLang: 'Dili saýlaň',

        theme: 'Tema',
        changeTheme: 'Tema saýlaň',

        system: 'Sistema',
        light: 'Gündiz',
        dark: 'Gije',

        myRates: 'Meniň bahalarym',
        
        discountPub: 'Arzanladyş yglan etmek',

        find: 'Gözleg sözi',
        filter: 'Filter',
        order: 'Ilki bilen',
        news: 'Täzeler',
        olds: 'Köneler',
        topViews: 'Köp görülýänler',
        topPrice: 'Gymmat baha',
        downPrice: 'Arzan baha',
        discountPrice: 'Arzanladyş',
        topRecomended: 'Maslahat berýäris',
        topSelling: 'Köp sargyt edilýänler',
        topDiscount: 'Uly arzanladyş',
        topRates: 'Ýokary reýting',

        locations: 'Welaýatlar',
        markers: 'Şäherler',
        sections: 'Bölümler',
        chapters: 'Baplar',
        categories: 'Kategoriýalar',

        addLocation: 'Welaýat goşmak',
        addMarker: 'Şäher goşmak',
        addSection: 'Bölüm açmak',
        addChapter: 'Bap goşmak',
        addCategory: 'Kategoriýa goşmak',

        newLocation: 'Täze Welaýat',
        newMarker: 'Täze Şäher',
        newSection: 'Täze bölüm',
        newChapter: 'Täze bap',
        newCategory: 'Täze kategoriýa',

        productStore: 'Satyjy',
        storeProductOfProducts: 'Meňzeş Harytlar',
        storeOtherProducts: 'Başgada Harytlar',
        storeProducts: 'Dükanyň Harytlary',
        storeBanners: 'Dükanyň Bannerlary',
        cartProfile: 'Satyn alyjy',
        
        media: 'Media',
        subMedia: 'Media ikinji bölüm',
        main: 'Esasy',
        confidential: 'Şahsy',
        deliveriesAndPayments: 'Eltip bermek we töleg',
        priceAndDiscount: 'Baha, arzanladyşlar we aksiýalar',
        other: 'Başgalar',
        security: 'Howpsuzlyk',
        
        name: 'Ady',
        title: 'Ady',
        subTitle: 'Kiçi ady',
        login: 'Login',
        phone: 'Telefon',
        tel: 'Tel',
        website: 'Web-saýt',
        basicPhone: 'Esasy Telefon',
        additionalPhone: 'Goşmaça Telefon',
        phonePlace: 'Telefon belgi',
        otpPlace: 'SMS kod',
        email: 'E-mail',
        newAddress: 'Täze Salgy',
        addAddress: 'Salgy goşmak',
        myAddresses: 'Meniň Salgylarym',
        addresses: 'Salgylar',
        address: 'Salgy',
        street: 'Köçe',
        house: 'Jaý',
        houseEntrance: 'Girelge',
        houseFloor: 'Gat',
        houseApartment: 'Kwartira',
        location: 'Ýeri',
        marker: 'Ýerleşiş belligi',
        //location: 'Welaýaty',
        //marker: 'Şäheri',
        answer: 'Jogap',
        rateLike: 'Bu teswir Söwda Nokady tarapyndan halandy',
        comment: 'Teswir',
        comments: 'Teswirler',
        cartComment: 'Sargydyň teswiri',
        cartAddressComment: 'Salgynyň teswiri',
        cartCode: 'Sargydyň kody',
        section: 'Bölümi',
        chapter: 'Bapy',
        category: 'Kategoriýa',
        
        regDate: 'Bellige alyndy',
        pubDate: 'Goşulan wagty',
        activeDate: 'Aktiw wagty',
        changeDate: 'Üýtgedilen wagty',
        rejectedDate: 'Red edilen wagty',
        confirmDate: 'Tassyklanan wagty',
        sentDate: 'Ugradylan wagty',
        deliveredDate: 'Gowşurylan wagty',
        
        opened: 'Açyk',
        closed: 'Ýapyk',
        opens: 'Açyklar',
        closes: 'Ýapyklar',

        online: 'Onlaýn',
        offline: 'Oflaýn',

        workDay: 'Iş güni',
        notWorkDay: 'Işlemeýär',
        breakWorkDay: 'Arakesme',
        workDays: 'Iş günleri',
        workTime: 'Iş wagty',
        workStart: 'Başlaýan',
        workEnd: 'Gutarýan',
        
        day1: 'Duşenbe',
        day2: 'Sişenbe',
        day3: 'Çarşenbe',
        day4: 'Penşenbe',
        day5: 'Anna',
        day6: 'Şenbe',
        day7: 'Ýekşenbe',
        
        cartRank: 'Sargydyň Derejesi',
        rateRank: 'Teswiriň Derejesi',
        rank: 'Dereje',
        rank1: 'Başlangyç',
        rank2: 'Bürünç',
        rank3: 'Kümüş',
        rank4: 'Altyn',
        rank5: 'Platina',
        rank6: 'Göwher',
        rank7: 'Meşhur',
        abonimentRank: 'Abuna Derejesi',
        lezzetCoin: 'Lezzet teňňe',
        lezzetCoinPrice: 'Lezzet teňňe bahasy',
        subscribe: 'Ýazylmak',
        unsubscribe: 'Aýrylmak',

        invoice: 'Hasap',
        client: 'Muşderi',
        payments: 'Tölegiň görnüşi',
        payment1: 'Nagt',
        payment2: 'Kart we terminal',
        payment3: 'Onlaýn',
        cash: 'Nagt',
        terminal: 'Kart we terminal',

        delivery: 'Eltip bermek',
        lezzetDeliveryTitle: "Lezzet'Sebeti eltip bermek",
        lezzetDelivery: "Eltip bermek hyzmaty Lezzet'Sebeti tarapyndan",
        storeDelivery: 'Eltip bermek hyzmaty Söwda Nokady tarapyndan',
        deliveryType: 'Eltip bermek usuly',
        deliveryCountry1: 'Şäher içi, Şäher daşy we Welaýat ara',
        deliveryCountry2: 'Şäher içi we Şäher daşy',
        deliveryCountry3: 'Şäher içi',
        deliveryCountry4: 'Özüň baryp almak',
        delivery1: 'Söwda Nokady tarapyndan',
        delivery2: "Lezzet'Sebeti tarapyndan",
        delivery3: 'Özüm baryp aljak',
        inCity: 'Şäher içi',
        outCity: 'Şäher daşy',
        outRegion: 'Welaýat ara',
        price: 'Baha',
        totalPrice: 'Jemi baha',
        addedPrice: 'Goşulan baha',
        valute: 'TMT',
        summ: 'Tölenmeli baha',
        minCartPrice: 'Sargydyň iň pes bahasy',
        
        size: 'Ölçegi',
        sizes: 'Ölçegler',
        
        onsale: 'Satuwda bar',
        notOnsale: 'Satuwda ýok',
        notDelivery: 'Eltip bermek hyzmaty ýok',
        notSelected: 'bellenilmedik',
        notSize: 'ölçegsiz',
        notPrice: 'bahasyz',

        delivered: 'Sargytlar',

        views: 'Görüldi',
        rate: 'Reýting',
        rates: 'Reýtinglar',
        rateUp: 'Baha beriň',
        yourRate: 'Siziň bahaňyz',
        deliveryRate: 'Eltip bermek hyzmatyna baha beriň...',
        serviceRate: 'Hyzmat edilişine we serwizine baha beriň...',
        tasteRate: 'Tagamyna we hiline baha beriň...',
        viewStatus: 'Görnüş statusy',
        period: 'Döwür',
        
        phoneVerifyTitle: 'Tassyklamak',
        phoneVerify: 'Telefon belgiňizi tassyklaň',
        
        forgotPassword: 'Gizlin açaryňyz ýatdan çykdymy',
        forgotPasswordText1: 'E-mail salgyňyzy ýazyň we dowam ediň.',
        forgotPasswordText2: 'Bir gezeklik tassyklama açary (6 sandan ybarat bolan) Söwda Nokadynyň esasy telefon belgisine SMS arkaly ugradyldy.',
        forgotPasswordText3: 'Bir gezeklik tassyklama açary ýazyň we tassyklaň.',
        passwordRecovery: 'Gizlin açary dikeltmek',
        password: 'Gizlin açar',
        currentPassword: 'Häzirki gizlin açar',
        currentPasswordText: 'Häzirki gizlin açary ýazyň',
        newPassword: 'Täze gizlin açar',
        newPasswordText: 'Täze gizlin açary ýazyň',
        passwordRepeat: 'Täze gizlin açary gaýtalaň',
        passwordRepeatErr: 'Ýazan Gizlin açaryňyz gabat gelmeýär',
        passwordUpd: 'Gizlin açary üýtgetmek',
        
        otpText1: 'Telefon belgiňizi ýazyň we dowam ediň.',
        otpText2: 'Bir gezeklik tassyklama açary (6 sandan ybarat bolan) Siziň telefon belgiňize SMS arkaly ugradyldy.',
        otpText3: 'Bir gezeklik tassyklama açary ýazyň we dowam ediň.',
        sendOtpMessage: "Lezzet'Sebeti bir gezeklik giriş gizlin açary",
        
        avatar: 'Avatar',
        passport: 'Passport',
        car: 'Awtoulag',
        image: 'Surat',
        images: 'Suratlar',
        mainImage: 'Esasy surat',
        newImage: 'Täze surat',
        imageI: 'Ýüklenýän faýl gabat gelmeli: Format .jpeg, .jpg, .png, .gif we Ululygy boýunça 5 megabaýtdan uly bolmaly däl.',
        video: 'Video',
        poster: 'Poster surat',
        newVideo: 'Täze video',
        videoI: 'Ýüklenýän faýl gabat gelmeli: Format .mp4 we Ululygy boýunça 20-mi megabaýtdan uly bolmaly däl.',
        excelI: 'Ýüklenýän faýl gabat gelmeli: Format .xlsx, .xls',
        
        cartCommentI: 'Sargydyňyza degişli bolan maglumatlary ýazyň.',
        cartAddressCommentI: 'Eltip bermek hyzmaty üçin, Salgyňyzy söz bilen düşündiriň.',
        cartAdressNotFoundI: 'Eltip bermek hyzmaty üçin, Salgylar tapylmady.',

        trashAbonimentTitle: 'Abunany öçürmek',
        trashAbonimentI: 'Abunany öçürmek islegi derrew amala aşyrylýar, isleg Abunanyň ähli maglumatlaryny öçürer, isleg Dükanlaryň ýazgylaryny öz içine alýar.',

        trashLocationTitle: 'Welaýaty öçürmek',
        trashLocationI: 'Welaýaty öçürmek islegi derrew amala aşyrylýar, isleg Welaýatyň ähli maglumatlaryny öçürer, isleg Şäherleri öz içine alýar.',

        trashMarkerTitle: 'Şäheri öçürmek',
        trashMarkerI: 'Şäheri öçürmek islegi derrew amala aşyrylýar, isleg Şäheriň ähli maglumatlaryny öçürer.',

        trashCategoryTitle: 'Kategoriýany öçürmek',
        trashCategoryI: 'Kategoriýany öçürmek islegi derrew amala aşyrylýar, isleg Kategoriýanyň ähli maglumatlaryny öçürer.',

        trashLezzetDeliveryTitle: 'Eltip bermek hyzmatyny öçürmek',
        trashLezzetDeliveryI: 'Eltip bermek hyzmatyny öçürmek islegi derrew amala aşyrylýar, isleg Eltip bermek hyzmatynyň ähli maglumatlaryny öçürer.',

        trashProfileTitle: 'Akkaunty öçürmek',
        trashProfileI: 'Akkaunty öçürmek islegi derrew amala aşyrylýar, isleg Akkauntyň ähli maglumatlaryny öçürer, isleg Sessiýalary, Salgylary, halanan Dükanlary, Harytlary we Teswirleri öz içine alýar.',

        trashProfileDataTitle: 'Akkauntyň Maglumatlaryny öçürmek',
        trashProfileDataI: 'Akkauntyň Maglumatlaryny öçürmek islegi derrew amala aşyrylýar, isleg Akkaunta degişli bolan ähli maglumatlary öçürer, isleg Sessiýalary, Salgylary, halanan Dükanlary, Harytlary we Teswirleri öz içine alýar.',

        trashAdressTitle: 'Salgyny öçürmek',
        trashAdressI: 'Salgyny öçürmek islegi derrew amala aşyrylýar, isleg Salgynyň ähli maglumatlaryny öçürer.',
        
        trashStoreTitle: 'Dükany öçürmek',
        trashStoreI: 'Dükany öçürmek islegi derrew amala aşyrylýar, isleg Dükanyň ähli maglumatlaryny öçürer, isleg Harytlary we Teswirleri öz içine alýar.',
        
        trashRateTitle: 'Bahany öçürmek',
        trashRateI: 'Bahany öçürmek islegi derrew amala aşyrylýar, isleg Bahanyň ähli maglumatlaryny öçürer.',

        trashProductTitle: 'Harydy öçürmek',
        trashProductI: 'Harydy öçürmek islegi derrew amala aşyrylýar, isleg Harydyň ähli maglumatlaryny öçürer.',
        
        trashCartTitle: 'Sebeti boşatmak',
        trashCartI: 'Sebetde tassyklanmadyk başga Dükandan haryt bar. Täze sargyt etmek üçin, bar bolan sargydy tassyklaň ýa-da sebeti boşadyň.',
        trashCartI2: 'Siz hakykatdanam sebeti boşatmakçymy?',
        
        trashNewCartTitle: 'Sargydy öçürmek',
        trashNewCartI: 'Sargydy öçürmek islegi derrew amala aşyrylýar, isleg Sargydyň ähli maglumatlaryny öçürer.',
        
        notConfirmedCartPushTitle: 'Tassyklanmadyk sargyt',
        notConfirmedCartPushI: 'Sargydyň belgisi',

        newCartPushTitle: 'Täze sargyt geldi',
        newCartPushI: 'Sargydyň belgisi',

        confirmCartTitle: 'Sargydy tassyklamak',
        confirmCartI: 'Siz hakykatdanam şu sargydy tassyklamakçymy?',

        confirmCartPushTitle: 'Sargydyňyz tassyklandy',
        confirmCartPushI: 'Sargydyň belgisi',

        sentCartTitle: 'Sargydy ugratmak',
        sentCartI: 'Siz hakykatdanam şu sargydy eýesine ugratmakçymy?',

        sentCartPushTitle: 'Sargydyňyz ugradyldy',
        sentCartPushI: 'Sargydyň belgisi',

        deliveredCartTitle: 'Sargydy eltip bermek',
        deliveredCartI: 'Siz hakykatdanam şu sargydy eýesine eltip berdiňizmi?',

        courierCartPushTitle: 'Täze sargyt bellendi',
        courierCartPushI: 'Sargydyň belgisi',

        newCourierCartPushTitle: 'Eltip beriji bellendi',
        newCourierCartPushI: 'Sargydyň belgisi',

        rateCartStorePushI: 'Teswiriňizi goýmagy ýatdan çykarmaň',

        rejectCartTitle: 'Sargydy red etmek',
        rejectCartI: 'Siz hakykatdanam şu sargydy red etmekçimi?',

        rejectCartPushTitle: 'Sargydyňyz red edildi',
        rejectCartPushI: 'Sargydyň belgisi',

        trashServiceTitle: 'Hyzmaty öçürmek',
        trashServiceI: 'Hyzmaty öçürmek islegi derrew amala aşyrylýar, isleg Hyzmatyň ähli maglumatlaryny öçürer.',
        
        trashBannerTitle: 'Banneri öçürmek',
        trashBannerI: 'Banneri öçürmek islegi derrew amala aşyrylýar, isleg Banneriň ähli maglumatlaryny öçürer.',
        
        trashAdsTitle: 'Mahabaty öçürmek',
        trashAdsI: 'Mahabaty öçürmek islegi derrew amala aşyrylýar, isleg Mahabatyň ähli maglumatlaryny öçürer.',

        navigations: 'Nawigassiýalar',
        myNavigations: 'Meniň nawigasiýalarym',
        history: 'Görülenler taryhy',
        myFavorites: 'Halanlarym',
        myRatedStores: 'Baha berenlerim',
        favorites: 'Halandy',
        topFavorites: 'Köp halananlar',

        menu: 'Menýu',
        back: 'Yza',
        select: 'Saýlamak',
        choose: 'Saýlaň',
        chooseData: 'Maglumatlary saýlaň',
        show: 'Görkezmek',
        hide: 'Gizlemek',
        all: 'Ählisi',
        send: 'Ugratmak',
        sendPhone: 'Telefon belgiňizi ugradyň',
        add: 'Goşmak',
        addCart: 'Sebede goş',
        create: 'Açmak',
        read: 'Okamak',
        update: 'Täzele',
        reset: 'Täzeden düzmek',
        delete: 'Öçür',
        recycle: 'Boşat',
        remove: 'Aýyr',
        change: 'Üýtget',
        confirm: 'Tassykla',
        confirmPhone: 'Telefon belgiňizi tassyklaň',
        block: 'Blokla',
        deliver: 'Gowşuruldy',
        reject: 'Red et',
        warning: 'Duýduryş',
        info: 'Beýany',
        about: 'Giňişleýin',
        aboutInfo: 'Giňişleýin maglumaty',
        print: 'Çap etmek',

        required: 'Talap edilýär',
        min: 'Azyndan',
        max: 'Köpünden',
        pattern: 'Dogry nyşanlar',
        numbers: 'sanlar',
        strings: 'setirler',
        symbols: 'nyşanlar',

        distance: 'Araçäk',
        year: 'ýyl',
        years: 'ýyl',
        day: 'gün',
        days: 'gün',
        hour: 'sagat',
        hours: 'sagat',
        minut: 'minut',
        minutes: 'minut',
        second: 'sekund',
        seconds: 'sekund',
        kilometr: 'km',
        kilometros: 'km',
        metr: 'metr',
        metros: 'metr',

        powered: 'Açyk',
        ok: 'Howwa',
        not: 'Ýok',
        cancel: 'Beset',

        quantity: 'Jemi',
        count: 'Sany',
        pcs: 'sany',
        from: 'başlangyç',

        privilege: 'Aýratynlyk',
        privilege1: 'Ökde',
        privilege2: 'Orta',
        privilege3: 'Adaty',
        privilege4: 'Kiçi',

        error: 'Ýaňlyş',
        error1: 'Ýaňlyş: Soralýan ugur tapylmady',
        error2: 'Ýeterlik maglumat iberilmedi',
        error3: 'Iberilen maglumatlar nädogry',
        error4: 'Format ýa-da ululyk gabat gelmeýär',
        error5: 'Isleg kanagatlandyrylmady',
        error6: 'Bu Ýerleşiş belligi bilen Eltip bermek hyzmaty bar',

        error100: 'Akkaunt tapylmady',
        error101: 'Akkaunt tassyklanylmadyk',
        error102: 'Akkaunt bloklanan',
        error103: 'Akkaunt ýalňyş ýagdaýda',
        error104: 'Siz Ulgamda däl',
        error105: 'Ulgamda ygtyýarly Akkaunt bar',
        error106: 'Siziň aýratynlyklaryňyz görkezilenlere gabat gelmeýär',
        error107: 'Bu giriş Ady bilen Akkaunt tapylmady',
        error108: 'Bu giriş Ady bilen Akkaunt bar',
        error109: 'Bu telefon belgi bilen Akkaunt tapylmady',
        error110: 'Bu telefon belgi bilen Akkaunt bar',
        error111: 'Bu E-mail salgysy bilen Akkaunt tapylmady',
        error112: 'Bu E-mail salgysy bilen Akkaunt bar',
        error113: 'Nädogry gizlin açar',
        error114: 'Möhleti geçen token',
        error115: 'Nädogry token',
        error116: 'Giriş tapylmady',
        error117: 'Bu Girişi öçürmek mümkinçiligi ýok',
        error118: 'Bir gezeklik giriş açary tapylmady',
        error119: 'Bu Ady, Ýerleşiş belligi we bu telefon belgisi bilen Akkaunt bar',
        error120: 'Ýerleşiş belligini anyklamaga rugsat ýapyk.',
        error121: 'Ýerleşiş belligini anyklap bolmady. Siziň ýerleşiş belligiňizi anyklamak bilen üpjün ediji hyzmatynyň açykdygyna göz ýetiriň.',
        error122: 'Puş-habarnamalaryny almaga rugsat ýapyk.',
        error123: 'Puş-belligini alyp bolmady. Haýyş, fiziki enjam ulanyň.',
        error124: 'Bu telefon belgisi eýýäm esasy telefon belgiňiz hökmünde ulanylýar.',
        error125: 'Bu telefon belgisi häzirki wagtda esasy telefon belgiňiz hökmünde ulanylýar.',
        error126: 'Bu telefon belgisi eýýäm goşmaça telefon belgiňiz hökmünde ulanylýar.',
        error127: 'Bu telefon belgisi häzirki wagtda goşmaça telefon belgiňiz hökmünde ulanylýar.',

        error200: 'Dükan tapylmady',
        error201: 'Dükan tassyklanylmadyk',
        error202: 'Dükan bloklanan',
        error203: 'Dükan ýalňyş ýagdaýda',
        error204: 'Bu Ady, Ýerleşiş belligi, Kategoriýa we bu E-mail salgysy bilen Dükan bar',
        error205: 'Dükan ýapyk',
        error206: 'Dükanyň iş günine garaşylýar',
        error207: 'Dükanyň iş wagtyna garaşylýar',
        error208: 'Eltip bermek hyzmaty çäkli',
        error209: 'Eltip bermek hyzmaty ýok',
        error210: 'Dükanda ygtyýarly Abuna ýazylgysy bar',
        error211: 'Dükanda ygtyýarly Abuna ýazylgysy ýok',
        error212: 'Bu E-mail salgysy bilen Dükan bar',

        error300: 'Haryt tapylmady',
        error301: 'Haryt tassyklanylmadyk',
        error302: 'Haryt bloklanan',
        error303: 'Haryt ýalňyş ýagdaýda',
        error304: 'Bu Ady we bu Kategoriýa bilen Haryt bar',

        error400: 'Hyzmat tapylmady',
        error401: 'Hyzmat tassyklanylmadyk',
        error402: 'Hyzmat bloklanan',
        error403: 'Hyzmat ýalňyş ýagdaýda',
        error404: 'Bu Ady, Ýerleşiş belligi we bu Kategoriýa bilen Hyzmat bar',

        error500: 'Sargyt tapylmady',
        error501: 'Sargyt tassyklanylmadyk',
        error502: 'Sargyt bloklanan',
        error503: 'Sargyt ýalňyş ýagdaýda',
        error504: 'Salgy ýalňyş ýa-da Salgy eltip bermek hyzmatynyň çägine girmeýär',
        error505: 'Bu Sargyt üçin entek Eltip beriji bellenilmedi',

        error600: 'Banner tapylmady',
        error601: 'Banner tassyklanylmadyk',
        error602: 'Banner bloklanan',
        error603: 'Banner ýalňyş ýagdaýda',

        error700: 'Mahabat tapylmady',
        error701: 'Mahabat tassyklanylmadyk',
        error702: 'Mahabat bloklanan',
        error703: 'Mahabat ýalňyş ýagdaýda',

        error800: 'Bu Ady bilen Ýeri bar',
        error801: 'Bu Ady bilen Ýerleşiş belligi bar',
        error802: 'Bu Ady bilen Kategoriýa bar',
        error803: 'Bu Ady bilen Bölüm bar',
        error804: 'Bu Ady bilen Kiçi Kategoriýa bar',
        error805: 'Bu Ady bilen Ussatlyk bar',

        error900: 'Reýting tapylmady',
        error904: 'Reýting kabul edilmedi',

        error1000: 'Abuna tapylmady',
        error1004: 'Bu Düzülmeler bilen Aktiw Abuna bar',

        success: 'Üstünlük',
        success100: 'Üstünlük bilen',
        success101: 'Siz üstünlük bilen Ulgama girdiňiz',
        success102: 'Siz üstünlük bilen Ulgam açdyňyz',
        success103: 'Hoş Sag boluň',
        success104: 'Üstünlük bilen açyldy',
        success105: 'Üstünlük bilen goşuldy',
        success106: 'Üstünlük bilen täzelendi',
        success107: 'Üstünlük bilen üýtgedildi',
        success108: 'Üstünlük bilen tassyklanyldy',
        success109: 'Üstünlük bilen öçürüldi',
        success110: 'Siziň sargydyňyz üstünlük bilen alyndy. Sargydy tassyklamak üçin Size Operator tarapyndan jaň ediler',
        success111: 'Üstünlük bilen ugradyldy',

        viewStatus1: 'Aktiw',
        viewStatus2: 'Täze',
        viewStatus3: 'Üýtgedilen',
        viewStatus4: 'Bloklanan',
        viewStatus5: 'Tassyklanan',
        viewStatus6: 'Ugradylan',
        viewStatus7: 'Gowşurulan',
        viewStatus9: 'Red edilen',
        
        status: 'Status',
        status1: 'Aktiw',
        status2: 'Tassyklanmagy garaşylýar',
        status3: 'Üýtgeşmeler barlanylýar',
        status4: 'Bloklanan',
        status5: 'Tassyklanan',
        status6: 'Ugradylan',
        status7: 'Gowşurulan',
        status9: 'Red edilen',
        status10: 'Tapylmady',
        
        panelStatus1: 'Aktiwlar',
        panelStatus2: 'Täzeler',
        panelStatus3: 'Üýtgedilenler',
        panelStatus4: 'Bloklananlar',
        panelStatus5: 'Tassyklananlar',
        panelStatus6: 'Ugradylanlar',
        panelStatus7: 'Gowşurulanlar',
        panelStatus9: 'Red edilenler',

        appDescription1: "Lezzet'Sebeti – onlaýn söwda platformasy.",
        appDescription2: "Biz her bir adamyň arzuwyny hakykata golaýlaşdyrmana hereket edýäris.",
        appDescription3: "Biziň maksadymyz dünýäni ýene-de gowylaşmagyna we oňaýlaşmagyna goşandymyzy goşmak.",
        appSupport: "Eger-de Sizde başga soraglar, ýüze çyksa biziň E-mail poçtamyza ýazyň.",
        copyright: "Ähli Awtorlyk hukuklar goragly 2024 ýyl.",

        appAboutUs: "Biz barada:",
        appAboutUs1: "1. Lezzet'Sebeti-niň maksady, söwda sferasy bilen meşgullanýan fiziki ýa-da ýuridiki şahslaryň marketingini güýçlendirmäne mümkinçilikler bermek. Şeýlede öz zerurlyklaryny gözleýän şahslara, tiz we täsirli gözlap tapmak üçin mümkinçilikler bermek.",
        appAboutUs2: "2. Biziň goşmaça hyzmatlarymyza girýär:",
        appAboutUsServices: "Banner mahabat, sahypa-ara mahabat: Siziň Söwda Nokadyňyzyň, harytlaryňyzyň we şoňa meňzeş mahabatlary ýerleşdirmek.",
        appAboutUsQuestionsAndAnswers: "Soraglara jogap:",
        appAboutUsQuestion1: "1. Lezzet'Sebeti näme?",
        appAboutUsAnswer1: "Lezzet'Sebeti söwda sferasy bilen meşgullanýan fiziki ýa-da ýuridiki şahslaryň marketingini güýçlendirmäne mümkinçilikler berýär. Şeýlede öz zerurlyklaryny gözleýän şahslara, tiz we täsirli gözlap tapmak üçin mümkinçilikler berýär.",
        appAboutUsQuestion2: "2. Men öz Söwda Nokadymy Lezzet'Sebeti-nde ýerleşdirip bilýänmi?",
        appAboutUsAnswer2: "Howwa, eger-de Siz söwda sferasy bilen meşgullanýan bolsaňyz, Siz öz Söwda Nokadyňyzy hiç bir päsgelçiliksiz ýerleşdirip bilersisňiz. Munuň üçin Administrator bilen habarlaşyň.",
        appAboutUsQuestion3: "3. Lezzet'Sebeti-nde Ulgam açmak hökmanmy?",
        appAboutUsAnswer3: "Ýok, hökman däl. Ýöne, Lezzet'Sebeti-nde ulgam açanyňyzdan soň, sargyt etmek, reýting baha bermek, teswir galdyrmak, özüňize ýaran Söwda Nokatlaryny ýa-da harytlary halanlarym taryhyna goşmak we beýleki işleri amala aşyrmak ýaly köp mümkinçilikler peýda bolar.",
        
        termsOfUseTitle: "Şu saýta ýa-da programma giren we häzirki döwürde ulanýan ähli adamlar, şu Ulanyş Şertlerini gürrüňsiz kabul edýänliginiň şaýady bolup durýar.",

        termsOfUseUsers: "Ulanyjylara:",
        termsOfUseUsers1: "1. Lezzet'Sebeti Ulanyjylaryň zerurlyklaryna we talaplaryna laýyk harytlary tapmak ukybyny hödürleýär.",
        termsOfUseUsers2: "2. Lezzet'Sebeti Ulanyjy we onuň saýlamak hereketi üçin jogapkärçiligi öz üssüne almaýar. Biziň maksadymyz, Ulanyja özüne gerekli zerurlygyny Söwda Nokatlarynyň harytlary arasyndan tapmak üçin mümkinçilik döretmek.",
        termsOfUseUsers3: "3. Lezzet'Sebeti harytlaryň tölenmegi ýa-da öňünden tölenmegi üçin, şeýle hem harytlaryň hiliniň kepilligine we bahasy üçin  jogapkärçiligi öz üssüne almaýar. Harytlary almazdan we gözden geçirmezden öň puluny tölemäň. Lezzet'Sebeti-nde Siziň edýän ähli işleriňizi we hereketleriňizi, öz töwekgelçiligiňiz we gorkyňyz bilen edýärsiňiz.",
        termsOfUseUsers4: "4. Söwda Nokatlaryndan söwda etmezden ozal, başga Ulanyjylar tarapyndan galdyrylan teswirleri okaň we reýting bahalaryny deňeşdiriň.",
        termsOfUseUsers5: "5. Ulanyjylar özüne ýaran Söwda Nokatlaryny ýa-da harytlaryny halanlarym taryhyna goşmak, şeýle hem Sargyt eden Söwda Nokatlaryna reýting baha bermek we teswir galdyrmak mümkinçiligi bar.",
        termsOfUseUsers6: "6. Teswir galdyrmagyň düzgünleri:",
        termsOfUseUsersComment1: "• Teswirde, psihiki taýdan ýa-da dini taýdan ynandyrma sözleri bolmaly däl, şeýle hem gödek sözler zorluk, masgaralamak ýa-da sögünç sözler bolmagy gadagan.",
        termsOfUseUsersComment2: "• Teswirde, psihiki taýdan ýa-da dini taýdan ynandyrma materiallara baglanyşyk, şeýle hem zorluk, masgaralamak we bolgusyz materiallara baglanyşyk bolmagy gadagan.",
        termsOfUseUsers7: "7. Görkezilen düzgünler bozulan ýagdaýynda Administrator düşündirişsiz we sebäpsiz, Ulanyjyny ulgamdan pozmaga we blokirlemäne hukugy bar.",
        termsOfUseUsers8: "8. Ulanyjy Lezzet'Sebeti-nde edýän ähili işleri we hereketleri üçin jogapkärçiligi doly öz üssüne alýar.",
        termsOfUseUsers9: "9. Lezzet'Sebeti Ulanyjylaryň we Söwda Nokatlaryň ylalaşygynyň arasynda durmaýar we gatnaşmaýar.",
        termsOfUseUsers10: "10. Lezzet'Sebeti Ulanyjylaryň we Söwda Nokatlaryň söwdasynyň arasynda durmaýar we gatnaşmaýar.",

        termsOfUseStores: "Söwda Nokatlaryna:",
        termsOfUseStores1: "1. Lezzet'Sebeti Söwda Nokatlaryna harytlaryny we hyzmatlaryny onlaýn hödürlemek we satmak üçin hyzmatlary we mümkinçilikleri hödürleýär.",
        termsOfUseStores2: "2. Lezzet'Sebeti Söwda Nokadynyň hereketleri we bildirişleri üçin jogapkärçiligi öz üssüne almaýar. Biziň maksadymyz Söwda Nokatlaryna harytlaryny we hyzmatlaryny onlaýn hödürlemek we satmak mümkinçiligini bermek.",
        termsOfUseStores3: "3. Lezzet'Sebeti sargytlaryň tölenmezligi üçin jogapkärçiligi öz üssüne almaýar (görkezilen halatlardan başgasy: egerde eltip bermek hyzmaty Lezzet'Sebeti tarapyndan bolsa we onlaýn töleg), Lezzet'Sebeti-nde Siziň edýän ähli işleriňizi we hereketleriňizi, öz töwekgelçiligiňiz we gorkyňyz bilen edýärsiňiz.",
        termsOfUseStores4: "4. Lezzet'Sebeti düşündirişsiz we sebäpsiz harytlaryň we hyzmatlaryň bildirişini pozmaga we blokirlemäne hukugy bar, şeýle hem eger haryt ýa-da hyzmat Lezzet'Sebeti-niň düzgünlerine laýyk gelmedýän bolsa. Ähli bildirişler Lezzet'Sebeti-niň Administratorlary tarapyndan barlanylýar.",
        termsOfUseStores5: "5. Bildiriş goşmagyň düzgünleri:",
        termsOfUseStoresAnnouncement1: "• Bildirişde, Türkmenistanyň kanunçylygyna laýyk gelmeýän harytlar ýa-da hyzmatlar bolmaly däldir.",
        termsOfUseStoresAnnouncement2: "• Bildirişde, psihiki taýdan ýa-da dini taýdan ynandyrma sözleri bolmaly däl, şeýle hem gödek sözler zorluk, masgaralamak ýa-da sögünç sözler bolmagy gadagan.",
        termsOfUseStoresAnnouncement3: "• Bildirişde, psihiki taýdan ýa-da dini taýdan ynandyrma materiallara baglanyşyk bolmaly däl, şeýle hem zorluk, masgaralamak ýa-da gödek häsiýetli materiallara baglanyşyk bolmagy gadagan.",
        termsOfUseStoresAnnouncement4: "• Bildirişde, psihiki taýdan ýa-da dini taýdan ynandyrma suratlary bolmaly däl, şeýle hem zorluk, masgaralamak ýa-da gödek häsiýetli suratlary goýmak gadagan.",
        termsOfUseStoresAnnouncement5: "• Söwda Nokady, harydyň ýa-da hyzmatyň bildirişini beýansyz we suratsyz goýmaga hukugy ýok.",
        termsOfUseStoresAnnouncement6: "• Söwda Nokady, özüne degişli bolmadyk harydyň ýa-da hyzmatyň bildirişini goýmaga hukugy ýok.",
        termsOfUseStores6: "6. Söwda Nokatlary Ulanyjylar tarapyndan galdyrylan teswirlere jogap galdyrmak mümkinçiligi bar.",
        termsOfUseStores7: "7. Jogap galsyrmagyň düzgünleri:",
        termsOfUseStoresComment1: "• Jogapda, psihiki taýdan ýa-da dini taýdan ynandyrma sözleri bolmaly däl, şeýle hem gödek sözler zorluk, masgaralamak ýa-da sögünç sözler bolmagy gadagan.",
        termsOfUseStoresComment2: "• Jogapda, psihiki taýdan ýa-da dini taýdan ynandyrma materiallara baglanyşyk bolmaly däl, şeýle hem zorluk, masgaralamak ýa-da gödek häsiýetli materiallara baglanyşyk bolmagy gadagan.",
        termsOfUseStores8: "8. Lezzet'Sebeti-niň Administratorlary düşündirişsiz we sebäpsiz Söwda Nokadyny we onuň (jogapkär adamy) Eýesini ulgamdan pozmaga we blokirlemäne hukugy bar.",
        termsOfUseStores9: "9. Söwda Nokady we onuň (jogapkär adamy) Eýesi Lezzet'Sebeti-nde islendik edýän hereketleri we işleri üçin jogapkärçiligi doly öz üssüne alýar.",
        termsOfUseStores10: "10. Lezzet'Sebeti Ulanyjylaryň we Söwda Nokatlaryň ylalaşygynyň arasynda durmaýar we gatnaşmaýar.",
        termsOfUseStores11: "11. Lezzet'Sebeti Ulanyjylaryň we Söwda Nokatlaryň söwdasynyň arasynda durmaýar we gatnaşmaýar.",

        privacyPolicyTitle: "Şu saýta ýa-da programma giren we häzirki döwürde ulanýan ähli adamlar, şu Gizlinlik Syýasatyny gürrüňsiz kabul edýänliginiň şaýady bolup durýar.",

        privacyPolicyDataUsers: "Ulanyjylara:",
        privacyPolicyDatasUsersScroll: "Ulanyjylaryň, Şahsy maglumatlary bilen hereketleriň sanawy:",
        privacyPolicyDatasUsers: "Lezzet'Sebeti-nde görkezilen Şahsy maglumatlar ýygnalýar: Ulanyjylaryň bellige alynan telefon belgileri, ady (hakyky ýa-da bellenen, tötänleýin), salgylary, teswirleri we sargytlary barada maglumaty.",
        privacyPolicyDataUsersPhone: "Ulanyjynyň bellige alynan telefon belgisi:",
        privacyPolicyDataUsersPhone1: "1. Ulanyjynyň bellige alynan telefon belgisi: Lezzet'Sebeti-nde hasaba alynanda Ulanyjy tarapyndan girizilen telefon belgisi.",
        privacyPolicyDataUsersPhone2: "2. Ulanyjy, Lezzet'Sebeti-nde hasaba alynandan soň, onuň telefon belgisi Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataUsersPhone3: "3. Lezzet'Sebeti-nde bellige alynan telefon belgisi, şahsyýeti tassyklamak, Ulanyjy bilen habarlaşmak we sargydy tassyklamak, şeýle hem Lezzet'Sebeti-niň serwerinde Ulanyjyny tanamak üçin hyzmat edýär.",
        privacyPolicyDataUsersPhone4: "4. Ulanyjynyň bellige alynan telefon belgisi, Lezzet'Sebeti-nde hasaba alynanda, hökmany suratda görkezilýär.",
        privacyPolicyDataUsersName: "Ulanyjynyň ady:",
        privacyPolicyDataUsersName1: "1. Ulanyjynyň ady: Lezzet'Sebeti-nde Ulanyjy tarapyndan girizilen ady ýa-da hasaba alynanda tötänleýin bellenen ady.",
        privacyPolicyDataUsersName2: "2. Ulanyjy, adyny üýtgeden soň, onuň ady Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataUsersName3: "3. Ady, şahsyýeti tassyklamak we sargydy tassyklamak üçin hyzmat edýär.",
        privacyPolicyDataUsersName4: "4. Ulanyjynyň ady, Lezzet'Sebeti-nde hasaba alynandan soň, hökmany suratda görkezilmeýär.",
        privacyPolicyDataUsersAddress: "Ulanyjynyň salgysy:",
        privacyPolicyDataUsersAddress1: "1. Ulanyjynyň salgysy: Lezzet'Sebeti-nde Ulanyjy tarapyndan goşulan salgy.",
        privacyPolicyDataUsersAddress2: "2. Ulanyjy, salgy goşandan soň, onuň salgysy Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataUsersAddress3: "3. Salgy, bellenilen ýere sargydy eltip bermek üçin hyzmat edýär.",
        privacyPolicyDataUsersAddress4: "4. Ulanyjynyň salgysy, Lezzet'Sebeti-nde sargyt edilende, hökmany suratda görkezilýär.",
        privacyPolicyDataUsersRate: "Ulanyjynyň teswiri:",
        privacyPolicyDataUsersRate1: "1. Ulanyjynyň teswiri: Lezzet'Sebeti-nde sargyt edilen soň Ulanyjy tarapyndan Söwda Nokadyna goşulan teswir.",
        privacyPolicyDataUsersRate2: "2. Ulanyjy, teswiri goşandan soň, onuň teswiri Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataUsersRate3: "3. Teswir, eltip bermek hyzmatynyň hilini, serwiz hyzmatynyň we harytlar täsiri barada maglumatlaryny almak üçin hyzmat edýär.",
        privacyPolicyDataUsersRate4: "4. Ulanyjynyň teswiri, Lezzet'Sebeti-nde sargyt edilenden soň, hökmany suratda görkezilmeýär.",
        privacyPolicyDataUsersCart: "Ulanyjynyň sargytlary barada maglumaty:",
        privacyPolicyDataUsersCart1: "1. Ulanyjynyň sargytlary barada maglumaty: Lezzet'Sebeti-nde Ulanyjy tarapyndan Söwda Nokatlaryndan edilen sargytlar.",
        privacyPolicyDataUsersCart2: "2. Ulanyjy, sargyt eden soň, onuň sargydy Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataUsersCart3: "3. Sargyt barada maglumat, satyn alynan harytlaryň, hyzmatlaryň maglumatlaryny almak we eltip bermek üçin salgynyň maglumatlaryny almak, şeýle hem Söwda Nokady we Eltip beriji tarapyndan Ulanyjy barada maglumatlary almak üçin hyzmat edýär.",
        privacyPolicyDataUsersCart4: "4. Ulanyjynyň sargydy barada maglumaty, Lezzet'Sebeti-nde sargyt edilende hökmany suratda görkezilýär.",
        privacyPolicyDataUsersShopping: "Sargyt eldilenden we gowşurylýança edilýän hereketleriň sanawy:",
        privacyPolicyDataUsersShopping1: "1. Ulanyjy Lezzet'Sebeti-nde sargyt edeninden soň, Ulanjynyň maglumatlary we sargydyň maglumatlary, Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataUsersShopping2: "2. Lezzet'Sebeti-niň serwerindäki edilen sargyt we Ulanjynyň maglumatlary, sargyt edilen Söwda Nokadyna, awtomatiki usulda iberilýär.",
        privacyPolicyDataUsersShopping3: "3. Edilen sargyt we Ulanyjynyň maglumatlary, Söwda Nokadynyň Operatory tarapyndan, Ulanyjynyň hasaba alynan telefon belgisine, jaň etmek bilen tassyklanýar.",
        privacyPolicyDataUsersShopping4: "4. Edilen sargyt, Söwda Nokadynyň Eltip berijisi ýa-da Lezzet'Sebeti-niň Eltip berijisi tarapyndan, bellenilen ýere eltip berilýär.",
        privacyPolicyDataUsersEncryptTitle: "Ulanyjynyň, Lezzet'Sebeti-niň serwerinde ähli, alynan ýa-da iberilen Şahsy maglumatlary, şifrlemek arkaly amala aşyrylýar.",

        privacyPolicyDataStores: "Söwda Nokatlaryna:",
        privacyPolicyDatasStoresScroll: "Söwda Nokatlaryn, Şahsy maglumatlary bilen hereketleriň sanawy:",
        privacyPolicyDatasStores: "Lezzet'Sebeti-nde görkezilen Şahsy maglumatlar ýygnalýar: Söwda Nokadynyň ady, media faýllary, telefon belgileri, E-mail salgylar, iş günleri, eltip bermek barada maglumaty, töleg görünişleri barada maglumaty, salgysy, harytlary we hyzmatlary barada maglumaty, we sargytlary barada maglumaty.",
        privacyPolicyDataStoresTitle: "Söwda Nokadynyň ady:",
        privacyPolicyDataStoresTitle1: "1. Söwda Nokadynyň ady: Lezzet'Sebeti-nde hasaba alynanda girizilen ady.",
        privacyPolicyDataStoresTitle2: "2. Söwda Nokady, Lezzet'Sebeti-nde hasaba alynandan soň, onuň ady Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresTitle3: "3. Ady, Lezzet'Sebeti-nde Söwda Nokady hökmünde obýekti tassyklamaga we işini dowam etmek üçin hyzmat edýär.",
        privacyPolicyDataStoresTitle4: "4. Söwda Nokadynyň ady, Lezzet'Sebeti-nde hasaba alynanda, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresMedia: "Söwda Nokadynyň media faýllary:",
        privacyPolicyDataStoresMedia1: "1. Söwda Nokadynyň media faýllary: Lezzet'Sebeti serwerine, Söwda Nokady tarapyndan ýüklenýän wideo we surat faýllary.",
        privacyPolicyDataStoresMedia2: "2. Söwda Nokady, Lezzet'Sebeti-nde media faýl ýüklän soň, onuň media faýly Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresMedia3: "3. Media faýllar, Lezzet'Sebeti-nde Söwda Nokady obýekti barada maglumatlary wizual tassyklamak we Söwda Nokadynyň harytlary we hyzmatlary barada maglumatlary wizual tassyklamak üçin hyzmat edýär.",
        privacyPolicyDataStoresMedia4: "4. Söwda Nokadynyň media faýllary, Lezzet'Sebeti-nde hasaba alynandan soň, şeýle hem harytlary we hyzmatlary goşandan soň, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresPhone: "Söwda Nokadynyň telefon belgileri:",
        privacyPolicyDataStoresPhone1: "1. Söwda Nokadynyň telefon belgileri: Lezzet'Sebeti-nde hasaba alynanda girizilen, Söwda Nokadynyň esasy telefon belgisi, şeýle hem hasaba alynandan soň goşulan Söwda Nokadynyň goşmaça telefon belgisi.",
        privacyPolicyDataStoresPhone2: "2. Söwda Nokady, Lezzet'Sebeti-nde esasy telefon belgisi bilen hasaba alynanda ýa-da soň goşmaça telefon belgisini goşandan soň, onuň telefon belgisi Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresPhone3: "3. Lezzet'Sebeti-nde esasy ýa-da goşmaça telefon belgileri, Söwda Nokady bilen habarlaşmak, şeýle-hem Lezzet'Sebeti-nde sargytlary tassyklamak üçin hyzmat edýär.",
        privacyPolicyDataStoresPhone4: "4. Söwda Nokadynyň esasy telefon belgisi, Lezzet'Sebeti-nde hasaba alynanda, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresEmail: "Söwda Nokadynyň E-mail salgysy:",
        privacyPolicyDataStoresEmail1: "1. Söwda Nokadynyň E-mail salgysy: Lezzet'Sebeti-nde hasaba alynanda girizilen E-mail salgysy.",
        privacyPolicyDataStoresEmail2: "2. Söwda Nokady, Lezzet'Sebeti-nde hasaba alynandan soň, onuň E-mail salgysy Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresEmail3: "3. Lezzet'Sebeti-nde E-mail salgy, Söwda Nokady bilen habarlaşmak, şeýle hem Lezzet'Sebeti-niň serwerinde Söwda Nokadyny tanamak üçin hyzmat edýär.",
        privacyPolicyDataStoresEmail4: "4. Söwda Nokadynyň E-mail salgysy, Lezzet'Sebeti-nde hasaba alynanda, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresWorkDays: "Söwda Nokadynyň iş günleri:",
        privacyPolicyDataStoresWorkDays1: "1. Söwda Nokadynyň iş günleri: Lezzet'Sebeti-nde hasaba alynandan soň, görkezilen Söwda Nokadynyň iş günleri.",
        privacyPolicyDataStoresWorkDays2: "2. Söwda Nokady, Lezzet'Sebeti-nde iş günlerini görkezenden soň, onuň iş günleri Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresWorkDays3: "3. Iş günleri, Lezzet'Sebeti-nde Söwda Nokadynyň statusy işleýän ýa-da işlemeýändigi barada maglumatlaryny almak üçin hyzmat edýär.",
        privacyPolicyDataStoresWorkDays4: "4. Söwda Nokadynyň iş günleri, Lezzet'Sebeti-nde hasaba alynandan soň, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresDelivery: "Söwda Nokadynyň eltip bermek barada maglumaty:",
        privacyPolicyDataStoresDelivery1: "1. Söwda Nokadynyň eltip bermek barada maglumaty: Lezzet'Sebeti-nde hasaba alynandan soň, görkezilen Söwda Nokadynyň eltip bermek barada görkezilen usullary we ýollary.",
        privacyPolicyDataStoresDelivery2: "2. Söwda Nokady, Lezzet'Sebeti-nde eltip bermek barada usullary we ýollary görkezenden soň, onuň eltip bermek barada usullary we ýollary Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresDelivery3: "3. Eltip bermek barada maglumaty, Lezzet'Sebeti-nde Söwda Nokadynyň eltip bermek barada usullary we ýollary maglumatlaryny almak üçin hyzmat edýär.",
        privacyPolicyDataStoresDelivery4: "4. Söwda Nokadynyň eltip bermek barada maglumaty, Lezzet'Sebeti-nde hasaba alynandan soň, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresPayment: "Söwda Nokadynyň töleg görünişleri barada maglumaty:",
        privacyPolicyDataStoresPayment1: "1. Söwda Nokadynyň töleg görünişleri barada maglumaty: Lezzet'Sebeti-nde hasaba alynandan soň, görkezilen Söwda Nokadynyň töleg görünişleri.",
        privacyPolicyDataStoresPayment2: "2. Söwda Nokady, Lezzet'Sebeti-nde töleg görünişlerini görkezenden soň, onuň töleg görünişleri Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresPayment3: "3. Töleg görünişleri barada maglumaty, Lezzet'Sebeti-nde Söwda Nokadynyň töleg görünişleri barada maglumatlaryny almak üçin hyzmat edýär.",
        privacyPolicyDataStoresPayment4: "4. Söwda Nokadynyň töleg görünişleri barada maglumaty, Lezzet'Sebeti-nde hasaba alynandan soň, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresAddress: "Söwda Nokadynyň salgysy:",
        privacyPolicyDataStoresAddress1: "1. Söwda Nokadynyň salgysy: Lezzet'Sebeti-nde hasaba alynanda girizilen salgy.",
        privacyPolicyDataStoresAddress2: "2. Söwda Nokady, Lezzet'Sebeti-nde hasaba alynandan soň, onuň salgysy Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresAddress3: "3. Salgy, Lezzet'Sebeti-nde Söwda Nokadynyň ýerleşýän ýeri barada maglumatlaryny almak üçin hyzmat edýär.",
        privacyPolicyDataStoresAddress4: "4. Söwda Nokadynyň salgysy, Lezzet'Sebeti-nde hasaba alynanda, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresProduct: "Söwda Nokadynyň harytlary we hyzmatlary barada maglumaty:",
        privacyPolicyDataStoresProduct1: "1. Söwda Nokadynyň harytlary we hyzmatlary barada maglumaty: Lezzet'Sebeti-nde Söwda Nokady tarapyndan, her bir haryt ýa-da hyzmat goşulanda girizilen maglumat.",
        privacyPolicyDataStoresProduct2: "2. Söwda Nokady, Lezzet'Sebeti-nde haryt ýa-da hyzmat barada maglumat goşandan soň, onuň haryt ýa-da hyzmat barada maglumaty Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresProduct3: "3. Harytlar we hyzmatlar barada maglumat, Söwda Nokadynyň harytlary we hyzmatlary barada maglumatlaryny almak, şeýle hem Lezzet'Sebeti-niň serwerinde her bir aýratyn haryt ýa-da hyzmaty tanamak üçin hyzmat edýär.",
        privacyPolicyDataStoresProduct4: "4. Söwda Nokadynyň harytlary we hyzmatlary barada maglumaty, Lezzet'Sebeti-nde her bir haryt ýa-da hyzmat goşulanda, hökmany suratda görkezilýär.",
        privacyPolicyDataStoresCart: "Söwda Nokadynyň sargytlary barada maglumaty:",
        privacyPolicyDataStoresCart1: "1. Söwda Nokadynyň sargytlary barada maglumaty: Lezzet'Sebeti-nde Ulanyjy tarapyndan Söwda Nokadyndan edilen sargytlar.",
        privacyPolicyDataStoresCart2: "2. Söwda Nokady, Ulanyjy tarapyndan alan, kabul eden, ugradan ýa-da gowşuran sargydy, Lezzet'Sebeti-niň serwerinde srgydyň statusy täze, tassyklanan, ugradylan ýa-da gowşurulan bolup üýtgeýär.",
        privacyPolicyDataStoresCart3: "3. Sargyt barada maglumat, satyn alynan harytlar, hyzmatlar barada maglumatlaryny almak we eltip bermek üçin salgy maglumatlaryny almak, şeýle hem Ulanyjy maglumatlaryny almak üçin hyzmat edýär.",
        privacyPolicyDataStoresCart4: "4. Söwda Nokadynyň sargydy barada maglumaty, Lezzet'Sebeti-nde sargyt edilenden soň, hökmany suratda saklanýar.",
        privacyPolicyDataStoresShopping: "Sargyt eldilenden we gowşurylýança edilýän hereketleriň sanawy:",
        privacyPolicyDataStoresShopping1: "1. Ulanyjy Lezzet'Sebeti-nde sargyt edeninden soň, Ulanjynyň maglumatlary we sargydyň maglumatlary, Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataStoresShopping2: "2. Lezzet'Sebeti-niň serwerindäki edilen sargyt we Ulanjynyň maglumatlary, sargyt edilen Söwda Nokadyna, awtomatiki usulda iberilýär.",
        privacyPolicyDataStoresShopping3: "3. Edilen sargyt we Ulanyjynyň maglumatlary, Söwda Nokadynyň Operatory tarapyndan, Ulanyjynyň hasaba alynan telefon belgisine, jaň etmek bilen tassyklanýar.",
        privacyPolicyDataStoresShopping4: "4. Edilen sargyt, Söwda Nokadynyň Eltip berijisi ýa-da Lezzet'Sebeti-niň Eltip berijisi tarapyndan, bellenilen ýere eltip berilýär.",
        privacyPolicyDataStoresEncryptTitle: "Söwda Nokadynyň, Lezzet'Sebeti-niň serwerinde ähli, alynan ýa-da iberilen Şahsy maglumatlary, şifrlemek arkaly amala aşyrylýar.",
        
        privacyPolicyDataCouriers: "Eltip berijilere:",
        privacyPolicyDatasCouriersScroll: "Eltip berijileriň, Şahsy maglumatlary bilen hereketleriň sanawy:",
        privacyPolicyDatasCouriers: "Lezzet'Sebeti-nde görkezilen Şahsy maglumatlar ýygnalýar: Eltip berijileriň ady (hakyky ýa-da bellenen, tötänleýin), telefon belgileri, salgylary, suratlary (şahsy, ulag we pasport) we sargytlary barada maglumaty.",
        privacyPolicyDataCouriersName: "Eltip berijiniň ady:",
        privacyPolicyDataCouriersName1: "1. Eltip berijiniň ady: Lezzet'Sebeti-nde Eltip beriji tarapyndan girizilen ady ýa-da hasaba alynanda tötänleýin bellenen ady.",
        privacyPolicyDataCouriersName2: "2. Eltip beriji, adyny üýtgeden soň, onuň ady Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataCouriersName3: "3. Ady, şahsyýeti tassyklamak we sargydy tassyklamak, şeýle hem Lezzet'Sebeti-niň işgäri hökmünde tanamak üçin hyzmat edýär.",
        privacyPolicyDataCouriersName4: "4. Eltip berijiniň ady, Lezzet'Sebeti-nde hasaba alynandan soň, hökmany suratda görkezilýär.",
        privacyPolicyDataCouriersPhone: "Eltip berijiniň telefon belgisi:",
        privacyPolicyDataCouriersPhone1: "1. Eltip berijiniň telefon belgisi: Lezzet'Sebeti-nde hasaba alynanda Eltip berijiniň girizilen telefon belgisi.",
        privacyPolicyDataCouriersPhone2: "2. Eltip beriji, Lezzet'Sebeti-nde hasaba alynandan soň, onuň telefon belgisi Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataCouriersPhone3: "3. Lezzet'Sebeti-nde telefon belgisi, şahsyýeti tassyklamak, Eltip beriji bilen habarlaşmak we sargydy tassyklamak, şeýle hem Lezzet'Sebeti-niň serwerinde Eltip berijini tanamak üçin hyzmat edýär.",
        privacyPolicyDataCouriersPhone4: "4. Eltip berijiniň telefon belgisi, Lezzet'Sebeti-nde hasaba alynanda, hökmany suratda görkezilýär.",
        privacyPolicyDataCouriersAddress: "Eltip berijiniň salgysy:",
        privacyPolicyDataCouriersAddress1: "1. Eltip berijiniň salgysy: Lezzet'Sebeti-nde hasaba alynanda Eltip berijiniň girizilen salgysy.",
        privacyPolicyDataCouriersAddress2: "2. Eltip beriji, Lezzet'Sebeti-nde hasaba alynandan soň, onuň salgysy Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataCouriersAddress3: "3. Salgy, Eltip berijiniň ýaşaýyş ýeri barada maglumatlaryny almak, şeýle hem degişli bolan ýaşaýyş ýerinden sargytlary almak üçin hyzmat edýär.",
        privacyPolicyDataCouriersAddress4: "4. Eltip berijiniň salgysy, Lezzet'Sebeti-nde hasaba alynanda, hökmany suratda görkezilýär.",
        privacyPolicyDataCouriersPhoto: "Eltip berijiniň suratlary:",
        privacyPolicyDataCouriersPhoto1: "1. Eltip berijiniň suratlary: Lezzet'Sebeti serwerine, Eltip beriji tarapyndan ýüklenýän surat faýllary.",
        privacyPolicyDataCouriersPhoto2: "2. Eltip beriji, Lezzet'Sebeti-nde surat faýl ýüklän soň, onuň surat faýly Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataCouriersPhoto3: "3. Suratlar, Eltip beriji barada maglumatlary wizual tassyklamak we Eltip berijiniň ulagy barada maglumatlary wizual tassyklamak, şeýle hem Eltip berijini, Lezzet'Sebeti-niň işgäri hökmünde tanamak üçin hyzmat edýär.",
        privacyPolicyDataCouriersPhoto4: "4. Eltip berijiniň suratlary, Lezzet'Sebeti-nde hasaba alynandan soň, hökmany suratda görkezilýär.",
        privacyPolicyDataCouriersCart: "Eltip berijiniň sargytlary barada maglumaty:",
        privacyPolicyDataCouriersCart1: "1. Eltip berijiniň sargytlary barada maglumaty: Lezzet'Sebeti-nde sargytlary bellenilen ýere eltip bermek üçin, Lezzet'Sebeti tarapyndan Eltip berijä tabşyrylan sargytlar.",
        privacyPolicyDataCouriersCart2: "2. Eltip berijä, sargyt tabşyrylan soň, onuň sargydy Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataCouriersCart3: "3. Sargyt barada maglumat, satyn alynan harytlar, hyzmatlar barada maglumatlaryny almak we eltip bermek üçin salgy maglumatlaryny almak, şeýle hem Ulanyjy maglumatlaryny almak üçin hyzmat edýär.",
        privacyPolicyDataCouriersCart4: "4. Eltip berijiniň sargydy barada maglumaty, Lezzet'Sebeti-nde sargyt tabşyrylanda, hökmany suratda görkezilýär.",
        privacyPolicyDataCouriersShopping: "Sargyt eldilenden we gowşurylýança edilýän hereketleriň sanawy:",
        privacyPolicyDataCouriersShopping1: "1. Ulanyjy Lezzet'Sebeti-nde sargyt edeninden soň, Ulanjynyň maglumatlary we sargydyň maglumatlary, Lezzet'Sebeti-niň serwerinde saklanýar.",
        privacyPolicyDataCouriersShopping2: "2. Lezzet'Sebeti-niň serwerindäki edilen sargyt we Ulanjynyň maglumatlary, sargyt edilen Söwda Nokadyna, awtomatiki usulda iberilýär.",
        privacyPolicyDataCouriersShopping3: "3. Edilen sargyt we Ulanyjynyň maglumatlary, Söwda Nokadynyň Operatory tarapyndan, Ulanyjynyň hasaba alynan telefon belgisine, jaň etmek bilen tassyklanýar.",
        privacyPolicyDataCouriersShopping4: "4. Edilen sargyt, Söwda Nokadynyň Eltip berijisi ýa-da Lezzet'Sebeti-niň Eltip berijisi tarapyndan, bellenilen ýere eltip berilýär.",
        privacyPolicyDataCouriersEncryptTitle: "Eltip berijiniň, Lezzet'Sebeti-niň serwerinde ähli, alynan ýa-da iberilen Şahsy maglumatlary, şifrlemek arkaly amala aşyrylýar."
    },
    ru: {
        app: "Lezzet'Sebeti",
        appStore: "Lezzet'Store",
        appGo: "Lezzet'Go",
        
        appUpdateVersionTitle: "Программное обеспечение!",
        appUpdateVersionDescription: "Это программное обеспечение было обновлено, пожалуйста, обновите его до последней версии!",

        loading: 'ЗАГРУЗКА',
        loadMore: 'Загрузить больше',
        pageNotFound: 'Ошибка: 404 - страница не найдена',
        unknownScreen: 'Hеизвестный экран',
        install: "Установка приложения Lezzet'Sebeti",

        logo: 'Логотип',
        logos: 'Логотипы',

        start: 'Начинать',
        startIn: 'Начинать здесь',

        sessions: 'Подключенные устройства',

        pages: 'Страницы',
        viewPages: 'Страницы Показа',
        otherPages: 'Другие Страницы',

        shoppingCenters: 'Торговые Заведения',
        shoppingCenter: 'Торговое Заведение',

        homePage: 'Главная Страница',
        home: 'Главная',

        adminPanelPage: 'Страница Админ-панель',
        adminPanel: 'Админ-панель',
        panelPage: 'Страница Панель',
        panel: 'Панель',

        createRankAbonimentPage: 'Страница Создать Подписку Ранга',
        setRankAbonimentPage: 'Страница Настройки Подписки Ранга',
        createRankAboniment: 'Создать Подписку Ранга',
        newRankAboniment: 'Новая Подписка Ранга',
        rankAbonimentPage: 'Страница Подписка Ранга',
        rankAboniment: 'Подписка Ранга',
        rankAbonimentStoresPage: 'Страница Магазины Подписки Ранга',
        rankAbonimentStores: 'Магазины Подписки Ранга',
        rankAbonimentTitle: 'Заработай пока ешь',
        rankAbonimentTableTitle: 'Ранг от Заработай пока ешь',
        
        promotions: 'Акции',
        promotionAboniment: 'Акция 1+1',

        subscribesStores: 'Подписанные Магазины',

        adminsPage: 'Страница Администраторы',
        createAdminPage: 'Страница Создать Администратора',
        setAdminPage: 'Страница Настройки Администратора',
        createAdmin: 'Создать Администратора',
        setAdmin: 'Настройки Администратора',
        newAdmin: 'Новый Администратор',
        admins: 'Администраторы',
        adminPage: 'Страница Администратора',
        admin: 'Администратор',
        
        lDeliverysPage: 'Страница Услуги Доставок',
        createLDeliveryPage: 'Страница Создать Услугу Доставка',
        setLDeliveryPage: 'Страница Настройки Услуги Доставка',
        setLDelivery: 'Настройки Услуги Доставка',
        createLDelivery: 'Создать Услугу Доставки',
        newLDelivery: 'Новая Услуга Доставки',
        lDeliverys: 'Услуги Доставок',
        lDeliveryPage: 'Страница Услуга Доставки',
        lDelivery: 'Услуга Доставки',
        
        couriersPage: 'Страница Курьеры',
        createCourierPage: 'Страница Создать Курьера',
        setCourierPage: 'Страница Настройки Курьера',
        setCourier: 'Настройки Курьера',
        createCourier: 'Создать Курьера',
        newCourier: 'Новый Курьер',
        couriers: 'Курьеры',
        courierPage: 'Страница Курьера',
        courier: 'Курьер',
        courierCartsPage: 'Страница Заказы Курьера',
        courierNotificationsPage: 'Страница Уведомления Курьера',

        cartPage: 'Страница Корзина',
        shopsPage: 'Страница Заказы',
        shopPage: 'Страница Заказа',
        shop: 'Заказ',
        setShopPage: 'Страница Настройки Заказа',
        setShop: 'Настройки Заказа',
        storeShops: 'Заказы',
        storeNewShops: 'Текущие Заказы',
        courierShops: 'Заказы',
        courierNewShops: 'Текущие Заказы',
        profileShops: 'Покупки',
        profileNewShops: 'Ожидающие Заказы',
        historyShops: 'История Заказов',
        cart: 'Корзина',
        confirmCart: 'Подтверждение Заказа',
        newCarts: 'Новые Заказы',
        confirmedCarts: 'Подтвержденные Заказы',
        sentedCarts: 'Отправленные Заказы',
        deliveredCarts: 'Переданные Заказы',
        receivedCarts: 'Полученные Заказы',
        rejectedCarts: 'Отклоненные Заказы',
        
        profilesPage: 'Страница Пользователи',
        profiles: 'Пользователи',
        profilePage: 'Страница Пользователя',
        setProfilePage: 'Страница Настройки Пользователя',
        setProfile: 'Настройки Пользователя',
        profileDataPage: 'Страница Данные Пользователя',
        profileData: 'Данные Пользователя',
        profileDataTrash: 'Удаление Данных Пользователя',
        profileTrash: 'Удаление Пользователя',
        profile: 'Профиль',
        profileSet: 'Изменить Профиль',
        profileCartsPage: 'Страница Заказы Пользователя',
        profileNotificationsPage: 'Страница Уведомления Пользователя',

        addressesPage: 'Страница Адресов',
        addAddressPage: 'Страница Добавить Адрес',

        myFavoriteStoresPage: 'Страница Избранные Товары',
        myFavoriteProductsPage: 'Страница Избранные Товары',
        myRatedStoresPage: 'Страница Оцененные мной Магазины',
        recomendedStoresPage: 'Страница Рекомендуемые Магазины',

        profileCurrentRatesPage: 'Страница Мои Отзывы',
        profileCurrentRates: 'Мои Отзывы',
        profilePendingRatesPage: 'Страница Ожидающие Отзывы',
        profilePendingRates: 'Ожидающие Отзывы',

        currentRatesPage: 'Страница Отзывы',
        currentRates: 'Отзывы',
        pendingRatesPage: 'Страница Ожидающие Отзывы',
        pendingRates: 'Ожидающие Отзывы',

        settingsPage: 'Страница Настройки',
        settings: 'Настройки',
        
        discountStoresPage: 'Страница Магазины со Скидкой',
        promotionStoresPage: 'Страница Магазины с Акциями',
        lezzetDeliveryStoresPage: "Страница Магазины с доставкой от Lezzet'Sebeti",
        rankStoresPage: 'Страница Магазины с рангом Заработай пока ешь',

        storesPage: 'Страница Магазины',
        createStorePage: 'Страница Открыть Магазин',
        setStorePage: 'Страница Настройки Магазина',
        setStore: 'Настройки Магазина',
        createStore: 'Открыть Магазин',
        newStore: 'Новый Магазин',
        stores: 'Магазины',
        storePage: 'Страница Магазина',
        store: 'Магазин',
        storeBannersPage: 'Страница Баннеры Магазина',
        storeProductsPage: 'Страница Товары Магазина',
        storeCreateProductPage: 'Страница Добавить Товар',
        storeCartsPage: 'Страница Заказы Магазина',
        storeNotificationsPage: 'Страница Уведомления Магазина',
        
        productsPage: 'Страница Товары',
        addProduct: 'Добавить Товар',
        addProducts: 'Добавить Товары',
        newProduct: 'Новый Товар',
        newProducts: 'Новые Товары',
        products: 'Товары',
        productPage: 'Страница Товара',
        setProductPage: 'Страница Настройки Товара',
        setProduct: 'Настройки Товара',
        product: 'Товар',
        
        bannersPage: 'Страница Баннеры',
        setBannerPage: 'Страница Настройки Баннера',
        setBanner: 'Настройки Баннера',
        addBanner: 'Добавить Баннер',
        newBanner: 'Новый Баннер',
        banners: 'Баннеры',
        bannerPage: 'Страница Баннера',
        banner: 'Баннер',

        advertisingsPage: 'Страница Рекламы',
        addAdvertising: 'Добавить Рекламу',
        newAdvertising: 'Новая Реклама',
        advertisings: 'Рекламы',
        advertisingPage: 'Страница Реклама',
        advertising: 'Реклама',

        notificationsPage: 'Страница Уведомления',
        setNotificationPage: 'Страница Настройки Уведомления',
        addNotification: 'Добавить Уведомление',
        newNotification: 'Новое Уведомление',
        notifications: 'Уведомления',
        notificationPage: 'Страница Уведомление',
        notification: 'Уведомление',
        
        reviews: 'Отзывы',

        authorization: 'Авторизация',
        signup: 'Регистрация',
        agree: 'Я согласен с условиями использования и политикой конфиденциальности',
        
        help: 'Помощь',
        termsOfUse: 'Условия использования',
        privacyPolicy: 'Политика конфиденциальности',
        aboutUs: 'Про нас',
        
        informations: 'Разделы и информации',
        contacts: 'Контакты',
        
        welcomeBack: 'Привет, Добро Пожаловать',
        entrancePage: 'Страница Входа',
        entrance: 'Вход',
        allTheBest: 'Всего Доброго',
        exitPage: 'Страница Выхода',
        exit: 'Выход',
        exitIn: 'Выйти',
        verifyPage: 'Страница Подтверждения',
        resetPage: 'Страница Сброса',
        next: 'Продолжить',
        
        lang: 'Язык',
        changeLang: 'Выберите язык',

        theme: 'Тема',
        changeTheme: 'Выберите тему',

        system: 'Система',
        light: 'День',
        dark: 'Ночь',

        myRates: 'Мои оценки',
        
        discountPub: 'Объявить скидку',

        find: 'Поисковый запрос',
        filter: 'Фильтр',
        order: 'Сначала',
        news: 'Новинки',
        olds: 'Старые',
        topViews: 'Топ просматриваемые',
        topPrice: 'Дороже',
        downPrice: 'Дешевле',
        discountPrice: 'Скидка',
        topRecomended: 'Рекомендуем',
        topSelling: 'Топ продаваемость',
        topDiscount: 'Топ скидки',
        topRates: 'Топ рейтинг',

        locations: 'Области',
        markers: 'Города',
        sections: 'Секции',
        chapters: 'Разделы',
        categories: 'Категории',

        addLocation: 'Добавить Область',
        addMarker: 'Добавить Город',
        addSection: 'Создать секцию',
        addChapter: 'Добавить раздел',
        addCategory: 'Добавить категорию',

        newLocation: 'Новая Область',
        newMarker: 'Новый Город',
        newSection: 'Новая секция',
        newChapter: 'Новый раздел',
        newCategory: 'Новая категория',

        productStore: 'Продавец',
        storeProductOfProducts: 'Похожие Товары',
        storeOtherProducts: 'Другие Товары',
        storeProducts: 'Товары Магазина',
        storeBanners: 'Баннеры Магазина',
        cartProfile: 'Покупатель',
        
        media: 'Медиа',
        subMedia: 'Медиа вторая часть',
        main: 'Основные',
        confidential: 'Личные',
        deliveriesAndPayments: 'Доставка и оплата',
        priceAndDiscount: 'Цена, скидки и акции',
        other: 'Другие',
        security: 'Безопасность',
        
        name: 'Имя',
        title: 'Название',
        subTitle: 'Подзаголовок',
        login: 'Логин',
        phone: 'Телефон',
        tel: 'Тел',
        website: 'Веб-сайт',
        basicPhone: 'Основной Телефон',
        additionalPhone: 'Дополнительный Телефон',
        phonePlace: 'Номер телефона',
        otpPlace: 'СМС код',
        email: 'E-mail',
        newAddress: 'Новый Адрес',
        addAddress: 'Добавить Адрес',
        myAddresses: 'Мои Адреса',
        addresses: 'Адреса',
        address: 'Адрес',
        street: 'Улица',
        house: 'Дом',
        houseEntrance: 'Подъезд',
        houseFloor: 'Этаж',
        houseApartment: 'Квартира',
        location: 'Локация',
        marker: 'Местоположение',
        //location: 'Область',
        //marker: 'Город',
        answer: 'Ответ',
        rateLike: 'Этот отзыв получил лайк от Торгового Заведения',
        comment: 'Комментария',
        comments: 'Комментарии',
        cartComment: 'Комментарий для заказа',
        cartAddressComment: 'Комментарий для адреса',
        cartCode: 'Код заказа',
        section: 'Секция',
        chapter: 'Раздел',
        category: 'Категория',
        
        regDate: 'Зарегистрирован',
        pubDate: 'Опубликован',
        activeDate: 'Активен до',
        changeDate: 'Изменен',
        rejectedDate: 'Отклонен',
        confirmDate: 'Подтвержден',
        sentDate: 'Отправлен',
        deliveredDate: 'Доставлен',
        
        opened: 'Открыт',
        closed: 'Закрыт',
        opens: 'Открытые',
        closes: 'Закрытые',

        online: 'Онлайн',
        offline: 'Офлайн',

        workDay: 'Рабочий день',
        notWorkDay: 'Не работает',
        breakWorkDay: 'Перерыв',
        workDays: 'Рабочие дни',
        workTime: 'Рабочее время',
        workStart: 'Начало',
        workEnd: 'Конец',
        
        day1: 'Понедельник',
        day2: 'Вторник',
        day3: 'Среда',
        day4: 'Четверг',
        day5: 'Пятница',
        day6: 'Суббота',
        day7: 'Воскресенье',
        
        cartRank: 'Ранг от заказа',
        rateRank: 'Ранг от отзыва',
        rank: 'Ранг',
        rank1: 'Начальный',
        rank2: 'Бронза',
        rank3: 'Серебро',
        rank4: 'Золото',
        rank5: 'Платина',
        rank6: 'Алмаз',
        rank7: 'Популярный',
        abonimentRank: 'Ранг Подписки',
        lezzetCoin: 'Lezzet монета',
        lezzetCoinPrice: 'Цена Lezzet монеты',
        subscribe: 'Подписаться',
        unsubscribe: 'Отписаться',

        invoice: 'Счет',
        client: 'Клиент',
        payments: 'Способы оплаты',
        payment1: 'Наличные',
        payment2: 'Карта и терминал',
        payment3: 'Онлайн',
        cash: 'Наличные',
        terminal: 'Карта и терминал',

        delivery: 'Доставка',
        lezzetDeliveryTitle: "Доставка Lezzet'Sebeti",
        lezzetDelivery: "Услуга Доставка от Lezzet'Sebeti",
        storeDelivery: 'Услуга Доставка от Торгового Заведения',
        deliveryType: 'Способ доставки',
        deliveryCountry1: 'По Городу, за Город и в Велаяты',
        deliveryCountry2: 'По Городу и за Город',
        deliveryCountry3: 'По Городу',
        deliveryCountry4: 'Забрать самому',
        delivery1: 'От Торгового Заведения',
        delivery2: "От Lezzet'Sebeti",
        delivery3: 'Я сам заберу',
        inCity: 'По Городу',
        outCity: 'За Город',
        outRegion: 'В Велаяты',
        price: 'Цена',
        totalPrice: 'Общая цена',
        addedPrice: 'Добавленная стоимость',
        valute: 'ТМТ',
        summ: 'Сумма к оплате',
        minCartPrice: 'Минимальная цена заказа',
        
        size: 'Размер',
        sizes: 'Размеры',
        
        onsale: 'В продаже',
        notOnsale: 'Нет в продаже',
        notDelivery: 'Без службы доставки',
        notSelected: 'не отмечена',
        notSize: 'без размера',
        notPrice: 'без цены',
        
        delivered: 'Заказы',
        
        views: 'Просмотр',
        rate: 'Рейтинг',
        rates: 'Рейтинги',
        rateUp: 'Оцените',
        yourRate: 'Ваша оценка',
        deliveryRate: 'Оцените сервис доставки...',
        serviceRate: 'Оцените обслуживание и сервиз...',
        tasteRate: 'Оцените вкус и качество...',
        viewStatus: 'Статус видимости',
        period: 'Период',
        
        phoneVerifyTitle: 'Подтверждение',
        phoneVerify: 'Подтвердите номер телефона',
        
        forgotPassword: 'Забыли пароль',
        forgotPasswordText1: 'Введите Свой E-mail адрес и продолжите.',
        forgotPasswordText2: 'Одноразовый пароль подтверждения (из 6-ти цифр) отправлено по СМС, на основной номер телефона Торгового Заведения.',
        forgotPasswordText3: 'Введите одноразовый пароль подтверждения и подтвердите.',
        passwordRecovery: 'Восстановление пароля',
        password: 'Пароль',
        currentPassword: 'Текущий пароль',
        currentPasswordText: 'Введите текущий пароль',
        newPassword: 'Новый пароль',
        newPasswordText: 'Введите новый пароль',
        passwordRepeat: 'Повторите пароль',
        passwordRepeatErr: 'Повторный пароль не совпадает',
        passwordUpd: 'Изменить пароль',
        
        otpText1: 'Введите Свой номер телефона и продолжите.',
        otpText2: 'Одноразовый пароль подтверждения (из 6-ти цифр) отправлено по СМС, на Ваш номер телефона.',
        otpText3: 'Введите одноразовый пароль подтверждения и продолжите.',
        sendOtpMessage: "Lezzet'Sebeti одноразовый пароль для входа",
        
        avatar: 'Аватар',
        passport: 'Паспорт',
        car: 'Автомобиль',
        image: 'Фото',
        images: 'Фотографии',
        mainImage: 'Главное фото',
        newImage: 'Новое фото',
        imageI: 'Загружаемый файл должен соответствовать: Формата .jpeg, .jpg, .png, .gif и Размером не более 5-ти мегабайт.',
        video: 'Видеоролик',
        poster: 'Постер фото',
        newVideo: 'Новый видеоролик',
        videoI: 'Загружаемый файл должен соответствовать: Формата .mp4 и Размером не более 20-ти мегабайт.',
        excelI: 'Загружаемый файл должен соответствовать: Формата .xlsx, .xls.',
        
        cartCommentI: 'Введите информацию, которая относится к Вашему заказу.',
        cartAddressCommentI: 'Для услуги Доставка, опишите Свой Адрес словами.',
        cartAdressNotFoundI: 'Для услуги Доставка, Адреса не найдены.',

        trashAbonimentTitle: 'Удаление Подписки',
        trashAbonimentI: 'Запрос на удаление Подписки происходит моментально, запрос удалит все данные Подписки, включая Подписки Магазинов.',

        trashLocationTitle: 'Удаление Велаята',
        trashLocationI: 'Запрос на удаление Велаята происходит моментально, запрос удалит все данные Велаята, включая Города.',

        trashMarkerTitle: 'Удаление Города',
        trashMarkerI: 'Запрос на удаление Города происходит моментально, запрос удалит все данные Города.',

        trashCategoryTitle: 'Удаление Категории',
        trashCategoryI: 'Запрос на удаление Категории происходит моментально, запрос удалит все данные Категории.',

        trashLezzetDeliveryTitle: 'Удаление Услуги Доставки',
        trashLezzetDeliveryI: 'Запрос на удаление Услуги Доставки происходит моментально, запрос удалит все данные Услуги Доставки.',

        trashProfileTitle: 'Удаление Аккаунта',
        trashProfileI: 'Запрос на удаление Аккаунта происходит моментально, запрос удалит все данные Аккаунта, включая Сессии, Адресов, избранные Магазины, Товары и Отзывы.',

        trashProfileDataTitle: 'Удаление Данных Аккаунта',
        trashProfileDataI: 'Запрос на удаление Данных Аккаунта происходит моментально, запрос удалит все данные связанные с Аккаунтом, включая Сессии, Адресов, избранные Магазины, Товары и Отзывы.',

        trashAdressTitle: 'Удаление Адреса',
        trashAdressI: 'Запрос на удаление Адреса происходит моментально, запрос удалит все данные Адреса.',
        
        trashStoreTitle: 'Удаление Магазина',
        trashStoreI: 'Запрос на удаление Магазина происходит моментально, запрос удалит все данные Магазина, включая Товары и Отзывы.',
        
        trashRateTitle: 'Удаление Оценки',
        trashRateI: 'Запрос на удаление Оценки происходит моментально, запрос удалит все данные Оценки.',

        trashProductTitle: 'Удаление Товара',
        trashProductI: 'Запрос на удаление Товара происходит моментально, запрос удалит все данные Товара.',
        
        trashCartTitle: 'Очистить корзину',
        trashCartI: 'В корзине существует не подтвержденный товар из другого Магазина. Чтобы сделать новый заказ, подтвердите имеющийся заказ или очистите корзину.',
        trashCartI2: 'Вы действительно хотите чистить корзину?',
        
        trashNewCartTitle: 'Удаление Заказа',
        trashNewCartI: 'Запрос на удаление Заказа происходит моментально, запрос удалит все данные Заказа.',
        
        notConfirmedCartPushTitle: 'Не подтвержденный заказ',
        notConfirmedCartPushI: 'Номер заказа',

        newCartPushTitle: 'Поступил новый заказ',
        newCartPushI: 'Номер заказа',

        confirmCartTitle: 'Подтверждение заказа',
        confirmCartI: 'Вы, действительно хотите подтвердить текущий заказ?',

        confirmCartPushTitle: 'Заказ подтвержден',
        confirmCartPushI: 'Номер заказа',

        sentCartTitle: 'Отправление заказа',
        sentCartI: 'Вы, действительно хотите отправить текущий заказ получателю?',

        sentCartPushTitle: 'Заказ отправлен',
        sentCartPushI: 'Номер заказа',

        deliveredCartTitle: 'Доставка заказа',
        deliveredCartI: 'Вы, действительно доставили текущий заказ получателю?',

        courierCartPushTitle: 'Назначен новый заказ',
        courierCartPushI: 'Номер заказа',

        newCourierCartPushTitle: 'Назначен курьер',
        newCourierCartPushI: 'Номер заказа',

        rateCartStorePushI: 'Не забудьте оставить ваш отзыв',

        rejectCartTitle: 'Отклонение заказа',
        rejectCartI: 'Вы, действительно хотите отклонить текущий заказ?',

        rejectCartPushTitle: 'Заказ отклонен',
        rejectCartPushI: 'Номер заказа',

        trashServiceTitle: 'Удаление Услуги',
        trashServiceI: 'Запрос на удаление Услуги происходит моментально, запрос удалит все данные Услуги.',
        
        trashBannerTitle: 'Удаление Баннера',
        trashBannerI: 'Запрос на удаление Баннера происходит моментально, запрос удалит все данные Баннера.',
        
        trashAdsTitle: 'Удаление Рекламы',
        trashAdsI: 'Запрос на удаление Рекламы происходит моментально, запрос удалит все данные Рекламы.',

        navigations: 'Навигации',
        myNavigations: 'Мои навигации',
        history: 'История просмотров',
        myFavorites: 'Избранные',
        myRatedStores: 'Оцененные мной',
        favorites: 'Нравится',
        topFavorites: 'Топ избранные',

        menu: 'Меню',
        back: 'Назад',
        select: 'Выбрать',
        choose: 'Выберите',
        chooseData: 'Выберите Данные',
        show: 'Показать',
        hide: 'Скрыть',
        all: 'Все',
        send: 'Отправить',
        sendPhone: 'Отправьте номер телефона',
        add: 'Добавить',
        addCart: 'В корзину',
        create: 'Создать',
        read: 'Прочитать',
        update: 'Обновить',
        reset: 'Сбросить',
        delete: 'Удалить',
        recycle: 'Очистить',
        remove: 'Убрать',
        change: 'Изменить',
        confirm: 'Подтвердить',
        confirmPhone: 'Подтвердите номер телефона',
        block: 'Заблокировать',
        deliver: 'Доставлен',
        reject: 'Отклонить',
        warning: 'Предупреждение',
        info: 'Описание',
        about: 'Подробно',
        aboutInfo: 'Подробная информация',
        print: 'Распечатать',

        required: 'Обязательно',
        min: 'Минимум',
        max: 'Максимум',
        pattern: 'Допустимые символы',
        numbers: 'числа',
        strings: 'строки',
        symbols: 'символы',

        distance: 'Дистанция',
        year: 'год',
        years: 'годов',
        day: 'день',
        days: 'дней',
        hour: 'час',
        hours: 'часов',
        minut: 'минута',
        minutes: 'минуты',
        second: 'секунд',
        seconds: 'секунды',
        kilometr: 'км',
        kilometros: 'км-ов',
        metr: 'метр',
        metros: 'метров',

        powered: 'Включена',
        ok: 'Да',
        not: 'Нет',
        cancel: 'Отмена',

        quantity: 'Итого',
        count: 'Кол-во',
        pcs: 'штук',
        from: 'от',

        privilege: 'Привилегия',
        privilege1: 'Супер',
        privilege2: 'Средний',
        privilege3: 'Обычный',
        privilege4: 'Низкий',

        error: 'Ошибка',
        error1: 'Ошибка: Запрашиваемый роут не найден',
        error2: 'Отправлено недостаточно данных',
        error3: 'Отправленные данные неверные',
        error4: 'Несоответствие формата или размера',
        error5: 'Запрос был отклонен',
        error6: 'Служба Доставки с таким Местоположением существует',

        error100: 'Аккаунт не найден',
        error101: 'Аккаунт не подтвержден',
        error102: 'Аккаунт заблокирован',
        error103: 'Ошибка статуса Аккаунта',
        error104: 'Вы не Авторизованы',
        error105: 'Существует Авторизованный Аккаунт',
        error106: 'Ваши привилегии не соответствуют указанным',
        error107: 'Аккаунт с таким Логином не найден',
        error108: 'Аккаунт с таким Логином существует',
        error109: 'Аккаунт с таким номером телефона не найден',
        error110: 'Аккаунт с таким номером телефона существует',
        error111: 'Аккаунт с таким E-mail адресом не найден',
        error112: 'Аккаунт с таким E-mail адресом существует',
        error113: 'Неверный пароль',
        error114: 'Просроченный токен',
        error115: 'Неверный токен',
        error116: 'Сессия не найдена',
        error117: 'Текущая Сессия не может быть удалена',
        error118: 'Одноразовый пароль не найден',
        error119: 'Аккаунт с таким Именем, Местоположением и с таким номером телефона существует',
        error120: 'Разрешение на доступ к местоположению отключен.',
        error121: 'Не удалось определить местоположение. Убедитесь, что Ваш поставщик услуг определения местоположения включен.',
        error122: 'Разрешение на получение push-уведомлений отключен.',
        error123: 'Не удалось получить push-token. Пожалуйста, используйте физическое устройство.',
        error124: 'Этот номер телефона уже используется в качестве основного номера телефона.',
        error125: 'Этот номер телефона в настоящее время используется в качестве основного номера телефона.',
        error126: 'Этот номер телефона уже используется в качестве дополнительного номера телефона.',
        error127: 'Этот номер телефона в настоящее время используется в качестве дополнительного номера телефона.',

        error200: 'Магазин не найден',
        error201: 'Магазин не подтвержден',
        error202: 'Магазин заблокирован',
        error203: 'Ошибка статуса Магазина',
        error204: 'Магазин с таким Названием, Местоположением, Категорией и с таким E-mail адресом существует',
        error205: 'Магазин закрыт',
        error206: 'Ожидание рабочего дня Магазина',
        error207: 'Ожидание рабочего времени Магазина',
        error208: 'Услуга доставки ограничена',
        error209: 'Без услуги доставки',
        error210: 'У Магазина существует имеющаяся Подписка',
        error211: 'У Магазина не существует имеющаяся Подписка',
        error212: 'Магазин с таким E-mail адресом существует',

        error300: 'Товар не найден',
        error301: 'Товар не подтвержден',
        error302: 'Товар заблокирован',
        error303: 'Ошибка статуса Товара',
        error304: 'Товар с таким Названием и с такой Категорией существует',

        error400: 'Услуга не найдена',
        error401: 'Услуга не подтверждена',
        error402: 'Услуга заблокирована',
        error403: 'Ошибка статуса Услуги',
        error404: 'Услуга с таким Названием, Местоположением и с такой Категорией существует',

        error500: 'Заказ не найден',
        error501: 'Заказ не подтвержден',
        error502: 'Заказ заблокирован',
        error503: 'Ошибка статуса Заказа',
        error504: 'Не правильный адрес или адрес не входит границам службы доставки',
        error505: 'Для этого Заказа пока не назначен Курьер',

        error600: 'Баннер не найден',
        error601: 'Баннер не подтвержден',
        error602: 'Баннер заблокирован',
        error603: 'Ошибка статуса Баннера',

        error700: 'Реклама не найдена',
        error701: 'Реклама не подтверждена',
        error702: 'Реклама заблокирована',
        error703: 'Ошибка статуса Рекламы',

        error800: 'Локация с таким Названием существует',
        error801: 'Местоположение с таким Названием существует',
        error802: 'Раздел с таким Названием существует',
        error803: 'Категория с таким Названием существует',
        error804: 'Подкатегория с таким Названием существует',
        error805: 'Навык с таким Названием существует',

        error900: 'Рейтинг не найден',
        error904: 'Рейтинг не принят',

        error1000: 'Подписка не найдена',
        error1004: 'Активная Подписка с такими параметрами существует',

        success: 'Успех',
        success100: 'Успешно',
        success101: 'Вы успешно Авторизованы',
        success102: 'Вы успешно Зарегистрированы',
        success103: 'Всего Доброго',
        success104: 'Успешно создана',
        success105: 'Успешно добавлена',
        success106: 'Успешно обновлена',
        success107: 'Успешно изменена',
        success108: 'Успешно подтверждена',
        success109: 'Успешно удалена',
        success110: 'Ваш заказ успешно принят. Вам перезвонит Оператор для подтверждения заказа',
        success111: 'Успешно отправлено',
        
        viewStatus1: 'Актив',
        viewStatus2: 'Новый',
        viewStatus3: 'Изменен',
        viewStatus4: 'Заблок-н',
        viewStatus5: 'Подтвержден',
        viewStatus6: 'Отправлен',
        viewStatus7: 'Доставлен',
        viewStatus9: 'Отклонен',
        
        status: 'Статус',
        status1: 'Активен',
        status2: 'В ожидании подтверждения',
        status3: 'Проверяется на изменения',
        status4: 'Заблокирован',
        status5: 'Подтвержден',
        status6: 'Отправлен',
        status7: 'Доставлен',
        status9: 'Отклонен',
        status10: 'Не найдена',
        
        panelStatus1: 'Активно',
        panelStatus2: 'Новые',
        panelStatus3: 'Изменено',
        panelStatus4: 'Заблокировано',
        panelStatus5: 'Подтверждено',
        panelStatus6: 'Отправлено',
        panelStatus7: 'Доставлено',
        panelStatus9: 'Отклонено',

        appDescription1: "Lezzet'Sebeti – платформа онлайн покупок.",
        appDescription2: "Мы собираемся приблизить мечту каждого человека в реальность.",
        appDescription3: "Наша цель добавить свой вклад на то чтобы мир стал еще лучше и удобней.",
        appSupport: "Если у вас возникли другиe вопросы, пишите на наш E-mail адрес.",
        copyright: "Все Авторские права защищены 2024 год.",

        appAboutUs: "Про нас:",
        appAboutUs1: "1. Цель Lezzet'Sebeti предоставить возможности, повышения маркетинга всем физическим или юридическим лицам, занимающиеся сферой торговли. А так же лицам в поисках своих нужд находить свои потребности быстро и эффективно.",
        appAboutUs2: "2. В наши дополнительные услуги входят:",
        appAboutUsServices: "Реклама баннер, постраничная реклама: реклама Вашего Торгового Заведения, товаров и размещение других похожих реклам.",
        appAboutUsQuestionsAndAnswers: "Ответы на вопросы:",
        appAboutUsQuestion1: "1. Что представляет Lezzet'Sebeti?",
        appAboutUsAnswer1: "Lezzet'Sebeti предоставляет возможности, повышения маркетинга всем физическим или юридическим лицам, занимающиеся сферой торговли. А так же лицам в поисках своих нужд находить свои потребности быстро и эффективно.",
        appAboutUsQuestion2: "2. Я могу разместить свое Торговое Заведение на Lezzet'Sebeti?",
        appAboutUsAnswer2: "Да, если Вы занимаетесь сферой торговли, Вы можете разместить свое Торговое Заведение без каких либо трудностей. Для этого свяжитесь с Администратором.",
        appAboutUsQuestion3: "3. Регистрация на Lezzet'Sebeti объязательная?",
        appAboutUsAnswer3: "Нет, не объязательная. Но, после регистрации на Lezzet'Sebeti, появятся больше возможностей как, совершать заказы, давать рейтинг балы, оставлять отзывы, добавлять понравившиеся Торговые Заведения или товары в историю мои избранные и другиe дальнейшие действия.",
        
        termsOfUseTitle: "Каждый человек, кто получает доступ к этому сайту, программе и использует его в настоящее время, свидетельствует о том, что  соглашается с настоящими Условиями Использования.",

        termsOfUseUsers: "Пользователям:",
        termsOfUseUsers1: "1. Lezzet'Sebeti представляет возможности Пользователям, находить товары под свои нужды и потребности.",
        termsOfUseUsers2: "2. Lezzet'Sebeti не несёт ответственность за Пользователя и за его выбор. Наша цель, предоставить Пользователю возможность находить нужную ему потребность в объявлениях товаров от Торговых Заведений.",
        termsOfUseUsers3: "3. Lezzet'Sebeti не несёт ответственность за оплату или предоплату товаров, а так же за гарантию качества и за цену товара. Не оплачивайте товар пока не получите и не осмотрите лично. Всё что вы делаете и совершаете на Lezzet'Sebeti, делаете на свой риск и страх.",
        termsOfUseUsers4: "4. Прежде чем, совершать заказ от Торговых Заведений, прочитайте отзывы оставленные со стороны других Пользователей и сравните рейтинг.",
        termsOfUseUsers5: "5. Пользователи имеют возможность добавлять понравившиеся Торговые Заведения или товары в историю мои избранные, а также давать Рейтинг балы и оставлять отзывы Торговым Заведениям, после совершения заказа.",
        termsOfUseUsers6: "6. Перечень правил для отзывов:",
        termsOfUseUsersComment1: "• Отзыв не должен содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство, мат.",
        termsOfUseUsersComment2: "• Отзыв не должен содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.",
        termsOfUseUsers7: "7. При нарушении приведенных правил Администратор имеет право удалить и заблокировать Пользователя без объяснения и причин.",
        termsOfUseUsers8: "8. Пользователь несёт полную ответственность за свои любые действия и совершания на Lezzet'Sebeti.",
        termsOfUseUsers9: "9. Lezzet'Sebeti не вмешивается и не состоит в договоре между Пользователями и Торговыми Заведениями.",
        termsOfUseUsers10: "10. Lezzet'Sebeti не вмешивается и не состоит в купле-продаже между Пользователями и Торговыми Заведениями.",

        termsOfUseStores: "Торговым Заведениям:",
        termsOfUseStores1: "1. Lezzet'Sebeti представляет услуги и возможности Торговым Заведениям, предложить и продавать свои товары и услуги онлайн.",
        termsOfUseStores2: "2. Lezzet'Sebeti не несёт ответственность за Торговое Заведение, его действиям и за его объявлений. Наша цель, предоставить Торговому Заведению возможность предложить и продавать свои товары и услуги онлайн.",
        termsOfUseStores3: "3. Lezzet'Sebeti не несёт ответственность за не уплату заказа (кроме случаев: если доставка осуществляется со стороны Lezzet'Sebeti и онлайн оплаты), Всё что вы делаете и совершаете на Lezzet'Sebeti, делаете на свой риск и страх.",
        termsOfUseStores4: "4. Lezzet'Sebeti имеет право удалять и заблокировать объявления товаров или услуг без объяснения и причин, также если товар или услуга не соответствует правилам Lezzet'Sebeti. Все объявления проверяются Администраторами Lezzet'Sebeti.",
        termsOfUseStores5: "5. Перечень правил для объявлений:",
        termsOfUseStoresAnnouncement1: "• Объявление не должно содержать товары или услуги не соответствующие законодательству Туркменистана.",
        termsOfUseStoresAnnouncement2: "• Объявление не должно содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство,  мат.",
        termsOfUseStoresAnnouncement3: "• Объявление не должно содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.",
        termsOfUseStoresAnnouncement4: "• Объявление не должно содержать фотографии психического или религиозного внушения, а также запрещается фотографии насилия, издевательство или нецензурного характера.", 
        termsOfUseStoresAnnouncement5: "• Торговое Заведение не имеет право добавить объявления товара или услуги без описания и фотографии.", 
        termsOfUseStoresAnnouncement6: "• Торговое Заведение не имеет право добавить объявления товаров или услуг не являющийся его собственностью.", 
        termsOfUseStores6: "6. Торговые Заведения имеют возможность оставлять ответы на отзывы, оставленные Пользователями.",
        termsOfUseStores7: "7. Перечень правил для ответов:",
        termsOfUseStoresComment1: "• Ответ не должен содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство, мат.",
        termsOfUseStoresComment2: "• Ответ не должен содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.", 
        termsOfUseStores8: "8. Администраторы Lezzet'Sebeti имеют право удалять и заблокировать Торговое Заведение и его Правообладателя без объяснения и причин.", 
        termsOfUseStores9: "9. Торговое Заведение и его Правообладатель несёт полную ответственность за свои любые действия и совершения на Lezzet'Sebeti.",
        termsOfUseStores10: "10. Lezzet'Sebeti не вмешивается и не состоит в договоре между Пользователями и Торговыми Заведениями.",
        termsOfUseStores11: "11. Lezzet'Sebeti не вмешивается и не состоит в купле-продаже между Пользователями и Торговыми Заведениями.",

        privacyPolicyTitle: "Каждый человек, кто получает доступ к этому сайту или программе и использует его в настоящее время, свидетельствует о том, что соглашается с настоящим Политикой Конфиденциальности.",

        privacyPolicyDataUsers: "Пользователям:",
        privacyPolicyDatasUsersScroll: "Перечень действий, с Персональными данными Пользователя:",
        privacyPolicyDatasUsers: "На Lezzet'Sebeti собираются следующие Персональные данные: Зарегистрированные номера телефонов, имя (настоящее или присвоенное, рандомное), адреса, отзывы и информация о заказах Пользователей.",
        privacyPolicyDataUsersPhone: "Зарегистрированный номер телефона Пользователя:",
        privacyPolicyDataUsersPhone1: "1. Зарегистрированным номером телефона Пользователя является: Введенный номер телефона Пользователем при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone2: "2. После того, как Пользователь зарегистрировался на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone3: "3. Зарегистрированный номер телефона на Lezzet'Sebeti, служит для подтверждения личности, для связи с Пользователем и для подтверждения заказа, а также для идентифицирования Пользователя на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone4: "4. Зарегистрированный номер телефона Пользователя, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersName: "Имя Пользователя:",
        privacyPolicyDataUsersName1: "1. Имя Пользователя является: Введенный имя Пользователем или рандомное имя присвоенное после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersName2: "2. После того, как Пользователь изменил имя, его имя сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersName3: "3. Имя, служит для подтверждения личности и для подтверждения заказа.",
        privacyPolicyDataUsersName4: "4. Имя Пользователя, не указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress: "Адрес Пользователя:",
        privacyPolicyDataUsersAddress1: "1. Адресом Пользователя является: Добавленный адрес Пользователем на Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress2: "2. После того, как Пользователь добавил адрес, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress3: "3. Адрес, служит для доставки заказа в пункт назначения.",
        privacyPolicyDataUsersAddress4: "4. Адрес Пользователя, указывается в обязательном порядке, при совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersRate: "Отзыв Пользователя:",
        privacyPolicyDataUsersRate1: "1. Отзывом Пользователя является: Добавленный отзыв Торговому Заведению Пользователем, после совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersRate2: "2. После того, как Пользователь добавил отзыв, его отзыв сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersRate3: "3. Отзыв, служит для получения информации о качестве доставки, обслуживания сервиза и впечатление от товаров.",
        privacyPolicyDataUsersRate4: "4. Отзыв Пользователя, не указывается в обязательном порядке, после совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersCart: "Информация о заказах Пользователя:",
        privacyPolicyDataUsersCart1: "1. Информацией о заказах Пользователя является: Совершенные заказы Пользователем от Торговых Заведений на Lezzet'Sebeti.",
        privacyPolicyDataUsersCart2: "2. После того, как Пользователь совершил заказ, его заказ сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе со стороны Торгового Заведения и Курьера, где был совершен заказ.",
        privacyPolicyDataUsersCart4: "4. Информация о заказе Пользователя, указывается в обязательном порядке, при совершении заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersShopping: "Перечень действий от заказа до, его получения:",
        privacyPolicyDataUsersShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataUsersShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataUsersShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataUsersEncryptTitle: "Все полученные или переданные Персональные данные Пользователя на сервере Lezzet'Sebeti, совершаются через шифрование данных.",

        privacyPolicyDataStores: "Торговым Заведениям:",
        privacyPolicyDatasStoresScroll: "Перечень действий, с Персональными данными Торгового Заведения:",
        privacyPolicyDatasStores: "На Lezzet'Sebeti собираются следующие Персональные данные: Название, медиафайлы, номера телефонов, E-mail адрес, рабочие дни, информация по доставке, информация о спобах оплаты, адрес, информация о товарах и услугах, и информация о заказах Торгового Заведения.",
        privacyPolicyDataStoresTitle: "Название Торгового Заведения:",
        privacyPolicyDataStoresTitle1: "1. Название Торгового Заведения является: Введенное Название, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle2: "2. После того, как Торговое Заведение зарегистрировался на Lezzet'Sebeti, его Название сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle3: "3. Название, служит для подтверждения объекта как Торговое Заведение и для продолжения своей деятельности на Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle4: "4. Название Торгового Заведения, указывается в обязательном порядке при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia: "Медиафайлы Торгового Заведения:",
        privacyPolicyDataStoresMedia1: "1. Медиафайлами Торгового Заведения является: Видео или фото файлы, загруженные Торговым Заведением, на сервер Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia2: "2. После того, как Торговое Заведение загруружает медиафайл на Lezzet'Sebeti, его медиафайл сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia3: "3. Медиафайлы, служат для визуального подтверждения информации об объекте Торговое Заведение и для визуального подтверждения информации о товарах и услугах Торгового Заведения на Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia4: "4. Медиафайлы Торгового Заведения, указываются в обязательном порядке после регистрации, а также после добавления товаров и услуг на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone: "Номера телефонов Торгового Заведения:",
        privacyPolicyDataStoresPhone1: "1. Номера телефонов Торгового Заведения являются: Введенный основной номер телефона Торгового Заведения, при регистрации на Lezzet'Sebeti, а также добавленный позже дополнительный номер телефона Торгового Заведения после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone2: "2. После того, как Торговое Заведение зарегистрировался с основным номером телефона или добавил позже дополнительный номер телефона на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone3: "3. Основной или дополнительный номера телефонов на Lezzet'Sebeti, служат для связи с Торговым Заведением, а также для подтверждения заказов на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone4: "4. Основной номер телефона Торгового Заведения, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail: "E-mail адрес Торгового Заведения:",
        privacyPolicyDataStoresEmail1: "1. E-mail адрес Торгового Заведения является: Введенный E-mail адрес Торгового Заведения, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail2: "2. После того, как Торговое Заведение зарегистрировался на Lezzet'Sebeti, его E-mail адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail3: "3. E-mail адрес на Lezzet'Sebeti, служит для связи с Торговым Заведением, а также для идентифицирования Торгового Заведения на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail4: "4. E-mail адрес Торгового Заведения, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays: "Рабочие дни Торгового Заведения:",
        privacyPolicyDataStoresWorkDays1: "1. Рабочие дни Торгового Заведения является: Указанные рабочие дни Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays2: "2. После того, как Торговое Заведение указал рабочие дни на Lezzet'Sebeti, его рабочие дни сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays3: "3. Рабочие дни, служат для получения информации Торгового Заведения о статусе работает или не работает на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays4: "4. Рабочие дни Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery: "Информация по доставке Торгового Заведения:",
        privacyPolicyDataStoresDelivery1: "1. Информация по доставке Торгового Заведения является: Указанные методы и способы по доставке Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery2: "2. После того, как Торговое Заведение указал методы и способы по доставке на Lezzet'Sebeti, его методы и способы по доставке сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery3: "3. Информация по доставке, служит для получения информации Торгового Заведения о методах и способах по доставке на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery4: "4. Информация по доставке Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment: "Информация о спобах оплаты Торгового Заведения:",
        privacyPolicyDataStoresPayment1: "1. Информация о спобах оплаты Торгового Заведения является: Указанные способы оплаты Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment2: "2. После того, как Торговое Заведение указал способы оплаты на Lezzet'Sebeti, его способы оплат сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment3: "3. Информация о спобах оплаты, служит для получения информации Торгового Заведения о способах оплаты на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment4: "4. Информация о спобах оплаты Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress: "Адрес Торгового Заведения:",
        privacyPolicyDataStoresAddress1: "1. Адрес Торгового Заведения является: Введенный адрес Торгового Заведения, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress2: "2. После того, как Торговое зарегистрировался на Lezzet'Sebeti, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress3: "3. Адрес, служит для получения информации о местоположении Торгового Заведения на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress4: "4. Адрес Торгового Заведения, указывается в обязательном порядке при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct: "Информация о товарах и услугах Торгового Заведения:",
        privacyPolicyDataStoresProduct1: "1. Информация о товарах и услугах Торгового Заведения является: Введенная информация Торговым Заведением, при добавление каждого товара или услуги на Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct2: "2. После того, как Торговое Заведение добавил информацию о товаре или услуге на Lezzet'Sebeti, его информация о товаре или услуге сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct3: "3. Информация о товарах и услугах, служат для получения информации о товарах и услугах Торгового Заведения, а также для идентифицирования каждого отдельного товара или услуги на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct4: "4. Информация о товарах и услугах Торгового Заведения, указывается в обязательном порядке, при добавление каждого товара или услуги на Lezzet'Sebeti.",
        privacyPolicyDataStoresCart: "Информация о заказах Торгового Заведения:",
        privacyPolicyDataStoresCart1: "1. Информацией о заказах Торгового Заведения является: Совершенные заказы Пользователем от Торгового Заведения, на Lezzet'Sebeti.",
        privacyPolicyDataStoresCart2: "2. После того, как Торговое Заведение получил, принял, отправил или доставил заказ от Пользователя, статус заказа меняется на новый, подтвержденный, отправлено или доставлено на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе.",
        privacyPolicyDataStoresCart4: "4. Информация о заказе Торгового Заведения, сохраняется в обязательном порядке, после совершении заказа на Lezzet'Sebeti.",
        privacyPolicyDataStoresShopping: "Перечень действий от заказа, до его получения:",
        privacyPolicyDataStoresShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataStoresShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataStoresShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataStoresEncryptTitle: "Все полученные или переданные Персональные данные Торгового Заведения на сервере Lezzet'Sebeti, совершаются через шифрование данных.",

        privacyPolicyDataCouriers: "Курьерам:",
        privacyPolicyDatasCouriersScroll: "Перечень действий, с Персональными данными Курьера:",
        privacyPolicyDatasCouriers: "На Lezzet'Sebeti собираются следующие Персональные данные: Имя (настоящее или присвоенное, рандомное), номера телефона, адреса, фотографии (личное, транспорта и пасспорта) и информация о заказах Курьеров.",
        privacyPolicyDataCouriersName: "Имя Курьера:",
        privacyPolicyDataCouriersName1: "1. Имя Курьера является: Введенный имя Курьером или рандомное имя присвоенное после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersName2: "2. После того, как Курьер изменил имя, его имя сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersName3: "3. Имя, служит для подтверждения личности и для подтверждения заказа, а также для идентифицирования Курьера, как сотрудник на Lezzet'Sebeti.",
        privacyPolicyDataCouriersName4: "4. Имя Курьера, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone: "Номер телефона Курьера:",
        privacyPolicyDataCouriersPhone1: "1. Номер телефона Курьера является: Введенный номер телефона Курьера при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone2: "2. После того, как Курьер зарегистрировался на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone3: "3. Номер телефона на Lezzet'Sebeti, служит для подтверждения личности, для связи с Курьером и для подтверждения заказа, а также для идентифицирования Курьера на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone4: "4. Номер телефона Курьера, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress: "Адрес Курьера:",
        privacyPolicyDataCouriersAddress1: "1. Адресом Курьера является: Введенный адрес Курьера при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress2: "2. После того, как Курьер зарегистрировался на Lezzet'Sebeti, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress3: "3. Адрес, служит для получения информации о место проживания Курьера, а также для получения заказов по место проживанию.",
        privacyPolicyDataCouriersAddress4: "4. Адрес Курьера, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto: "Фотографии Курьера:",
        privacyPolicyDataCouriersPhoto1: "1. Фотографии Курьера являются: Фото файлы, загруженные Курьером, на сервер Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto2: "2. После того, как Курьер загруружает фото файл на Lezzet'Sebeti, его фото файл сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto3: "3. Фотографии, служат для визуального подтверждения информации о Курьере и для визуального подтверждения информации о транспорте Курьера, а также для идентифицирования Курьера, как сотрудник на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto4: "4. Фотографии Курьера, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart: "Информация о заказах Курьера:",
        privacyPolicyDataCouriersCart1: "1. Информацией о заказах Курьера является: Порученные заказы от Lezzet'Sebeti к Курьеру, для доставки заказов в пункт назначения на Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart2: "2. После того, как к Курьеру был поручен заказ, его заказ сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе.",
        privacyPolicyDataCouriersCart4: "4. Информация о заказе Курьера, указывается в обязательном порядке, при поручении заказа на Lezzet'Sebeti.",
        privacyPolicyDataCouriersShopping: "Перечень действий от заказа, до его получения:",
        privacyPolicyDataCouriersShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataCouriersShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataCouriersShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataCouriersEncryptTitle: "Все полученные или переданные Персональные данные Курьера на сервере Lezzet'Sebeti, совершаются через шифрование данных."
    },
    en: {
        app: "Lezzet'Sebeti",
        appStore: "Lezzet'Store",
        appGo: "Lezzet'Go",
        
        appUpdateVersionTitle: "Software!",
        appUpdateVersionDescription: "This software has been updated, please update it to the latest version!",

        loading: 'LOADING',
        loadMore: 'Load more',
        pageNotFound: 'Error: 404 - page not found',
        unknownScreen: 'Unknown screen',
        install: "Installing the Lezzet'Sebeti app",

        logo: 'Logo',
        logos: 'Logos',

        start: 'Get Started',
        startIn: 'Get Started Here',

        sessions: 'Connected Devices',

        pages: 'Pages',
        viewPages: 'Show Pages',
        otherPages: 'Other Pages',

        shoppingCenters: 'Trading Establishments',
        shoppingCenter: 'Trading Establishment',

        homePage: 'Home Page',
        home: 'Home',

        adminPanelPage: 'Admin-panel Page',
        adminPanel: 'Admin-panel',
        panelPage: 'Panel Page',
        panel: 'Panel',

        createRankAbonimentPage: 'Create Rank Subscription Page',
        setRankAbonimentPage: 'Rank Subscription Settings Page',
        createRankAboniment: 'Create Rank Subscription',
        newRankAboniment: 'New Rank Subscription',
        rankAbonimentPage: 'Rank Subscription Page',
        rankAboniment: 'Rank Subscription',
        rankAbonimentStoresPage: 'Rank Subscription Stores Page',
        rankAbonimentStores: 'Rank Subscription Stores',
        rankAbonimentTitle: 'Earn while you eat',
        rankAbonimentTableTitle: 'Rank from Earn while you eat',
        
        promotions: 'Promotions',
        promotionAboniment: '1+1 Promotion',

        subscribesStores: 'Subscribed Stores',

        adminsPage: 'Administrators Page',
        createAdminPage: 'Create Administrator Page',
        setAdminPage: 'Settings Administrator Page',
        createAdmin: 'Create Administrator',
        setAdmin: 'Settings Administrator',
        newAdmin: 'New Administrator',
        admins: 'Administrators',
        adminPage: 'Administrator Page',
        admin: 'Administrator',
        
        lDeliverysPage: 'Delivery Services Page',
        createLDeliveryPage: 'Create Delivery Service Page',
        setLDeliveryPage: 'Delivery Service Settings Page',
        setLDelivery: 'Delivery Service Settings',
        createLDelivery: 'Create Delivery Service',
        newLDelivery: 'New Delivery Service',
        lDeliverys: 'Delivery Services',
        lDeliveryPage: 'Delivery Service Page',
        lDelivery: 'Delivery Service',
        
        couriersPage: 'Couriers Page',
        createCourierPage: 'Create Courier Page',
        setCourierPage: 'Courier Settings Page',
        setCourier: 'Courier Settings',
        createCourier: 'Create Courier',
        newCourier: 'New Courier',
        couriers: 'Couriers',
        courierPage: 'Courier Page',
        courier: 'Courier',
        courierCartsPage: 'Courier Orders Page',
        courierNotificationsPage: 'Courier Notifications Page',

        cartPage: 'Cart Page',
        shopsPage: 'Orders Page',
        shopPage: 'Order Page',
        shop: 'Order',
        setShopPage: 'Order Settings Page',
        setShop: 'Order Settings',
        storeShops: 'Orders',
        storeNewShops: 'Current Orders',
        courierShops: 'Orders',
        courierNewShops: 'Current Orders',
        profileShops: 'Purchases',
        profileNewShops: 'Pending Orders',
        historyShops: 'Order history',
        cart: 'Cart',
        confirmCart: 'Order confirmation',
        newCarts: 'New Orders',
        confirmedCarts: 'Confirmed Orders',
        sentedCarts: 'Sent Orders',
        deliveredCarts: 'Sent Orders',
        receivedCarts: 'Received Orders',
        rejectedCarts: 'Rejected Orders',
        
        profilesPage: 'Users Page',
        profiles: 'Users',
        profilePage: 'User Page',
        setProfilePage: 'User Settings Page',
        setProfile: 'User Settings',
        profileDataPage: 'User Details Page',
        profileData: 'User Details',
        profileDataTrash: 'Delete User Details',
        profileTrash: 'Delete User',
        profile: 'Profile',
        profileSet: 'Edit Profile',
        profileCartsPage: 'User Orders Page',
        profileNotificationsPage: 'User Notifications Page',

        addressesPage: 'Addresses Page',
        addAddressPage: 'Add Address Page',

        myFavoriteStoresPage: 'Favorite Stores Page',
        myFavoriteProductsPage: 'Favorite Products Page',
        myRatedStoresPage: 'Rated by me Stores Page',
        recomendedStoresPage: 'Recomended Stores Page',

        profileCurrentRatesPage: 'My Reviews Page',
        profileCurrentRates: 'My Reviews',
        profilePendingRatesPage: 'Pending Reviews Page',
        profilePendingRates: 'Pending Reviews',

        currentRatesPage: 'Reviews Page',
        currentRates: 'Reviews',
        pendingRatesPage: 'Pending Reviews Page',
        pendingRates: 'Pending Reviews',

        settingsPage: 'Settings Page',
        settings: 'Settings',
        
        discountStoresPage: 'Discount Stores Page',
        promotionStoresPage: 'Promotion Stores Page',
        lezzetDeliveryStoresPage: 'Lezzet Ddelivery Stores Page',
        rankStoresPage: 'Earn while you eat rank Stores Page',

        storesPage: 'Stores Page',
        createStorePage: 'Open Store Page',
        setStorePage: 'Store Settings Page',
        setStore: 'Store Settings',
        createStore: 'Open Store',
        newStore: 'New Store',
        stores: 'Stores',
        storePage: 'Store Page',
        store: 'Store',
        storeBannersPage: 'Store Banners Page',
        storeProductsPage: 'Store Products Page',
        storeCreateProductPage: 'Add Product Page',
        storeCartsPage: 'Store Orders Page',
        storeNotificationsPage: 'Store Notifications Page',
        
        productsPage: 'Products Page',
        addProduct: 'Add Product',
        addProducts: 'Add Products',
        newProduct: 'New Product',
        newProducts: 'New Products',
        products: 'Products',
        productPage: 'Product Page',
        setProductPage: 'Product Settings Page',
        setProduct: 'Product Settings',
        product: 'Product',
        
        bannersPage: 'Banners Page',
        setBannerPage: 'Banner Settings Page',
        setBanner: 'Banner Settings',
        addBanner: 'Add Banner',
        newBanner: 'New Banner',
        banners: 'Banners',
        bannerPage: 'Banner Page',
        banner: 'Banner',

        advertisingsPage: 'Advertisements Page',
        addAdvertising: 'Add Advertisement',
        newAdvertising: 'New Advertising',
        advertisings: 'Advertisements',
        advertisingPage: 'Advertising Page',
        advertising: 'Advertising',

        notificationsPage: 'Notifications Page',
        setNotificationPage: 'Settings Page Notifications',
        addNotification: 'Add Notice',
        newNotification: 'New Notice',
        notifications: 'Notifications',
        notificationPage: 'Notification page',
        notification: 'Notification',
        
        reviews: 'Reviews',

        authorization: 'Authorization',
        signup: 'Registration',
        agree: 'I agree to the terms of use and privacy policy',
        
        help: 'Help',
        termsOfUse: 'Terms of use',
        privacyPolicy: 'Privacy policy',
        aboutUs: 'About us',
        
        informations: 'Sections and information',
        contacts: 'Contacts',
        
        welcomeBack: 'Hello, Welcome',
        entrancePage: 'Login Page',
        entrance: 'Entrance',
        allTheBest: 'All the best',
        exitPage: 'Exit Page',
        exit: 'Exit',
        exitIn: 'Log out',
        verifyPage: 'Confirmation Page',
        resetPage: 'Reset Page',
        next: 'Continue',
        
        lang: 'Language',
        changeLang: 'Select language',

        theme: 'Theme',
        changeTheme: 'Select a theme',

        system: 'System',
        light: 'Day',
        dark: 'Night',

        myRates: 'My ratings',
        
        discountPub: 'Announce discount',

        find: 'Search term',
        filter: 'Filter',
        order: 'First',
        news: 'New',
        olds: 'Old',
        topViews: 'Top viewed',
        topPrice: 'More expensive',
        downPrice: 'Cheaper',
        discountPrice: 'Discount',
        topRecomended: 'Recommended',
        topSelling: 'Top sales',
        topDiscount: 'Top discounts',
        topRates: 'Top rating',

        locations: 'Regions',
        markers: 'Cities',
        sections: 'Sections',
        chapters: 'Chapters',
        categories: 'Categories',

        addLocation: 'Add Region',
        addMarker: 'Add City',
        addSection: 'Create section',
        addChapter: 'Add chapter',
        addCategory: 'Add category',

        newLocation: 'New Region',
        newMarker: 'New City',
        newSection: 'New section',
        newChapter: 'New chapter',
        newCategory: 'New category',

        productStore: 'Seller',
        storeProductOfProducts: 'Similar Products',
        storeOtherProducts: 'Other Products',
        storeProducts: 'Store Products',
        storeBanners: 'Store Banners',
        cartProfile: 'Buyer',
        
        media: 'Media',
        subMedia: 'Media part two',
        main: 'Main',
        confidential: 'Personal',
        deliveriesAndPayments: 'Delivery and payment',
        priceAndDiscount: 'Price, discounts and promotions',
        other: 'Others',
        security: 'Security',
        
        name: 'Name',
        title: 'Title',
        subTitle: 'Subtitle',
        login: 'Login',
        phone: 'Phone',
        tel: 'Tel',
        website: 'Web-site',
        basicPhone: 'Primary Phone',
        additionalPhone: 'Additional Phone',
        phonePlace: 'Phone number',
        otpPlace: 'SMS code',
        email: 'E-mail',
        newAddress: 'New Address',
        addAddress: 'Add Address',
        myAddresses: 'My Addresses',
        addresses: 'Addresses',
        address: 'Address',
        street: 'Street',
        house: 'House',
        houseEntrance: 'Entrance',
        houseFloor: 'Floor',
        houseApartment: 'Apartment',
        location: 'Location',
        marker: 'Position',
        //location: 'Region',
        //marker: 'City',
        answer: 'Answer',
        rateLike: 'This review was liked by Trading Establishment',
        comment: 'Comment',
        comments: 'Comments',
        cartComment: 'Comment for order',
        cartAddressComment: 'Comment for address',
        cartCode: 'Order code',
        section: 'Section',
        chapter: 'Chapter',
        category: 'Category',
        
        regDate: 'Registered',
        pubDate: 'Published',
        activeDate: 'Active until',
        changeDate: 'Modified',
        rejectedDate: 'Rejected',
        confirmDate: 'Confirmed',
        sentDate: 'Sent',
        deliveredDate: 'Delivered',
        
        opened: 'Open',
        closed: 'Closed',
        opens: 'Open',
        closes: 'Closed',

        online: 'Online',
        offline: 'Offline',

        workDay: 'Working day',
        notWorkDay: 'Not working',
        breakWorkDay: 'Break',
        workDays: 'Working days',
        workTime: 'Working hours',
        workStart: 'Start',
        workEnd: 'End',
        
        day1: 'Monday',
        day2: 'Tuesday',
        day3: 'Wednesday',
        day4: 'Thursday',
        day5: 'Friday',
        day6: 'Saturday',
        day7: 'Sunday',
        
        cartRank: 'Order rank',
        rateRank: 'Review rank',
        rank: 'Rank',
        rank1: 'Initial',
        rank2: 'Bronze',
        rank3: 'Silver',
        rank4: 'Gold',
        rank5: 'Platinum',
        rank6: 'Diamond',
        rank7: 'Popular',
        abonimentRank: 'Subscription Rank',
        lezzetCoin: 'Lezzet coin',
        lezzetCoinPrice: 'Lezzet coin price',
        subscribe: 'Subscribe',
        unsubscribe: 'Unsubscribe',

        invoice: 'Invoice',
        client: 'Client',
        payments: 'Payment methods',
        payment1: 'Cash',
        payment2: 'Card and terminal',
        payment3: 'Online',
        cash: 'Cash',
        terminal: 'Card and terminal',

        delivery: 'Delivery',
        lezzetDeliveryTitle: "Delivery Lezzet'Sebeti",
        lezzetDelivery: "Delivery service from Lezzet'Sebeti",
        storeDelivery: 'Delivery service from a Retail Establishment',
        deliveryType: 'Delivery method',
        deliveryCountry1: 'In the City, outside the City and to the Region',
        deliveryCountry2: 'In the City and outside the City',
        deliveryCountry3: 'In the City',
        deliveryCountry4: 'Pick it up yourself',
        delivery1: 'From a Retail Establishment',
        delivery2: "From Lezzet'Sebeti",
        delivery3: "I'll pick it up myself",
        inCity: 'In the City',
        outCity: 'Out of the City',
        outRegion: 'In the region',
        price: 'Price',
        totalPrice: 'Total price',
        addedPrice: 'Added value',
        valute: 'TMT',
        summ: 'Amount to pay',
        minCartPrice: 'Minimum order price',
        
        size: 'Size',
        sizes: 'Sizes',
        
        onsale: 'On sale',
        notOnsale: 'Not on sale',
        notDelivery: 'No delivery service',
        notSelected: 'not marked',
        notSize: 'no size',
        notPrice: 'no price',
        
        delivered: 'Orders',
        
        views: 'View',
        rate: 'Rating',
        rates: 'Ratings',
        rateUp: 'Rate',
        yourRate: 'Your rating',
        deliveryRate: 'Rate the delivery service...',
        serviceRate: 'Rate the service and servize...',
        tasteRate: 'Rate the taste and quality...',
        viewStatus: 'Visibility status',
        period: 'Period',
        
        phoneVerifyTitle: 'Confirmation',
        phoneVerify: 'Confirm phone number',
        
        forgotPassword: 'Forgot password',
        forgotPasswordText1: 'Enter Your E-mail address and continue.',
        forgotPasswordText2: 'A one-time confirmation password (6 digits) has been sent via SMS to the main phone number of the Trading Establishment.',
        forgotPasswordText3: 'Enter a one-time confirmation password and confirm.',
        passwordRecovery: 'Password recovery',
        password: 'Password',
        currentPassword: 'Current password',
        currentPasswordText: 'Enter the current password',
        newPassword: 'New password',
        newPasswordText: 'Enter the new password',
        passwordRepeat: 'Repeat password',
        passwordRepeatErr: 'Repeat password does not match',
        passwordUpd: 'Change password',
        
        otpText1: 'Enter Your phone number and continue.',
        otpText2: 'A one-time confirmation password (6 digits) has been sent via SMS to Your phone number.',
        otpText3: 'Enter a one-time confirmation password and continue.',
        sendOtpMessage: "Lezzet'Sebeti one-time password for login",
        
        avatar: 'Avatar',
        passport: 'Passport',
        car: 'Automobile',
        image: 'Photo',
        images: 'Photos',
        mainImage: 'Main photo',
        newImage: 'New photo',
        imageI: 'The uploaded file must match: Format .jpeg, .jpg, .png, .gif and no more than 5 megabytes in Size.',
        video: 'Video',
        poster: 'Poster photo',
        newVideo: 'New video',
        videoI: 'The uploaded file must match: Format .mp4 and no more than 20 megabytes in Size.',
        excelI: 'The uploaded file must match: Format .xlsx, .xls.',
        
        cartCommentI: 'Please enter information that pertains to Your order.',
        cartAddressCommentI: 'For the Delivery service, please describe Your Address in words.',
        cartAdressNotFoundI: 'For the service Delivery, Addresses not found.',

        trashAbonimentTitle: 'Deleting an Subscription',
        trashAbonimentI: 'The request to delete a Subscription occurs instantly, the request will delete all Subscription data, including Store Subscriptions.',

        trashLocationTitle: 'Deleting an Velayat',
        trashLocationI: 'The request to delete a Velayat occurs instantly, the request will delete all Velayat data, including Cities.',

        trashMarkerTitle: 'Deleting an City',
        trashMarkerI: 'The request to delete a City occurs instantly, the request will delete all City data.',

        trashCategoryTitle: 'Deleting an Category',
        trashCategoryI: 'The request to delete a Category occurs instantly, the request will delete all Category data.',

        trashLezzetDeliveryTitle: 'Deleting an Delivery Service',
        trashLezzetDeliveryI: 'The request to delete the Delivery Service occurs instantly, the request will delete all Delivery Service data.',

        trashProfileTitle: 'Deleting an Account',
        trashProfileI: 'The request to delete an Account occurs instantly, the request will delete all Account data, including Sessions, Addresses, favorite Stores, Products and Reviews.',

        trashProfileDataTitle: 'Deleting an Account Data',
        trashProfileDataI: 'The request to delete Account Data occurs instantly, the request will delete all data associated with the Account, including Sessions, Addresses, favorite Stores, Products and Reviews.',

        trashAdressTitle: 'Deleting an Address',
        trashAdressI: 'The request to delete Address occurs instantly, the request will delete all Address data.',
        
        trashStoreTitle: 'Deleting an store',
        trashStoreI: 'The request to delete Store occurs instantly, the request will delete all Store data, including Products and Reviews.',
        
        trashRateTitle: 'Deleting an Rating',
        trashRateI: 'The request to delete Rating occurs instantly, the request will delete all Rating data.',

        trashProductTitle: 'Deleting an Product',
        trashProductI: 'The request to delete the Product occurs instantly, the request will delete all Product data.',
        
        trashCartTitle: 'Clear Cart',
        trashCartI: 'There is an unconfirmed product from another Store in the cart. To make a new order, confirm the existing order or clear the cart.',
        trashCartI2: 'Do You really want to clear the cart?',
        
        trashNewCartTitle: 'Deleting an Order ',
        trashNewCartI: 'The request to delete the Order occurs instantly, the request will delete all Order data.',
        
        notConfirmedCartPushTitle: 'Unconfirmed order',
        notConfirmedCartPushI: 'Order number',

        newCartPushTitle: 'New order has arrived',
        newCartPushI: 'Order number',

        confirmCartTitle: 'Order confirmation',
        confirmCartI: 'Do You really want to confirm the current order?',

        confirmCartPushTitle: 'Order confirmed',
        confirmCartPushI: 'Order number',

        sentCartTitle: 'Order sending',
        sentCartI: 'Do You really want to send the current order to the recipient?',

        sentCartPushTitle: 'Order sent',
        sentCartPushI: 'Order number',

        deliveredCartTitle: 'Order delivery',
        deliveredCartI: 'Have You really delivered the current order to the recipient?',

        courierCartPushTitle: 'New order assigned',
        courierCartPushI: 'Order number',

        newCourierCartPushTitle: 'Courier assigned',
        newCourierCartPushI: 'Order number',

        rateCartStorePushI: "Don't forget to leave Your feedback",

        rejectCartTitle: 'Order rejection',
        rejectCartI: 'Are You sure You want to reject the current order?',

        rejectCartPushTitle: 'Order rejected',
        rejectCartPushI: 'Order number',

        trashServiceTitle: 'Deleting an Service',
        trashServiceI: 'The request to delete the Service occurs instantly, the request will delete all Service data.',
        
        trashBannerTitle: 'Deleting an Banner',
        trashBannerI: 'The request to delete the Banner occurs instantly, the request will delete all Banner data.',
        
        trashAdsTitle: 'Deleting an Advertisement',
        trashAdsI: 'The request to delete the Advertisement occurs instantly, the request will delete all Advertisement data.',

        navigations: 'Navigations',
        myNavigations: 'My navigations',
        history: 'Browsing history',
        myFavorites: 'Favorites',
        myRatedStores: 'Rated by me',
        favorites: 'Liked',
        topFavorites: 'Top favorites',

        menu: 'Menu',
        back: 'Back',
        select: 'Select',
        choose: 'Choose',
        chooseData: 'Choose Data',
        show: 'Show',
        hide: 'Hide',
        all: 'All',
        send: 'Send',
        sendPhone: 'Send phone number',
        add: 'Add',
        addCart: 'To cart',
        create: 'Create',
        read: 'Read',
        update: 'Refresh',
        reset: 'Reset',
        delete: 'Delete',
        recycle: 'Clear',
        remove: 'Remove',
        change: 'Edit',
        confirm: 'Confirm',
        confirmPhone: 'Confirm phone number',
        block: 'Block',
        deliver: 'Delivered',
        reject: 'Reject',
        warning: 'Warning',
        info: 'Description',
        about: 'Details',
        aboutInfo: 'Detailed information',
        print: 'Print',

        required: 'Required',
        min: 'Minimum',
        max: 'Maximum',
        pattern: 'Allowed characters',
        numbers: 'numbers',
        strings: 'strings',
        symbols: 'characters',

        distance: 'Distance',
        year: 'year',
        years: 'years',
        day: 'day',
        days: 'days',
        hour: 'hour',
        hours: 'hours',
        minut: 'minute',
        minutes: 'minutes',
        second: 'second',
        seconds: 'seconds',
        kilometr: 'kilometer',
        kilometros: 'kilometers',
        metr: 'meter',
        metros: 'meters',

        powered: 'Enabled',
        ok: 'Yes',
        not: 'No',
        cancel: 'Cancel',

        quantity: 'Total',
        count: 'Count',
        pcs: 'pcs',
        from: 'from',

        privilege: 'Privilege',
        privilege1: 'Super',
        privilege2: 'Medium',
        privilege3: 'Normal',
        privilege4: 'Low',

        error: 'Error',
        error1: 'Error: Requested route not found',
        error2: 'Not enough data sent',
        error3: 'Invalid data sent',
        error4: 'Format or size mismatch',
        error5: 'Request was rejected',
        error6: 'Delivery Service with such Position exists',

        error100: 'Account not found',
        error101: 'Account not verified',
        error102: 'Account blocked',
        error103: 'Account status error',
        error104: 'You are not Authorized',
        error105: 'Authorized Account exists',
        error106: 'Your privileges do not match those specified',
        error107: 'Account with such Login not found',
        error108: 'Account with such Login exists',
        error109: 'Account with such phone number not found',
        error110: 'Account with such phone number exists',
        error111: 'Account with this E-mail address not found',
        error112: 'Account with this E-mail address exists',
        error113: 'Incorrect password',
        error114: 'Expired token',
        error115: 'Incorrect token',
        error116: 'Session not found',
        error117: 'Current Session cannot be deleted',
        error118: 'One-time password not found',
        error119: 'Account with this Name, Location and phone number exists',
        error120: 'Location permission is disabled.',
        error121: 'The location could not be determined. Make sure Your location service provider is turned on.',
        error122: 'Permission to receive push-notifications is disabled.',
        error123: 'Failed to receive push token. Please, use a physical device.',
        error124: 'This phone number is already in use as a primary phone number.',
        error125: 'This phone number is currently in use as a primary phone number.',
        error126: 'This phone number is already in use as a secondary phone number.',
        error127: 'This phone number is currently in use as a secondary phone number.',

        
        error200: 'Store not found',
        error201: 'Store not verified',
        error202: 'Store blocked',
        error203: 'Store status error',
        error204: 'A store with this Name, Location, Category and E-mail address exists',
        error205: 'Store closed',
        error206: 'Waiting for Store working days',
        error207: 'Waiting for Store working hours',
        error208: 'Delivery service is limited',
        error209: 'No delivery service',
        error210: 'The store has an existing Subscription',
        error211: 'The store does not have an existing Subscription',
        error212: 'A store with this E-mail address exists',

        error300: 'Product not found',
        error301: 'Product not confirmed',
        error302: 'Product blocked',
        error303: 'Product status error',
        error304: 'Product with such Name and such Category exists',

        error400: 'Service not found',
        error401: 'Service not confirmed',
        error402: 'Service blocked-',
        error403: 'Service status error',
        error404: 'Service with such Name, Location and such Category exists',

        error500: 'Order not found',
        error501: 'Order not confirmed',
        error502: 'Order blocked',
        error503: 'Order status error',
        error504: 'Incorrect address or address is outside the delivery service boundaries',
        error505: 'No Courier has been assigned for this Order yet',

        error600: 'Banner not found',
        error601: 'Banner not confirmed',
        error602: 'Banner blocked',
        error603: 'Banner status error',

        error700: 'Advertisement not found',
        error701: 'Advertisement not confirmed',
        error702: 'Advertisement blocked',
        error703: 'Advertisement status error',

        error800: 'Location with such Name exists',
        error801: 'Position with such Name exists',
        error802: 'Section with such Name exists',
        error803: 'Chapter with such Name exists',
        error804: 'Category with such Name exists',
        error805: 'Skill with such Name exists',

        error900: 'Rating not found',
        error904: 'Rating not accepted',

        error1000: 'Subscription not found',
        error1004: 'An active Subscription with these parameters exists',

        success: 'Success',
        success100: 'Successfully',
        success101: 'You are successfully Authorized',
        success102: 'You have successfully Registered',
        success103: 'Best regards',
        success104: 'Successfully created',
        success105: 'Successfully added',
        success106: 'Successfully updated',
        success107: 'Successfully modified',
        success108: 'Successfully confirmed',
        success109: 'Successfully deleted',
        success110: 'Your order has been successfully accepted. The Operator will call You back to confirm Your order',
        success111: 'Successfully sent',
        
        viewStatus1: 'Active',
        viewStatus2: 'New',
        viewStatus3: 'Changed',
        viewStatus4: 'Blocked',
        viewStatus5: 'Confirmed',
        viewStatus6: 'Sent',
        viewStatus7: 'Delivered',
        viewStatus9: 'Rejected',
        
        status: 'Status',
        status1: 'Active',
        status2: 'Pending confirmation',
        status3: 'Checking for changes',
        status4: 'Blocked',
        status5: 'Confirmed',
        status6: 'Sent',
        status7: 'Delivered',
        status9: 'Rejected',
        status10: 'Not found',
        
        panelStatus1: 'Active',
        panelStatus2: 'New',
        panelStatus3: 'Changed',
        panelStatus4: 'Blocked',
        panelStatus5: 'Confirmed',
        panelStatus6: 'Sent',
        panelStatus7: 'Delivered',
        panelStatus9: 'Rejected',

        appDescription1: "Lezzet'Sebeti – платформа онлайн покупок.",
        appDescription2: "Мы собираемся приблизить мечту каждого человека в реальность.",
        appDescription3: "Наша цель добавить свой вклад на то чтобы мир стал еще лучше и удобней.",
        appSupport: "Если у вас возникли другиe вопросы, пишите на наш E-mail адрес.",
        copyright: "Все Авторские права защищены 2024 год.",

        appAboutUs: "Про нас:",
        appAboutUs1: "1. Цель Lezzet'Sebeti предоставить возможности, повышения маркетинга всем физическим или юридическим лицам, занимающиеся сферой торговли. А так же лицам в поисках своих нужд находить свои потребности быстро и эффективно.",
        appAboutUs2: "2. В наши дополнительные услуги входят:",
        appAboutUsServices: "Реклама баннер, постраничная реклама: реклама Вашего Торгового Заведения, товаров и размещение других похожих реклам.",
        appAboutUsQuestionsAndAnswers: "Ответы на вопросы:",
        appAboutUsQuestion1: "1. Что представляет Lezzet'Sebeti?",
        appAboutUsAnswer1: "Lezzet'Sebeti предоставляет возможности, повышения маркетинга всем физическим или юридическим лицам, занимающиеся сферой торговли. А так же лицам в поисках своих нужд находить свои потребности быстро и эффективно.",
        appAboutUsQuestion2: "2. Я могу разместить свое Торговое Заведение на Lezzet'Sebeti?",
        appAboutUsAnswer2: "Да, если Вы занимаетесь сферой торговли, Вы можете разместить свое Торговое Заведение без каких либо трудностей. Для этого свяжитесь с Администратором.",
        appAboutUsQuestion3: "3. Регистрация на Lezzet'Sebeti объязательная?",
        appAboutUsAnswer3: "Нет, не объязательная. Но, после регистрации на Lezzet'Sebeti, появятся больше возможностей как, совершать заказы, давать рейтинг балы, оставлять отзывы, добавлять понравившиеся Торговые Заведения или товары в историю мои избранные и другиe дальнейшие действия.",
        
        termsOfUseTitle: "Каждый человек, кто получает доступ к этому сайту, программе и использует его в настоящее время, свидетельствует о том, что  соглашается с настоящими Условиями Использования.",

        termsOfUseUsers: "Пользователям:",
        termsOfUseUsers1: "1. Lezzet'Sebeti представляет возможности Пользователям, находить товары под свои нужды и потребности.",
        termsOfUseUsers2: "2. Lezzet'Sebeti не несёт ответственность за Пользователя и за его выбор. Наша цель, предоставить Пользователю возможность находить нужную ему потребность в объявлениях товаров от Торговых Заведений.",
        termsOfUseUsers3: "3. Lezzet'Sebeti не несёт ответственность за оплату или предоплату товаров, а так же за гарантию качества и за цену товара. Не оплачивайте товар пока не получите и не осмотрите лично. Всё что вы делаете и совершаете на Lezzet'Sebeti, делаете на свой риск и страх.",
        termsOfUseUsers4: "4. Прежде чем, совершать заказ от Торговых Заведений, прочитайте отзывы оставленные со стороны других Пользователей и сравните рейтинг.",
        termsOfUseUsers5: "5. Пользователи имеют возможность добавлять понравившиеся Торговые Заведения или товары в историю мои избранные, а также давать Рейтинг балы и оставлять отзывы Торговым Заведениям, после совершения заказа.",
        termsOfUseUsers6: "6. Перечень правил для отзывов:",
        termsOfUseUsersComment1: "• Отзыв не должен содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство, мат.",
        termsOfUseUsersComment2: "• Отзыв не должен содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.",
        termsOfUseUsers7: "7. При нарушении приведенных правил Администратор имеет право удалить и заблокировать Пользователя без объяснения и причин.",
        termsOfUseUsers8: "8. Пользователь несёт полную ответственность за свои любые действия и совершания на Lezzet'Sebeti.",
        termsOfUseUsers9: "9. Lezzet'Sebeti не вмешивается и не состоит в договоре между Пользователями и Торговыми Заведениями.",
        termsOfUseUsers10: "10. Lezzet'Sebeti не вмешивается и не состоит в купле-продаже между Пользователями и Торговыми Заведениями.",

        termsOfUseStores: "Торговым Заведениям:",
        termsOfUseStores1: "1. Lezzet'Sebeti представляет услуги и возможности Торговым Заведениям, предложить и продавать свои товары и услуги онлайн.",
        termsOfUseStores2: "2. Lezzet'Sebeti не несёт ответственность за Торговое Заведение, его действиям и за его объявлений. Наша цель, предоставить Торговому Заведению возможность предложить и продавать свои товары и услуги онлайн.",
        termsOfUseStores3: "3. Lezzet'Sebeti не несёт ответственность за не уплату заказа (кроме случаев: если доставка осуществляется со стороны Lezzet'Sebeti и онлайн оплаты), Всё что вы делаете и совершаете на Lezzet'Sebeti, делаете на свой риск и страх.",
        termsOfUseStores4: "4. Lezzet'Sebeti имеет право удалять и заблокировать объявления товаров или услуг без объяснения и причин, также если товар или услуга не соответствует правилам Lezzet'Sebeti. Все объявления проверяются Администраторами Lezzet'Sebeti.",
        termsOfUseStores5: "5. Перечень правил для объявлений:",
        termsOfUseStoresAnnouncement1: "• Объявление не должно содержать товары или услуги не соответствующие законодательству Туркменистана.",
        termsOfUseStoresAnnouncement2: "• Объявление не должно содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство,  мат.",
        termsOfUseStoresAnnouncement3: "• Объявление не должно содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.",
        termsOfUseStoresAnnouncement4: "• Объявление не должно содержать фотографии психического или религиозного внушения, а также запрещается фотографии насилия, издевательство или нецензурного характера.", 
        termsOfUseStoresAnnouncement5: "• Торговое Заведение не имеет право добавить объявления товара или услуги без описания и фотографии.", 
        termsOfUseStoresAnnouncement6: "• Торговое Заведение не имеет право добавить объявления товаров или услуг не являющийся его собственностью.", 
        termsOfUseStores6: "6. Торговые Заведения имеют возможность оставлять ответы на отзывы, оставленные Пользователями.",
        termsOfUseStores7: "7. Перечень правил для ответов:",
        termsOfUseStoresComment1: "• Ответ не должен содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство, мат.",
        termsOfUseStoresComment2: "• Ответ не должен содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.", 
        termsOfUseStores8: "8. Администраторы Lezzet'Sebeti имеют право удалять и заблокировать Торговое Заведение и его Правообладателя без объяснения и причин.", 
        termsOfUseStores9: "9. Торговое Заведение и его Правообладатель несёт полную ответственность за свои любые действия и совершения на Lezzet'Sebeti.",
        termsOfUseStores10: "10. Lezzet'Sebeti не вмешивается и не состоит в договоре между Пользователями и Торговыми Заведениями.",
        termsOfUseStores11: "11. Lezzet'Sebeti не вмешивается и не состоит в купле-продаже между Пользователями и Торговыми Заведениями.",

        privacyPolicyTitle: "Каждый человек, кто получает доступ к этому сайту или программе и использует его в настоящее время, свидетельствует о том, что соглашается с настоящим Политикой Конфиденциальности.",

        privacyPolicyDataUsers: "Пользователям:",
        privacyPolicyDatasUsersScroll: "Перечень действий, с Персональными данными Пользователя:",
        privacyPolicyDatasUsers: "На Lezzet'Sebeti собираются следующие Персональные данные: Зарегистрированные номера телефонов, имя (настоящее или присвоенное, рандомное), адреса, отзывы и информация о заказах Пользователей.",
        privacyPolicyDataUsersPhone: "Зарегистрированный номер телефона Пользователя:",
        privacyPolicyDataUsersPhone1: "1. Зарегистрированным номером телефона Пользователя является: Введенный номер телефона Пользователем при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone2: "2. После того, как Пользователь зарегистрировался на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone3: "3. Зарегистрированный номер телефона на Lezzet'Sebeti, служит для подтверждения личности, для связи с Пользователем и для подтверждения заказа, а также для идентифицирования Пользователя на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone4: "4. Зарегистрированный номер телефона Пользователя, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersName: "Имя Пользователя:",
        privacyPolicyDataUsersName1: "1. Имя Пользователя является: Введенный имя Пользователем или рандомное имя присвоенное после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersName2: "2. После того, как Пользователь изменил имя, его имя сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersName3: "3. Имя, служит для подтверждения личности и для подтверждения заказа.",
        privacyPolicyDataUsersName4: "4. Имя Пользователя, не указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress: "Адрес Пользователя:",
        privacyPolicyDataUsersAddress1: "1. Адресом Пользователя является: Добавленный адрес Пользователем на Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress2: "2. После того, как Пользователь добавил адрес, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress3: "3. Адрес, служит для доставки заказа в пункт назначения.",
        privacyPolicyDataUsersAddress4: "4. Адрес Пользователя, указывается в обязательном порядке, при совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersRate: "Отзыв Пользователя:",
        privacyPolicyDataUsersRate1: "1. Отзывом Пользователя является: Добавленный отзыв Торговому Заведению Пользователем, после совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersRate2: "2. После того, как Пользователь добавил отзыв, его отзыв сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersRate3: "3. Отзыв, служит для получения информации о качестве доставки, обслуживания сервиза и впечатление от товаров.",
        privacyPolicyDataUsersRate4: "4. Отзыв Пользователя, не указывается в обязательном порядке, после совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersCart: "Информация о заказах Пользователя:",
        privacyPolicyDataUsersCart1: "1. Информацией о заказах Пользователя является: Совершенные заказы Пользователем от Торговых Заведений на Lezzet'Sebeti.",
        privacyPolicyDataUsersCart2: "2. После того, как Пользователь совершил заказ, его заказ сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе со стороны Торгового Заведения и Курьера, где был совершен заказ.",
        privacyPolicyDataUsersCart4: "4. Информация о заказе Пользователя, указывается в обязательном порядке, при совершении заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersShopping: "Перечень действий от заказа до, его получения:",
        privacyPolicyDataUsersShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataUsersShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataUsersShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataUsersEncryptTitle: "Все полученные или переданные Персональные данные Пользователя на сервере Lezzet'Sebeti, совершаются через шифрование данных.",

        privacyPolicyDataStores: "Торговым Заведениям:",
        privacyPolicyDatasStoresScroll: "Перечень действий, с Персональными данными Торгового Заведения:",
        privacyPolicyDatasStores: "На Lezzet'Sebeti собираются следующие Персональные данные: Название, медиафайлы, номера телефонов, E-mail адрес, рабочие дни, информация по доставке, информация о спобах оплаты, адрес, информация о товарах и услугах, и информация о заказах Торгового Заведения.",
        privacyPolicyDataStoresTitle: "Название Торгового Заведения:",
        privacyPolicyDataStoresTitle1: "1. Название Торгового Заведения является: Введенное Название, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle2: "2. После того, как Торговое Заведение зарегистрировался на Lezzet'Sebeti, его Название сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle3: "3. Название, служит для подтверждения объекта как Торговое Заведение и для продолжения своей деятельности на Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle4: "4. Название Торгового Заведения, указывается в обязательном порядке при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia: "Медиафайлы Торгового Заведения:",
        privacyPolicyDataStoresMedia1: "1. Медиафайлами Торгового Заведения является: Видео или фото файлы, загруженные Торговым Заведением, на сервер Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia2: "2. После того, как Торговое Заведение загруружает медиафайл на Lezzet'Sebeti, его медиафайл сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia3: "3. Медиафайлы, служат для визуального подтверждения информации об объекте Торговое Заведение и для визуального подтверждения информации о товарах и услугах Торгового Заведения на Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia4: "4. Медиафайлы Торгового Заведения, указываются в обязательном порядке после регистрации, а также после добавления товаров и услуг на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone: "Номера телефонов Торгового Заведения:",
        privacyPolicyDataStoresPhone1: "1. Номера телефонов Торгового Заведения являются: Введенный основной номер телефона Торгового Заведения, при регистрации на Lezzet'Sebeti, а также добавленный позже дополнительный номер телефона Торгового Заведения после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone2: "2. После того, как Торговое Заведение зарегистрировался с основным номером телефона или добавил позже дополнительный номер телефона на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone3: "3. Основной или дополнительный номера телефонов на Lezzet'Sebeti, служат для связи с Торговым Заведением, а также для подтверждения заказов на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone4: "4. Основной номер телефона Торгового Заведения, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail: "E-mail адрес Торгового Заведения:",
        privacyPolicyDataStoresEmail1: "1. E-mail адрес Торгового Заведения является: Введенный E-mail адрес Торгового Заведения, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail2: "2. После того, как Торговое Заведение зарегистрировался на Lezzet'Sebeti, его E-mail адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail3: "3. E-mail адрес на Lezzet'Sebeti, служит для связи с Торговым Заведением, а также для идентифицирования Торгового Заведения на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail4: "4. E-mail адрес Торгового Заведения, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays: "Рабочие дни Торгового Заведения:",
        privacyPolicyDataStoresWorkDays1: "1. Рабочие дни Торгового Заведения является: Указанные рабочие дни Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays2: "2. После того, как Торговое Заведение указал рабочие дни на Lezzet'Sebeti, его рабочие дни сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays3: "3. Рабочие дни, служат для получения информации Торгового Заведения о статусе работает или не работает на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays4: "4. Рабочие дни Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery: "Информация по доставке Торгового Заведения:",
        privacyPolicyDataStoresDelivery1: "1. Информация по доставке Торгового Заведения является: Указанные методы и способы по доставке Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery2: "2. После того, как Торговое Заведение указал методы и способы по доставке на Lezzet'Sebeti, его методы и способы по доставке сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery3: "3. Информация по доставке, служит для получения информации Торгового Заведения о методах и способах по доставке на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery4: "4. Информация по доставке Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment: "Информация о спобах оплаты Торгового Заведения:",
        privacyPolicyDataStoresPayment1: "1. Информация о спобах оплаты Торгового Заведения является: Указанные способы оплаты Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment2: "2. После того, как Торговое Заведение указал способы оплаты на Lezzet'Sebeti, его способы оплат сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment3: "3. Информация о спобах оплаты, служит для получения информации Торгового Заведения о способах оплаты на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment4: "4. Информация о спобах оплаты Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress: "Адрес Торгового Заведения:",
        privacyPolicyDataStoresAddress1: "1. Адрес Торгового Заведения является: Введенный адрес Торгового Заведения, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress2: "2. После того, как Торговое зарегистрировался на Lezzet'Sebeti, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress3: "3. Адрес, служит для получения информации о местоположении Торгового Заведения на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress4: "4. Адрес Торгового Заведения, указывается в обязательном порядке при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct: "Информация о товарах и услугах Торгового Заведения:",
        privacyPolicyDataStoresProduct1: "1. Информация о товарах и услугах Торгового Заведения является: Введенная информация Торговым Заведением, при добавление каждого товара или услуги на Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct2: "2. После того, как Торговое Заведение добавил информацию о товаре или услуге на Lezzet'Sebeti, его информация о товаре или услуге сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct3: "3. Информация о товарах и услугах, служат для получения информации о товарах и услугах Торгового Заведения, а также для идентифицирования каждого отдельного товара или услуги на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct4: "4. Информация о товарах и услугах Торгового Заведения, указывается в обязательном порядке, при добавление каждого товара или услуги на Lezzet'Sebeti.",
        privacyPolicyDataStoresCart: "Информация о заказах Торгового Заведения:",
        privacyPolicyDataStoresCart1: "1. Информацией о заказах Торгового Заведения является: Совершенные заказы Пользователем от Торгового Заведения, на Lezzet'Sebeti.",
        privacyPolicyDataStoresCart2: "2. После того, как Торговое Заведение получил, принял, отправил или доставил заказ от Пользователя, статус заказа меняется на новый, подтвержденный, отправлено или доставлено на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе.",
        privacyPolicyDataStoresCart4: "4. Информация о заказе Торгового Заведения, сохраняется в обязательном порядке, после совершении заказа на Lezzet'Sebeti.",
        privacyPolicyDataStoresShopping: "Перечень действий от заказа, до его получения:",
        privacyPolicyDataStoresShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataStoresShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataStoresShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataStoresEncryptTitle: "Все полученные или переданные Персональные данные Торгового Заведения на сервере Lezzet'Sebeti, совершаются через шифрование данных.",

        privacyPolicyDataCouriers: "Курьерам:",
        privacyPolicyDatasCouriersScroll: "Перечень действий, с Персональными данными Курьера:",
        privacyPolicyDatasCouriers: "На Lezzet'Sebeti собираются следующие Персональные данные: Имя (настоящее или присвоенное, рандомное), номера телефона, адреса, фотографии (личное, транспорта и пасспорта) и информация о заказах Курьеров.",
        privacyPolicyDataCouriersName: "Имя Курьера:",
        privacyPolicyDataCouriersName1: "1. Имя Курьера является: Введенный имя Курьером или рандомное имя присвоенное после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersName2: "2. После того, как Курьер изменил имя, его имя сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersName3: "3. Имя, служит для подтверждения личности и для подтверждения заказа, а также для идентифицирования Курьера, как сотрудник на Lezzet'Sebeti.",
        privacyPolicyDataCouriersName4: "4. Имя Курьера, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone: "Номер телефона Курьера:",
        privacyPolicyDataCouriersPhone1: "1. Номер телефона Курьера является: Введенный номер телефона Курьера при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone2: "2. После того, как Курьер зарегистрировался на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone3: "3. Номер телефона на Lezzet'Sebeti, служит для подтверждения личности, для связи с Курьером и для подтверждения заказа, а также для идентифицирования Курьера на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone4: "4. Номер телефона Курьера, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress: "Адрес Курьера:",
        privacyPolicyDataCouriersAddress1: "1. Адресом Курьера является: Введенный адрес Курьера при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress2: "2. После того, как Курьер зарегистрировался на Lezzet'Sebeti, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress3: "3. Адрес, служит для получения информации о место проживания Курьера, а также для получения заказов по место проживанию.",
        privacyPolicyDataCouriersAddress4: "4. Адрес Курьера, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto: "Фотографии Курьера:",
        privacyPolicyDataCouriersPhoto1: "1. Фотографии Курьера являются: Фото файлы, загруженные Курьером, на сервер Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto2: "2. После того, как Курьер загруружает фото файл на Lezzet'Sebeti, его фото файл сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto3: "3. Фотографии, служат для визуального подтверждения информации о Курьере и для визуального подтверждения информации о транспорте Курьера, а также для идентифицирования Курьера, как сотрудник на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto4: "4. Фотографии Курьера, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart: "Информация о заказах Курьера:",
        privacyPolicyDataCouriersCart1: "1. Информацией о заказах Курьера является: Порученные заказы от Lezzet'Sebeti к Курьеру, для доставки заказов в пункт назначения на Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart2: "2. После того, как к Курьеру был поручен заказ, его заказ сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе.",
        privacyPolicyDataCouriersCart4: "4. Информация о заказе Курьера, указывается в обязательном порядке, при поручении заказа на Lezzet'Sebeti.",
        privacyPolicyDataCouriersShopping: "Перечень действий от заказа, до его получения:",
        privacyPolicyDataCouriersShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataCouriersShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataCouriersShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataCouriersEncryptTitle: "Все полученные или переданные Персональные данные Курьера на сервере Lezzet'Sebeti, совершаются через шифрование данных."
    },
    tr: {
        app: "Lezzet'Sebeti",
        appStore: "Lezzet'Store",
        appGo: "Lezzet'Go",
        
        appUpdateVersionTitle: "Yazılım!",
        appUpdateVersionDescription: "Bu yazılım güncellendi, lütfen en son sürüme güncelleyin!",

        loading: 'YÜKLENİYOR',
        loadMore: 'Daha fazla',
        pageNotFound: 'Hata: 404 - sayfa bulunamadı',
        unknownScreen: 'Bilinmeyen ekran',
        install: "Lezzet'Sebeti uygulamasını yükleme",

        logo: 'Logo',
        logos: 'Logolar',

        start: 'Başlat',
        startIn: 'Buradan başla',

        sessions: 'Bağlı cihazlar',

        pages: 'Sayfalar',
        viewPages: 'Görüntülenen sayfalar',
        otherPages: 'Diğer sayfalar',

        shoppingCenters: 'Ticari Kuruluşlar',
        shoppingCenter: 'Ticari Kuruluş',

        homePage: 'Ana Sayfa',
        home: 'Ana sayfa',

        adminPanelPage: 'Yönetici-panel Sayfa',
        adminPanel: 'Yönetici-panel',
        panelPage: 'Panel Sayfa',
        panel: 'Panel',

        createRankAbonimentPage: 'Sıralama Aboneliği oluştur Sayfa',
        setRankAbonimentPage: 'Sıralama Aboneliği Ayarları Sayfa',
        createRankAboniment: 'Sıralama Aboneliği oluştur',
        newRankAboniment: 'Yeni Sıralama Aboneliği',
        rankAbonimentPage: 'Sıralama Aboneliği Sayfa',
        rankAboniment: 'Sıralama Aboneliği',
        rankAbonimentStoresPage: 'Sıralama Aboneliği Mağazaları Sayfa',
        rankAbonimentStores: 'Sıralama Aboneliği Mağazaları',
        rankAbonimentTitle: 'Yerken kazan',
        rankAbonimentTableTitle: 'Yerken kazan sıralaması',
        
        promotions: 'Promosyonlar',
        promotionAboniment: '1+1 Kampanyası',

        subscribesStores: 'Abone olunan Mağazalar',

        adminsPage: 'Yöneticiler Sayfa',
        createAdminPage: 'Yönetici oluştur Sayfa',
        setAdminPage: 'Yönetici Ayarları Sayfa',
        createAdmin: 'Yönetici oluştur',
        setAdmin: 'Yönetici Ayarları',
        newAdmin: 'Yeni Yönetici',
        admins: 'Yöneticiler',
        adminPage: 'Yönetici Sayfa',
        admin: 'Yönetici',
        
        lDeliverysPage: 'Teslimat Hizmetleri Sayfa',
        createLDeliveryPage: 'Teslimat Hizmeti oluştur Sayfa',
        setLDeliveryPage: 'Teslimat Hizmeti Ayarları Sayfa',
        setLDelivery: 'Teslimat Hizmeti Ayarları',
        createLDelivery: 'Teslimat Hizmeti oluştur',
        newLDelivery: 'Yeni teslimat Hizmeti',
        lDeliverys: 'Teslimatlar Hizmetleri',
        lDeliveryPage: 'Teslimat Hizmeti Sayfa',
        lDelivery: 'Teslimat Hizmeti',
        
        couriersPage: 'Kuryeler Sayfa',
        createCourierPage: 'Kurye oluştur Sayfa',
        setCourierPage: 'Kurye Ayarları Sayfa',
        setCourier: 'Kurye Ayarları',
        createCourier: 'Kurye oluştur',
        newCourier: 'Yeni Kurye',
        couriers: 'Kuryeler',
        courierPage: 'Kurye Sayfa',
        courier: 'Kurye',
        courierCartsPage: 'Kurye Siparişlerı Sayfa',
        courierNotificationsPage: 'Kurye Bildirimlerı Sayfa',

        cartPage: 'Sepet Sayfa',
        shopsPage: 'Siparişler Sayfa',
        shopPage: 'Sipariş Sayfa',
        shop: 'Sipariş',
        setShopPage: 'Sipariş Ayarları Sayfa',
        setShop: 'Sipariş Ayarları',
        storeShops: 'Siparişler',
        storeNewShops: 'Devam Eden Siparişler',
        courierShops: 'Siparişler',
        courierNewShops: 'Devam Eden Siparişler',
        profileShops: 'Alışverişler',
        profileNewShops: 'Bekleyen Siparişler',
        historyShops: 'Sipariş Geçmişi',
        cart: 'Sepet',
        confirmCart: 'Sipariş onayı',
        newCarts: 'Yeni Siparişler',
        confirmedCarts: 'Onaylanmış Siparişler',
        sentedCarts: 'Gönderilen Siparişler',
        deliveredCarts: 'Teslim edilen Siparişler',
        receivedCarts: 'Alınan Siparişler',
        rejectedCarts: 'Reddedilen Siparişler',
        
        profilesPage: 'Kullanıcılar Sayfa',
        profiles: 'Kullanıcılar',
        profilePage: 'Kullanıcı Sayfa',
        setProfilePage: 'Kullanıcı Ayarları Sayfa',
        setProfile: 'Kullanıcı Ayarları',
        profileDataPage: 'Kullanıcı Verileri Sayfa',
        profileData: 'Kullanıcı Verileri',
        profileDataTrash: 'Kullanıcı Verilerini Silme',
        profileTrash: 'Kullanıcıyı Silme',
        profile: 'Profil',
        profileSet: 'Profili Düzenle',
        profileCartsPage: 'Kullanıcı Siparişlerı Sayfa',
        profileNotificationsPage: 'Kullanıcı Bildirimlerı Sayfa',

        addressesPage: 'Adresler Sayfa',
        addAddressPage: 'Adresi Ekle Sayfa',

        myFavoriteStoresPage: 'Favori Mağazalar Sayfa',
        myFavoriteProductsPage: 'Favori Ürünler Sayfa',
        myRatedStoresPage: 'Değerlendirdiğim Mağazalar Sayfa',
        recomendedStoresPage: 'Önerilen Mağazalar Sayfa',

        profileCurrentRatesPage: 'İncelemelerim Sayfa',
        profileCurrentRates: 'İncelemelerim',
        profilePendingRatesPage: 'Bekleyen İncelemeler Sayfa',
        profilePendingRates: 'Bekleyen İncelemeler',

        currentRatesPage: 'İncelemeler Sayfa',
        currentRates: 'İncelemeler',
        pendingRatesPage: 'Bekleyen İncelemeler Sayfa',
        pendingRates: 'Bekleyen İncelemeler',

        settingsPage: 'Ayarlar Sayfa',
        settings: 'Ayarlar',
        
        discountStoresPage: 'İndirim Mağazaları Sayfa',
        promotionStoresPage: 'Promosyonlu Mağazalar Sayfa',
        lezzetDeliveryStoresPage: "Lezzet'Sebeti-den teslimatlı Mağazalar Sayfa",
        rankStoresPage: 'Yerken kazan sıralamalı Mağazalar Sayfa',

        storesPage: 'Mağazalar Sayfa',
        createStorePage: 'Mağaza aç Sayfa',
        setStorePage: 'Mağaza Ayarları Sayfa',
        setStore: 'Mağaza Ayarları',
        createStore: 'Mağaza aç',
        newStore: 'Yeni Mağaza',
        stores: 'Mağazalar',
        storePage: 'Mağaza Sayfa',
        store: 'Mağaza',
        storeBannersPage: 'Mağaza Bannerları Sayfa',
        storeProductsPage: 'Mağaza Ürünleri Sayfa',
        storeCreateProductPage: 'Ürün ekle Sayfa',
        storeCartsPage: 'Mağaza Siparişlerı Sayfa',
        storeNotificationsPage: 'Mağaza Bildirimlerı Sayfa',
        
        productsPage: 'Ürünler Sayfa',
        addProduct: 'Ürün ekle',
        addProducts: 'Ürünleri ekle',
        newProduct: 'Yeni Ürün',
        newProducts: 'Yeni Ürünler',
        products: 'Ürünler',
        productPage: 'Ürün Sayfa',
        setProductPage: 'Ürün ayarları Sayfa',
        setProduct: 'Ürün ayarları',
        product: 'Ürün',
        
        bannersPage: 'Bannerlar Sayfa',
        setBannerPage: 'Banner Ayarları Sayfa',
        setBanner: 'Banner Ayarları',
        addBanner: 'Banner ekle',
        newBanner: 'Yeni Banner',
        banners: 'Bannerlar',
        bannerPage: 'Banner Sayfa',
        banner: 'Banner',

        advertisingsPage: 'Reklamlar Sayfa',
        addAdvertising: 'Reklam ekle',
        newAdvertising: 'Yeni reklam',
        advertisings: 'Reklamlar',
        advertisingPage: 'Reklam Sayfa',
        advertising: 'Reklam',

        notificationsPage: 'Bildirimler Sayfa',
        setNotificationPage: 'Bildirim Ayarları Sayfa',
        addNotification: 'Bildirim ekle',
        newNotification: 'Yeni bildirim',
        notifications: 'Bildirimler',
        notificationPage: 'Bildirim Sayfa',
        notification: 'Bildirim',
        
        reviews: 'Yorumlar',

        authorization: 'Giriş',
        signup: 'Kayıt',
        agree: 'Kullanım şartlarını ve gizlilik politikasını kabul ediyorum',
        
        help: 'Yardım',
        termsOfUse: 'Kullanım şartları',
        privacyPolicy: 'Gizlilik politikası',
        aboutUs: 'Hakkımızda',
        
        informations: 'Bölümler ve bilgiler',
        contacts: 'İletişim',
        
        welcomeBack: 'Merhaba, Hoş Geldiniz',
        entrancePage: 'Giriş Sayfa',
        entrance: 'Giriş',
        allTheBest: 'Hoşça kal',
        exitPage: 'Çıkış Sayfa',
        exit: 'Çıkış',
        exitIn: 'Çıkış yap',
        verifyPage: 'Onaylamak Sayfa',
        resetPage: 'Sıfırlamak Sayfa',
        next: 'Devam et',
        
        lang: 'Dil',
        changeLang: 'Dil seçin',

        theme: 'Tema',
        changeTheme: 'Tema seçin',

        system: 'Sistem',
        light: 'Gündüz',
        dark: 'Gece',

        myRates: 'Puanlarım',
        
        discountPub: 'İndirim Duyur',

        find: 'Arama terimi',
        filter: 'Filtre',
        order: 'Önce',
        news: 'Yeniler',
        olds: 'Eskiler',
        topViews: 'En çok görüntülenenler',
        topPrice: 'Daha pahalı',
        downPrice: 'Daha ucuz',
        discountPrice: 'İndirim',
        topRecomended: 'Önerilenler',
        topSelling: 'En çok satılanlar',
        topDiscount: 'En İyi İndirimler',
        topRates: 'En yüksek puan',

        locations: 'Bölgeler',
        markers: 'Şehirler',
        sections: 'Bölümler',
        chapters: 'Kısımlar',
        categories: 'Kategoriler',

        addLocation: 'Bölge ekle',
        addMarker: 'Şehir ekle',
        addSection: 'Bölüm oluştur',
        addChapter: 'Kısım ekle',
        addCategory: 'Kategori ekle',

        newLocation: 'Yeni Bölge',
        newMarker: 'Yeni Şehir',
        newSection: 'Yeni bölüm',
        newChapter: 'Yeni kısım',
        newCategory: 'Yeni kategori',

        productStore: 'Satıcı',
        storeProductOfProducts: 'Benzer Ürünler',
        storeOtherProducts: 'Diğer Ürünler',
        storeProducts: 'Mağaza Ürünleri',
        storeBanners: 'Mağaza Bannerları',
        cartProfile: 'Alıcı',
        
        media: 'Medya',
        subMedia: 'Medya ikinci kısım',
        main: 'Temel',
        confidential: 'Kişisel',
        deliveriesAndPayments: 'Teslimat ve ödeme',
        priceAndDiscount: 'Fiyat, indirimler ve promosyonlar',
        other: 'Diğer',
        security: 'Güvenlik',
        
        name: 'Adı',
        title: 'Başlık',
        subTitle: 'Alt Başlık',
        login: 'Giriş',
        phone: 'Telefon',
        tel: 'Tel',
        website: 'Web-site',
        basicPhone: 'Ana Telefon',
        additionalPhone: 'Ek Telefon',
        phonePlace: 'Telefon numarası',
        otpPlace: 'SMS kodu',
        email: 'E-posta',
        newAddress: 'Yeni Adres',
        addAddress: 'Adres Ekle',
        myAddresses: 'Adreslerim',
        addresses: 'Adresler',
        address: 'Adres',
        street: 'Sokak',
        house: 'Ev',
        houseEntrance: 'Giriş',
        houseFloor: 'Kat',
        houseApartment: 'Daire',
        location: 'Konum',
        marker: 'Yer',
        //location: 'Bölge',
        //marker: 'Şehir',
        answer: 'Cevap',
        rateLike: 'Bu inceleme Ticaret Kuruluşu tarafından beğenildi',
        comment: 'Yorum',
        comments: 'Yorumlar',
        cartComment: 'Sipariş yorumu',
        cartAddressComment: 'Adres yorumu',
        cartCode: 'Sipariş kodu',
        section: 'Bölüm',
        chapter: 'Kısım',
        category: 'Kategori',
        
        regDate: 'Kayıtlı',
        pubDate: 'Yayınlandı',
        activeDate: 'Şuraya kadar aktif',
        changeDate: 'Değiştirildi',
        rejectedDate: 'Reddedildi',
        confirmDate: 'Onaylandı',
        sentDate: 'Gönderildi',
        deliveredDate: 'Teslim edildi',
        
        opened: 'Açık',
        closed: 'Kapalı',
        opens: 'Açıklar',
        closes: 'Kapalılar',

        online: 'Çevrimiçi',
        offline: 'Çevrimdışı',

        workDay: 'İş Günü',
        notWorkDay: 'Kapalı',
        breakWorkDay: 'Duraklatma',
        workDays: 'Çalışma günleri',
        workTime: 'Çalışma saati',
        workStart: 'Başlangıç',
        workEnd: 'Bitiş',
        
        day1: 'Pazartesi',
        day2: 'Salı',
        day3: 'Çarşamba',
        day4: 'Perşembe',
        day5: 'Cuma',
        day6: 'Cumartesi',
        day7: 'Pazar',
        
        cartRank: 'Siparişten sıralama',
        rateRank: 'Yorumdan sıralama',
        rank: 'Sıralama',
        rank1: 'Başlangıç',
        rank2: 'Bronz',
        rank3: 'Gümüş',
        rank4: 'Altın',
        rank5: 'Platin',
        rank6: 'Elmas',
        rank7: 'Popüler',
        abonimentRank: 'Abonelik Sıralaması',
        lezzetCoin: 'Lezzet parası',
        lezzetCoinPrice: 'Lezzet parasının fiyatı',
        subscribe: 'Abone ol',
        unsubscribe: 'Aboneliği iptal et',

        invoice: 'Hesap',
        client: 'Müşteri',
        payments: 'Ödeme yöntemleri',
        payment1: 'Nakit',
        payment2: 'Kart ve terminal',
        payment3: 'Çevrimiçi',
        cash: 'Nakit',
        terminal: 'Kart ve terminal',

        delivery: 'Teslimat',
        lezzetDeliveryTitle: "Lezzet'Sebeti teslimatı",
        lezzetDelivery: "Lezzet'Sebeti teslimat hizmeti",
        storeDelivery: 'Ticari kuruluş teslimat hizmeti',
        deliveryType: 'Teslimat yöntemi',
        deliveryCountry1: 'Şehir içi, Şehir dışı ve Illere',
        deliveryCountry2: 'Şehir içi ve Şehir dışı',
        deliveryCountry3: 'Şehir içi',
        deliveryCountry4: 'Kendin gelip al',
        delivery1: 'Ticari kuruluştan',
        delivery2: "Lezzet'Sebeti-nden",
        delivery3: 'Kendim gelip alırım',
        inCity: 'Şehir içi',
        outCity: 'Şehir dışı',
        outRegion: 'İllere',
        price: 'Fiyat',
        totalPrice: 'Toplam fiyat',
        addedPrice: 'Katma değer',
        valute: 'TMT',
        summ: 'Ödenecek tutar',
        minCartPrice: 'Minimum sipariş fiyatı',
        
        size: 'Boyut',
        sizes: 'Boyutlar',
        
        onsale: 'Satılık',
        notOnsale: 'Satılık değil',
        notDelivery: 'Teslimat hizmeti yok',
        notSelected: 'İşaretlenmemiş',
        notSize: 'Boyut yok',
        notPrice: 'Fiyat yok',
        
        delivered: 'Siparişler',
        
        views: 'Görüntüle',
        rate: 'Derecelendirme',
        rates: 'Derecelendirmeler',
        rateUp: 'Derecelendir',
        yourRate: 'Derecelendirmeniz',
        deliveryRate: 'Teslimat hizmetine puan verin...',
        serviceRate: 'Hizmetine ve servizine puan verin...',
        tasteRate: 'Tadına ve kaliteyine puan verin...',
        viewStatus: 'Görünürlük durumu',
        period: 'Dönem',
        
        phoneVerifyTitle: 'Onay',
        phoneVerify: 'Telefon numarasını onaylayın',
        
        forgotPassword: 'Şifrenizi mi unuttunuz',
        forgotPasswordText1: 'E-posta adresinizi girin ve devam edin.',
        forgotPasswordText2: 'Tek kullanımlık onay şifresi (6 haneli), Ticari Kuruluşun ana telefon numarasına SMS ile gönderildi.',
        forgotPasswordText3: 'Tek kullanımlık onay şifresini girin ve onaylayın.',
        passwordRecovery: 'Şifre kurtarma',
        password: 'Şifre',
        currentPassword: 'Mevcut şifre',
        currentPasswordText: 'Mevcut şifrenizi girin',
        newPassword: 'Yeni şifre',
        newPasswordText: 'Yeni şifrenizi girin',
        passwordRepeat: 'Şifreyi tekrar girin',
        passwordRepeatErr: 'Tekrar girilen şifre eşleşmiyor',
        passwordUpd: 'Şifreyi değiştir',
        
        otpText1: 'Telefon numaranızı girin ve devam edin.',
        otpText2: 'Tek kullanımlık onay şifresi (6 haneli), telefon numaranıza SMS ile gönderildi.',
        otpText3: 'Tek kullanımlık onay şifresini girin ve devam edin.',
        sendOtpMessage: "Lezzet'Sebeti giriş için tek kullanımlık şifre",
        
        avatar: 'Avatar',
        passport: 'Pasaport',
        car: 'Araba',
        image: 'Fotoğraf',
        images: 'Fotoğraflar',
        mainImage: 'Ana fotoğraf',
        newImage: 'Yeni fotoğraf',
        imageI: 'Yüklenen dosya aşağıdakilere uygun olmalıdır: Format .jpeg, .jpg, .png, .gif ve Boyutu 5 megabayttan fazla olmamalıdır.',
        video: 'Video klip',
        poster: 'Poster fotoğrafı',
        newVideo: 'Yeni video klip',
        videoI: 'Yüklenen dosya aşağıdakilere uygun olmalıdır: Format .mp4 ve Boyutu 20 megabayttan fazla olmamalıdır.',
        excelI: 'Yüklenen dosya aşağıdakilere uygun olmalıdır: Format .xlsx, .xls.',
        
        cartCommentI: 'Siparişinizle ilgili bilgileri girin.',
        cartAddressCommentI: 'Teslimat hizmeti için Adresinizi kelimelerle açıklayın.',
        cartAdressNotFoundI: 'Teslimat hizmeti için Adresler bulunamadı.',

        trashAbonimentTitle: 'Aboneliği silme',
        trashAbonimentI: 'Aboneliği silme isteği anında gerçekleşir, bu istek Mağaza Abonelikleri dahil olmak üzere tüm Abonelik verilerini siler.',

        trashLocationTitle: 'İli silme',
        trashLocationI: 'İli silme isteği anında gerçekleşir, bu istek Şehirler dahil olmak üzere tüm İl verilerini siler.',

        trashMarkerTitle: 'Şehri silme',
        trashMarkerI: 'Şehri silme isteği anında gerçekleşir, bu istek Şehrin tüm verilerini siler.',

        trashCategoryTitle: 'Kategoriyi silme',
        trashCategoryI: 'Kategoriyi silme isteği anında gerçekleşir, bu istek Kategorinin tüm verilerini siler.',

        trashLezzetDeliveryTitle: 'Teslimat Hizmetini Silme',
        trashLezzetDeliveryI: 'Teslimat Hizmetini silme isteği anında gerçekleşir, bu istek Teslimat Hizmetinin tüm verilerini siler.',

        trashProfileTitle: 'Hesabı silme',
        trashProfileI: 'Hesabı silme isteği anında gerçekleşir, bu istek Oturumlar, Adresler, favori Mağazalar, Ürünler ve Yorumlar dahil olmak üzere tüm Hesap verilerini siler.',

        trashProfileDataTitle: 'Hesap Verilerini Silme',
        trashProfileDataI: 'Hesap Verilerini silme isteği anında gerçekleşir, bu istek Oturumlar, Adresler, favori Mağazalar, Ürünler ve Yorumlar dahil olmak üzere Hesapla ilgili tüm verileri siler.',

        trashAdressTitle: 'Adresi silme',
        trashAdressI: 'Adresi silme isteği anında gerçekleşir, bu istek Adresin tüm verilerini siler.',
        
        trashStoreTitle: 'Mağazayı Silme',
        trashStoreI: 'Mağazayı silme isteği anında gerçekleşir, bu istek Ürünler ve Yorumlar dahil olmak üzere tüm Mağaza verilerini siler.',
        
        trashRateTitle: 'Derecelendirmeyi Silme',
        trashRateI: 'Derecelendirmeyi silme isteği anında gerçekleşir, bu istek tüm Derecelendirme verilerini siler.',

        trashProductTitle: 'Ürünü Silme',
        trashProductI: 'Ürünü silme isteği anında gerçekleşir, bu istek tüm Ürün verilerini siler.',
        
        trashCartTitle: 'Sepeti Temizle',
        trashCartI: 'Sepette başka bir Mağazadan onaylanmamış bir ürün var. Yeni bir sipariş vermek için mevcut siparişi onaylayın veya sepeti temizleyin.',
        trashCartI2: 'Sepeti gerçekten temizlemek istiyor musunuz?',
        
        trashNewCartTitle: 'Siparişi Silme',
        trashNewCartI: 'Siparişi silme isteği anında gerçekleşir, bu istek tüm Sipariş verilerini siler.',
        
        notConfirmedCartPushTitle: 'Onaylanmamış sipariş',
        notConfirmedCartPushI: 'Sipariş numarası',

        newCartPushTitle: 'Yeni sipariş geldi',
        newCartPushI: 'Sipariş numarası',

        confirmCartTitle: 'Sipariş onayı',
        confirmCartI: 'Mevcut siparişi gerçekten onaylamak istiyor musunuz?',

        confirmCartPushTitle: 'Sipariş onaylandı',
        confirmCartPushI: 'Sipariş numarası',

        sentCartTitle: 'Sipariş gönderme',
        sentCartI: 'Mevcut siparişi alıcıya gerçekten göndermek istiyor musunuz?',

        sentCartPushTitle: 'Sipariş gönderildi',
        sentCartPushI: 'Sipariş numarası',

        deliveredCartTitle: 'Sipariş teslimatı',
        deliveredCartI: 'Mevcut siparişi alıcıya gerçekten teslim ettiniz mi?',

        courierCartPushTitle: 'Yeni sipariş atandı',
        courierCartPushI: 'Sipariş numarası',

        newCourierCartPushTitle: 'Kurye atandı',
        newCourierCartPushI: 'Sipariş numarası',

        rateCartStorePushI: 'Yorumunuzu bırakmayı unutmayın',

        rejectCartTitle: 'Sipariş reddi',
        rejectCartI: 'Mevcut siparişi gerçekten reddetmek istiyor musunuz?',

        rejectCartPushTitle: 'Sipariş reddedildi',
        rejectCartPushI: 'Sipariş numarası',

        trashServiceTitle: 'Hizmeti Silme',
        trashServiceI: 'Hizmeti silme isteği anında gerçekleşir, bu istek tüm Hizmet verilerini siler.',
        
        trashBannerTitle: 'Bannerı Silme',
        trashBannerI: 'Bannerı silme isteği anında gerçekleşir, bu istek tüm Banner verilerini siler.',
        
        trashAdsTitle: 'Reklamı Silme',
        trashAdsI: 'Reklamı silme isteği anında gerçekleşir, bu istek tüm Reklam verilerini siler.',

        navigations: 'Navigasyonlar',
        myNavigations: 'Navigasyonlarım',
        history: 'Görüntüleme geçmişi',
        myFavorites: 'Favoriler',
        myRatedStores: 'Oyladıklarım',
        favorites: 'Beğenilenler',
        topFavorites: 'En iyi favoriler',

        menu: 'Menü',
        back: 'Geri',
        select: 'Seç',
        choose: 'Seçin',
        chooseData: 'Verileri Seçin',
        show: 'Göster',
        hide: 'Gizle',
        all: 'Hepsi',
        send: 'Gönder',
        sendPhone: 'Telefon numarasını gönderin',
        add: 'Ekle',
        addCart: 'Sepete ekle',
        create: 'Oluştur',
        read: 'Oku',
        update: 'Güncelle',
        reset: 'Sıfırla',
        delete: 'Sil',
        recycle: 'Temizle',
        remove: 'Kaldır',
        change: 'Değiştir',
        confirm: 'Onayla',
        confirmPhone: 'Telefon numarasını onaylayın',
        block: 'Engelle',
        deliver: 'Teslim edildi',
        reject: 'Reddet',
        warning: 'Uyarı',
        info: 'Açıklama',
        about: 'Ayrıntılı',
        aboutInfo: 'Ayrıntılı bilgi',
        print: 'Yazdır',

        required: 'Zorunlu',
        min: 'Minimum',
        max: 'Maksimum',
        pattern: 'İzin verilen karakterler',
        numbers: 'sayılar',
        strings: 'dizeler',
        symbols: 'karakterler',

        distance: 'Mesafe',
        year: 'yıl',
        years: 'yıllar',
        day: 'gün',
        days: 'günler',
        hour: 'saat',
        hours: 'saatler',
        minut: 'dakika',
        minutes: 'dakikalar',
        second: 'dakikalar',
        seconds: 'saniyeler',
        kilometr: 'km',
        kilometros: 'km-ler',
        metr: 'metre',
        metros: 'metreler',

        powered: 'Açık',
        ok: 'Evet',
        not: 'Hayır',
        cancel: 'İptal',

        quantity: 'Toplam',
        count: 'Miktar',
        pcs: 'adet',
        from: 'itibaren',

        privilege: 'Ayrıcalık',
        privilege1: 'Süper',
        privilege2: 'Orta',
        privilege3: 'Normal',
        privilege4: 'Düşük',

        error: 'Hata',
        error1: 'Hata: İstenen yol bulunamadı',
        error2: 'Yetersiz veri gönderildi',
        error3: 'Gönderilen veriler yanlış',
        error4: 'Format veya boyut uyuşmazlığı',
        error5: 'İstek reddedildi',
        error6: 'Bu Konumda Teslimat Hizmeti mevcut',

        error100: 'Hesap bulunamadı',
        error101: 'Hesap onaylanmadı',
        error102: 'Hesap engellendi',
        error103: 'Hesap durum hatası',
        error104: 'Yetkili değilsiniz',
        error105: 'Yetkili Hesap mevcut',
        error106: 'Ayrıcalıklarınız belirtilenlere uymuyor',
        error107: 'Bu Girişle Hesap bulunamadı',
        error108: 'Bu Girişle Hesap mevcut',
        error109: 'Bu telefon numarasıyla Hesap bulunamadı',
        error110: 'Bu telefon numarasıyla Hesap mevcut',
        error111: 'Bu E-posta adresiyle Hesap bulunamadı',
        error112: 'Bu E-posta adresiyle Hesap mevcut',
        error113: 'Yanlış şifre',
        error114: 'Süresi dolmuş token',
        error115: 'Yanlış token',
        error116: 'Oturum bulunamadı',
        error117: 'Geçerli Oturum silinemiyor',
        error118: 'Tek kullanımlık şifre bulunamadı',
        error119: 'Bu İsim, Konum ve Telefon Numarasıyla Hesap mevcut',
        error120: 'Konum erişim izni devre dışı bırakıldı.',
        error121: 'Konum belirlenemedi. Konum servis sağlayıcınızın açık olduğundan emin olun.',
        error122: 'Push bildirimleri izni devre dışı bırakıldı.',
        error123: 'Push token alınamadı. Lütfen fiziksel bir cihaz kullanın.',
        error124: 'Bu telefon numarası zaten ana telefon numarası olarak kullanılıyor.',
        error125: 'Bu telefon numarası şu anda ana telefon numarası olarak kullanılıyor.',
        error126: 'Bu telefon numarası zaten ek telefon numarası olarak kullanılıyor.',
        error127: 'Bu telefon numarası şu anda ek telefon numarası olarak kullanılıyor.',

        error200: 'Mağaza bulunamadı',
        error201: 'Mağaza onaylanmadı',
        error202: 'Mağaza engellendi',
        error203: 'Mağaza durum hatası',
        error204: 'Bu İsim, Konum, Kategori ve E-posta adresiyle Mağaza mevcut',
        error205: 'Mağaza kapalı',
        error206: 'Mağaza çalışma günü bekleniyor',
        error207: 'Mağaza çalışma saati bekleniyor',
        error208: 'Teslimat hizmeti sınırlı',
        error209: 'Teslimat hizmeti yok',
        error210: 'Mağazanın mevcut Aboneliği var',
        error211: 'Mağazanın mevcut Aboneliği yok',
        error212: 'Bu E-posta adresiyle Mağaza var',

        error300: 'Ürün bulunamadı',
        error301: 'Ürün onaylanmadı',
        error302: 'Ürün engellendi',
        error303: 'Ürün durum hatası',
        error304: 'Bu İsim ve Kategoriyle Ürün mevcut',

        error400: 'Hizmet bulunamadı',
        error401: 'Hizmet onaylanmadı',
        error402: 'Hizmet engellendi',
        error403: 'Hizmet durum hatası',
        error404: 'Bu İsim, Konum ve Kategoriyle Hizmet mevcut',

        error500: 'Sipariş bulunamadı',
        error501: 'Sipariş onaylanmadı',
        error502: 'Sipariş engellendi',
        error503: 'Sipariş durum hatası',
        error504: 'Yanlış adres veya adres teslimat hizmeti sınırları içinde değil',
        error505: 'Bu Sipariş için henüz bir Kurye atanmadı',

        error600: 'Banner bulunamadı',
        error601: 'Banner onaylanmadı',
        error602: 'Banner engellendi',
        error603: 'Banner durum hatası',

        error700: 'Reklam bulunamadı',
        error701: 'Reklam onaylanmadı',
        error702: 'Reklam engellendi',
        error703: 'Reklam durum hatası',

        error800: 'Bu İsimle Konum mevcut',
        error801: 'Bu İsimle Yer mevcut',
        error802: 'Bu İsimle Bölüm mevcut',
        error803: 'Bu İsimle Kısım mevcut',
        error804: 'Bu İsimle Kategori mevcut',
        error805: 'Bu İsimle Beceri mevcut',

        error900: 'Derecelendirme bulunamadı',
        error904: 'Derecelendirme kabul edilmedi',

        error1000: 'Abonelik bulunamadı',
        error1004: 'Bu parametrelerle aktif Abonelik mevcut',

        success: 'Başarı',
        success100: 'Başarılı',
        success101: 'Başarıyla giriş yaptınız',
        success102: 'Başarıyla kaydoldunuz',
        success103: 'Hoşça kal',
        success104: 'Başarıyla oluşturuldu',
        success105: 'Başarıyla eklendi',
        success106: 'Başarıyla güncellendi',
        success107: 'Başarıyla değiştirildi',
        success108: 'Başarıyla onaylandı',
        success109: 'Başarıyla silindi',
        success110: 'Siparişiniz başarıyla alındı. Siparişinizi onaylamak için Operatör Sizi arayacak',
        success111: 'Başarıyla gönderildi',
        
        viewStatus1: 'Aktif',
        viewStatus2: 'Yeni',
        viewStatus3: 'Değiş-di',
        viewStatus4: 'Engel-di',
        viewStatus5: 'Onaylandı',
        viewStatus6: 'Gönderildi',
        viewStatus7: 'Teslim edildi',
        viewStatus9: 'Reddedildi',
        
        status: 'Durum',
        status1: 'Aktif',
        status2: 'Onay bekleniyor',
        status3: 'Değişiklikler kontrol ediliyor',
        status4: 'Engellendi',
        status5: 'Onaylandı',
        status6: 'Gönderildi',
        status7: 'Teslim edildi',
        status9: 'Reddedildi',
        status10: 'Bulunamadı',
        
        panelStatus1: 'Aktif',
        panelStatus2: 'Yeniler',
        panelStatus3: 'Değiştirildi',
        panelStatus4: 'Engellendi',
        panelStatus5: 'Onaylandı',
        panelStatus6: 'Gönderildi',
        panelStatus7: 'Teslim edildi',
        panelStatus9: 'Reddedildi',

        appDescription1: "Lezzet'Sebeti – платформа онлайн покупок.",
        appDescription2: "Мы собираемся приблизить мечту каждого человека в реальность.",
        appDescription3: "Наша цель добавить свой вклад на то чтобы мир стал еще лучше и удобней.",
        appSupport: "Если у вас возникли другиe вопросы, пишите на наш E-mail адрес.",
        copyright: "Все Авторские права защищены 2024 год.",

        appAboutUs: "Про нас:",
        appAboutUs1: "1. Цель Lezzet'Sebeti предоставить возможности, повышения маркетинга всем физическим или юридическим лицам, занимающиеся сферой торговли. А так же лицам в поисках своих нужд находить свои потребности быстро и эффективно.",
        appAboutUs2: "2. В наши дополнительные услуги входят:",
        appAboutUsServices: "Реклама баннер, постраничная реклама: реклама Вашего Торгового Заведения, товаров и размещение других похожих реклам.",
        appAboutUsQuestionsAndAnswers: "Ответы на вопросы:",
        appAboutUsQuestion1: "1. Что представляет Lezzet'Sebeti?",
        appAboutUsAnswer1: "Lezzet'Sebeti предоставляет возможности, повышения маркетинга всем физическим или юридическим лицам, занимающиеся сферой торговли. А так же лицам в поисках своих нужд находить свои потребности быстро и эффективно.",
        appAboutUsQuestion2: "2. Я могу разместить свое Торговое Заведение на Lezzet'Sebeti?",
        appAboutUsAnswer2: "Да, если Вы занимаетесь сферой торговли, Вы можете разместить свое Торговое Заведение без каких либо трудностей. Для этого свяжитесь с Администратором.",
        appAboutUsQuestion3: "3. Регистрация на Lezzet'Sebeti объязательная?",
        appAboutUsAnswer3: "Нет, не объязательная. Но, после регистрации на Lezzet'Sebeti, появятся больше возможностей как, совершать заказы, давать рейтинг балы, оставлять отзывы, добавлять понравившиеся Торговые Заведения или товары в историю мои избранные и другиe дальнейшие действия.",
        
        termsOfUseTitle: "Каждый человек, кто получает доступ к этому сайту, программе и использует его в настоящее время, свидетельствует о том, что  соглашается с настоящими Условиями Использования.",

        termsOfUseUsers: "Пользователям:",
        termsOfUseUsers1: "1. Lezzet'Sebeti представляет возможности Пользователям, находить товары под свои нужды и потребности.",
        termsOfUseUsers2: "2. Lezzet'Sebeti не несёт ответственность за Пользователя и за его выбор. Наша цель, предоставить Пользователю возможность находить нужную ему потребность в объявлениях товаров от Торговых Заведений.",
        termsOfUseUsers3: "3. Lezzet'Sebeti не несёт ответственность за оплату или предоплату товаров, а так же за гарантию качества и за цену товара. Не оплачивайте товар пока не получите и не осмотрите лично. Всё что вы делаете и совершаете на Lezzet'Sebeti, делаете на свой риск и страх.",
        termsOfUseUsers4: "4. Прежде чем, совершать заказ от Торговых Заведений, прочитайте отзывы оставленные со стороны других Пользователей и сравните рейтинг.",
        termsOfUseUsers5: "5. Пользователи имеют возможность добавлять понравившиеся Торговые Заведения или товары в историю мои избранные, а также давать Рейтинг балы и оставлять отзывы Торговым Заведениям, после совершения заказа.",
        termsOfUseUsers6: "6. Перечень правил для отзывов:",
        termsOfUseUsersComment1: "• Отзыв не должен содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство, мат.",
        termsOfUseUsersComment2: "• Отзыв не должен содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.",
        termsOfUseUsers7: "7. При нарушении приведенных правил Администратор имеет право удалить и заблокировать Пользователя без объяснения и причин.",
        termsOfUseUsers8: "8. Пользователь несёт полную ответственность за свои любые действия и совершания на Lezzet'Sebeti.",
        termsOfUseUsers9: "9. Lezzet'Sebeti не вмешивается и не состоит в договоре между Пользователями и Торговыми Заведениями.",
        termsOfUseUsers10: "10. Lezzet'Sebeti не вмешивается и не состоит в купле-продаже между Пользователями и Торговыми Заведениями.",

        termsOfUseStores: "Торговым Заведениям:",
        termsOfUseStores1: "1. Lezzet'Sebeti представляет услуги и возможности Торговым Заведениям, предложить и продавать свои товары и услуги онлайн.",
        termsOfUseStores2: "2. Lezzet'Sebeti не несёт ответственность за Торговое Заведение, его действиям и за его объявлений. Наша цель, предоставить Торговому Заведению возможность предложить и продавать свои товары и услуги онлайн.",
        termsOfUseStores3: "3. Lezzet'Sebeti не несёт ответственность за не уплату заказа (кроме случаев: если доставка осуществляется со стороны Lezzet'Sebeti и онлайн оплаты), Всё что вы делаете и совершаете на Lezzet'Sebeti, делаете на свой риск и страх.",
        termsOfUseStores4: "4. Lezzet'Sebeti имеет право удалять и заблокировать объявления товаров или услуг без объяснения и причин, также если товар или услуга не соответствует правилам Lezzet'Sebeti. Все объявления проверяются Администраторами Lezzet'Sebeti.",
        termsOfUseStores5: "5. Перечень правил для объявлений:",
        termsOfUseStoresAnnouncement1: "• Объявление не должно содержать товары или услуги не соответствующие законодательству Туркменистана.",
        termsOfUseStoresAnnouncement2: "• Объявление не должно содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство,  мат.",
        termsOfUseStoresAnnouncement3: "• Объявление не должно содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.",
        termsOfUseStoresAnnouncement4: "• Объявление не должно содержать фотографии психического или религиозного внушения, а также запрещается фотографии насилия, издевательство или нецензурного характера.", 
        termsOfUseStoresAnnouncement5: "• Торговое Заведение не имеет право добавить объявления товара или услуги без описания и фотографии.", 
        termsOfUseStoresAnnouncement6: "• Торговое Заведение не имеет право добавить объявления товаров или услуг не являющийся его собственностью.", 
        termsOfUseStores6: "6. Торговые Заведения имеют возможность оставлять ответы на отзывы, оставленные Пользователями.",
        termsOfUseStores7: "7. Перечень правил для ответов:",
        termsOfUseStoresComment1: "• Ответ не должен содержать слова психического или религиозного внушения, а так же запрещается нецензурные слова насилия, издевательство или ругательство, мат.",
        termsOfUseStoresComment2: "• Ответ не должен содержать ссылки на материалы психического или религиозного внушения, а так же запрещается ссылки на материалы как насилия, издевательство или нецензурного характера.", 
        termsOfUseStores8: "8. Администраторы Lezzet'Sebeti имеют право удалять и заблокировать Торговое Заведение и его Правообладателя без объяснения и причин.", 
        termsOfUseStores9: "9. Торговое Заведение и его Правообладатель несёт полную ответственность за свои любые действия и совершения на Lezzet'Sebeti.",
        termsOfUseStores10: "10. Lezzet'Sebeti не вмешивается и не состоит в договоре между Пользователями и Торговыми Заведениями.",
        termsOfUseStores11: "11. Lezzet'Sebeti не вмешивается и не состоит в купле-продаже между Пользователями и Торговыми Заведениями.",

        privacyPolicyTitle: "Каждый человек, кто получает доступ к этому сайту или программе и использует его в настоящее время, свидетельствует о том, что соглашается с настоящим Политикой Конфиденциальности.",

        privacyPolicyDataUsers: "Пользователям:",
        privacyPolicyDatasUsersScroll: "Перечень действий, с Персональными данными Пользователя:",
        privacyPolicyDatasUsers: "На Lezzet'Sebeti собираются следующие Персональные данные: Зарегистрированные номера телефонов, имя (настоящее или присвоенное, рандомное), адреса, отзывы и информация о заказах Пользователей.",
        privacyPolicyDataUsersPhone: "Зарегистрированный номер телефона Пользователя:",
        privacyPolicyDataUsersPhone1: "1. Зарегистрированным номером телефона Пользователя является: Введенный номер телефона Пользователем при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone2: "2. После того, как Пользователь зарегистрировался на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone3: "3. Зарегистрированный номер телефона на Lezzet'Sebeti, служит для подтверждения личности, для связи с Пользователем и для подтверждения заказа, а также для идентифицирования Пользователя на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersPhone4: "4. Зарегистрированный номер телефона Пользователя, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersName: "Имя Пользователя:",
        privacyPolicyDataUsersName1: "1. Имя Пользователя является: Введенный имя Пользователем или рандомное имя присвоенное после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersName2: "2. После того, как Пользователь изменил имя, его имя сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersName3: "3. Имя, служит для подтверждения личности и для подтверждения заказа.",
        privacyPolicyDataUsersName4: "4. Имя Пользователя, не указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress: "Адрес Пользователя:",
        privacyPolicyDataUsersAddress1: "1. Адресом Пользователя является: Добавленный адрес Пользователем на Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress2: "2. После того, как Пользователь добавил адрес, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersAddress3: "3. Адрес, служит для доставки заказа в пункт назначения.",
        privacyPolicyDataUsersAddress4: "4. Адрес Пользователя, указывается в обязательном порядке, при совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersRate: "Отзыв Пользователя:",
        privacyPolicyDataUsersRate1: "1. Отзывом Пользователя является: Добавленный отзыв Торговому Заведению Пользователем, после совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersRate2: "2. После того, как Пользователь добавил отзыв, его отзыв сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersRate3: "3. Отзыв, служит для получения информации о качестве доставки, обслуживания сервиза и впечатление от товаров.",
        privacyPolicyDataUsersRate4: "4. Отзыв Пользователя, не указывается в обязательном порядке, после совершения заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersCart: "Информация о заказах Пользователя:",
        privacyPolicyDataUsersCart1: "1. Информацией о заказах Пользователя является: Совершенные заказы Пользователем от Торговых Заведений на Lezzet'Sebeti.",
        privacyPolicyDataUsersCart2: "2. После того, как Пользователь совершил заказ, его заказ сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе со стороны Торгового Заведения и Курьера, где был совершен заказ.",
        privacyPolicyDataUsersCart4: "4. Информация о заказе Пользователя, указывается в обязательном порядке, при совершении заказа на Lezzet'Sebeti.",
        privacyPolicyDataUsersShopping: "Перечень действий от заказа до, его получения:",
        privacyPolicyDataUsersShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataUsersShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataUsersShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataUsersShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataUsersEncryptTitle: "Все полученные или переданные Персональные данные Пользователя на сервере Lezzet'Sebeti, совершаются через шифрование данных.",

        privacyPolicyDataStores: "Торговым Заведениям:",
        privacyPolicyDatasStoresScroll: "Перечень действий, с Персональными данными Торгового Заведения:",
        privacyPolicyDatasStores: "На Lezzet'Sebeti собираются следующие Персональные данные: Название, медиафайлы, номера телефонов, E-mail адрес, рабочие дни, информация по доставке, информация о спобах оплаты, адрес, информация о товарах и услугах, и информация о заказах Торгового Заведения.",
        privacyPolicyDataStoresTitle: "Название Торгового Заведения:",
        privacyPolicyDataStoresTitle1: "1. Название Торгового Заведения является: Введенное Название, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle2: "2. После того, как Торговое Заведение зарегистрировался на Lezzet'Sebeti, его Название сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle3: "3. Название, служит для подтверждения объекта как Торговое Заведение и для продолжения своей деятельности на Lezzet'Sebeti.",
        privacyPolicyDataStoresTitle4: "4. Название Торгового Заведения, указывается в обязательном порядке при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia: "Медиафайлы Торгового Заведения:",
        privacyPolicyDataStoresMedia1: "1. Медиафайлами Торгового Заведения является: Видео или фото файлы, загруженные Торговым Заведением, на сервер Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia2: "2. После того, как Торговое Заведение загруружает медиафайл на Lezzet'Sebeti, его медиафайл сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia3: "3. Медиафайлы, служат для визуального подтверждения информации об объекте Торговое Заведение и для визуального подтверждения информации о товарах и услугах Торгового Заведения на Lezzet'Sebeti.",
        privacyPolicyDataStoresMedia4: "4. Медиафайлы Торгового Заведения, указываются в обязательном порядке после регистрации, а также после добавления товаров и услуг на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone: "Номера телефонов Торгового Заведения:",
        privacyPolicyDataStoresPhone1: "1. Номера телефонов Торгового Заведения являются: Введенный основной номер телефона Торгового Заведения, при регистрации на Lezzet'Sebeti, а также добавленный позже дополнительный номер телефона Торгового Заведения после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone2: "2. После того, как Торговое Заведение зарегистрировался с основным номером телефона или добавил позже дополнительный номер телефона на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone3: "3. Основной или дополнительный номера телефонов на Lezzet'Sebeti, служат для связи с Торговым Заведением, а также для подтверждения заказов на Lezzet'Sebeti.",
        privacyPolicyDataStoresPhone4: "4. Основной номер телефона Торгового Заведения, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail: "E-mail адрес Торгового Заведения:",
        privacyPolicyDataStoresEmail1: "1. E-mail адрес Торгового Заведения является: Введенный E-mail адрес Торгового Заведения, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail2: "2. После того, как Торговое Заведение зарегистрировался на Lezzet'Sebeti, его E-mail адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail3: "3. E-mail адрес на Lezzet'Sebeti, служит для связи с Торговым Заведением, а также для идентифицирования Торгового Заведения на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresEmail4: "4. E-mail адрес Торгового Заведения, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays: "Рабочие дни Торгового Заведения:",
        privacyPolicyDataStoresWorkDays1: "1. Рабочие дни Торгового Заведения является: Указанные рабочие дни Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays2: "2. После того, как Торговое Заведение указал рабочие дни на Lezzet'Sebeti, его рабочие дни сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays3: "3. Рабочие дни, служат для получения информации Торгового Заведения о статусе работает или не работает на Lezzet'Sebeti.",
        privacyPolicyDataStoresWorkDays4: "4. Рабочие дни Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery: "Информация по доставке Торгового Заведения:",
        privacyPolicyDataStoresDelivery1: "1. Информация по доставке Торгового Заведения является: Указанные методы и способы по доставке Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery2: "2. После того, как Торговое Заведение указал методы и способы по доставке на Lezzet'Sebeti, его методы и способы по доставке сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery3: "3. Информация по доставке, служит для получения информации Торгового Заведения о методах и способах по доставке на Lezzet'Sebeti.",
        privacyPolicyDataStoresDelivery4: "4. Информация по доставке Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment: "Информация о спобах оплаты Торгового Заведения:",
        privacyPolicyDataStoresPayment1: "1. Информация о спобах оплаты Торгового Заведения является: Указанные способы оплаты Торгового Заведения, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment2: "2. После того, как Торговое Заведение указал способы оплаты на Lezzet'Sebeti, его способы оплат сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment3: "3. Информация о спобах оплаты, служит для получения информации Торгового Заведения о способах оплаты на Lezzet'Sebeti.",
        privacyPolicyDataStoresPayment4: "4. Информация о спобах оплаты Торгового Заведения, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress: "Адрес Торгового Заведения:",
        privacyPolicyDataStoresAddress1: "1. Адрес Торгового Заведения является: Введенный адрес Торгового Заведения, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress2: "2. После того, как Торговое зарегистрировался на Lezzet'Sebeti, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress3: "3. Адрес, служит для получения информации о местоположении Торгового Заведения на Lezzet'Sebeti.",
        privacyPolicyDataStoresAddress4: "4. Адрес Торгового Заведения, указывается в обязательном порядке при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct: "Информация о товарах и услугах Торгового Заведения:",
        privacyPolicyDataStoresProduct1: "1. Информация о товарах и услугах Торгового Заведения является: Введенная информация Торговым Заведением, при добавление каждого товара или услуги на Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct2: "2. После того, как Торговое Заведение добавил информацию о товаре или услуге на Lezzet'Sebeti, его информация о товаре или услуге сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct3: "3. Информация о товарах и услугах, служат для получения информации о товарах и услугах Торгового Заведения, а также для идентифицирования каждого отдельного товара или услуги на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresProduct4: "4. Информация о товарах и услугах Торгового Заведения, указывается в обязательном порядке, при добавление каждого товара или услуги на Lezzet'Sebeti.",
        privacyPolicyDataStoresCart: "Информация о заказах Торгового Заведения:",
        privacyPolicyDataStoresCart1: "1. Информацией о заказах Торгового Заведения является: Совершенные заказы Пользователем от Торгового Заведения, на Lezzet'Sebeti.",
        privacyPolicyDataStoresCart2: "2. После того, как Торговое Заведение получил, принял, отправил или доставил заказ от Пользователя, статус заказа меняется на новый, подтвержденный, отправлено или доставлено на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе.",
        privacyPolicyDataStoresCart4: "4. Информация о заказе Торгового Заведения, сохраняется в обязательном порядке, после совершении заказа на Lezzet'Sebeti.",
        privacyPolicyDataStoresShopping: "Перечень действий от заказа, до его получения:",
        privacyPolicyDataStoresShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataStoresShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataStoresShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataStoresShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataStoresEncryptTitle: "Все полученные или переданные Персональные данные Торгового Заведения на сервере Lezzet'Sebeti, совершаются через шифрование данных.",

        privacyPolicyDataCouriers: "Курьерам:",
        privacyPolicyDatasCouriersScroll: "Перечень действий, с Персональными данными Курьера:",
        privacyPolicyDatasCouriers: "На Lezzet'Sebeti собираются следующие Персональные данные: Имя (настоящее или присвоенное, рандомное), номера телефона, адреса, фотографии (личное, транспорта и пасспорта) и информация о заказах Курьеров.",
        privacyPolicyDataCouriersName: "Имя Курьера:",
        privacyPolicyDataCouriersName1: "1. Имя Курьера является: Введенный имя Курьером или рандомное имя присвоенное после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersName2: "2. После того, как Курьер изменил имя, его имя сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersName3: "3. Имя, служит для подтверждения личности и для подтверждения заказа, а также для идентифицирования Курьера, как сотрудник на Lezzet'Sebeti.",
        privacyPolicyDataCouriersName4: "4. Имя Курьера, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone: "Номер телефона Курьера:",
        privacyPolicyDataCouriersPhone1: "1. Номер телефона Курьера является: Введенный номер телефона Курьера при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone2: "2. После того, как Курьер зарегистрировался на Lezzet'Sebeti, его номер телефона сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone3: "3. Номер телефона на Lezzet'Sebeti, служит для подтверждения личности, для связи с Курьером и для подтверждения заказа, а также для идентифицирования Курьера на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhone4: "4. Номер телефона Курьера, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress: "Адрес Курьера:",
        privacyPolicyDataCouriersAddress1: "1. Адресом Курьера является: Введенный адрес Курьера при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress2: "2. После того, как Курьер зарегистрировался на Lezzet'Sebeti, его адрес сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersAddress3: "3. Адрес, служит для получения информации о место проживания Курьера, а также для получения заказов по место проживанию.",
        privacyPolicyDataCouriersAddress4: "4. Адрес Курьера, указывается в обязательном порядке, при регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto: "Фотографии Курьера:",
        privacyPolicyDataCouriersPhoto1: "1. Фотографии Курьера являются: Фото файлы, загруженные Курьером, на сервер Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto2: "2. После того, как Курьер загруружает фото файл на Lezzet'Sebeti, его фото файл сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto3: "3. Фотографии, служат для визуального подтверждения информации о Курьере и для визуального подтверждения информации о транспорте Курьера, а также для идентифицирования Курьера, как сотрудник на Lezzet'Sebeti.",
        privacyPolicyDataCouriersPhoto4: "4. Фотографии Курьера, указывается в обязательном порядке, после регистрации на Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart: "Информация о заказах Курьера:",
        privacyPolicyDataCouriersCart1: "1. Информацией о заказах Курьера является: Порученные заказы от Lezzet'Sebeti к Курьеру, для доставки заказов в пункт назначения на Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart2: "2. После того, как к Курьеру был поручен заказ, его заказ сохраняется на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersCart3: "3. Информация о заказе, служит для получения информации о приобретенных товарах, услугах и для получения информации адреса доставки, а также для получения информации о Пользователе.",
        privacyPolicyDataCouriersCart4: "4. Информация о заказе Курьера, указывается в обязательном порядке, при поручении заказа на Lezzet'Sebeti.",
        privacyPolicyDataCouriersShopping: "Перечень действий от заказа, до его получения:",
        privacyPolicyDataCouriersShopping1: "1. После того, как Пользователь совершил заказ на Lezzet'Sebeti, его данные и данные заказа сохраняются на сервере Lezzet'Sebeti.",
        privacyPolicyDataCouriersShopping2: "2. Совершенный заказ и данные Пользователя на сервере Lezzet'Sebeti, автоматический передаются в Торговое Заведение, где был совершен заказ.",
        privacyPolicyDataCouriersShopping3: "3. Совершенный заказ и данные Пользователя, подтверждается звонком на зарегистрированный номер Пользователя, со стороны Оператора Торгового Заведения.",
        privacyPolicyDataCouriersShopping4: "4. Совершенный заказ, доставляется в пункт назначения Курьером от Торгового Заведения или Курьером от Lezzet'Sebeti.",
        privacyPolicyDataCouriersEncryptTitle: "Все полученные или переданные Персональные данные Курьера на сервере Lezzet'Sebeti, совершаются через шифрование данных."
    }
}